module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter-title",
    attrs: {
      "id": "ch-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('strong', [_vm._v("A. Religious Speech in Public Schools and Universities")])])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "FirstPara"
  }, [_vm._v("The most intense battles over religious speech have occurred in public schools. Public schools are the most sensitive site for government-sponsored speech; parents do not want their children converted to another faith in a public school. They do not want anyone, whether school employee or fellow student, to make the attempt. Public schools that absorbed and accepted the message of the Establishment Clause—that the school is not to teach the truth claims of any religion—often overreacted and tried to make the school a religion-free zone.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Battles over religious free speech in public schools are fought on multiple and overlapping fronts. Four sources of legal rules figure prominently in this Section.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("First is the Establishment Clause; maybe religious speech is constitutionally prohibited in public schools. The Supreme Court has repeatedly rejected this argument.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Second is the law of limited public forums under the Free Speech Clause. Schools can exclude subject matters from their forums, but not viewpoints. The Supreme Court has generally held that religion is a source of viewpoints and not merely an excludable subject matter. This has generally protected religious speech from discriminatory regulation, but there are limits and loopholes.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Third, what if schools suppress student speech in a nondiscriminatory way, closing off opportunities for student speech on any topic, religious or secular? The fight against that sort of rule has mostly been about the meaning of a seminal Supreme Court case, "), _c('em', [_vm._v("Tinker v. Des Moines Independent Community School District")]), _vm._v(" (1969). I read "), _c('em', [_vm._v("Tinker")]), _vm._v(" as protecting students’ right to speak; school officials and many lower federal courts would confine it to viewpoint discrimination, leaving schools free to suppress all student speech evenhandedly.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("Finally, Congress provided strong statutory protection in the Equal Access Act, which protects the right of student organizations to meet in public secondary ")]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("schools. The principal beneficiaries have been evangelical Christian groups and gay rights clubs. It is no coincidence that these two beneficiaries are on opposite sides of the culture wars. Free speech is for everybody; schools often try to stamp out whatever is controversial.")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('h1', {
    staticClass: "sec3b"
  }, [_c('strong', [_vm._v("The Scholarly …")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_c('em', [_vm._v("Equal Access and Moments of Silence")]), _vm._v(" (1986) is a major article on distinguishing private religious speech from government-sponsored religious speech. It explores the Equal Access Act in depth, and it offers the first, conclusory formulation of what would become my theory of substantive neutrality.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('em', [_vm._v("High-Value Speech and the Basic Educational Mission of a Public School")]), _vm._v(" (2008) reacts to an argument, pressed but not resolved in the Supreme Court, that a public school can suppress any speech it deems inconsistent with its “basic educational mission.” Of course that would lead to rampant censorship.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3b"
  }, [_c('strong', [_vm._v("the Amicus Briefs …")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_c('em', [_vm._v("Board of Education v. Mergens")]), _vm._v(" (1990) was the Supreme Court’s encounter with the Equal Access Act. This amicus brief argues that the Act creates a bright-line test to ensure its application and that judicial deference to the discretion of school officials would strip the meaning from the statute. It also argues, more briefly, that the Act is constitutional.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Amicus brief in "), _c('em', [_vm._v("Rosenberger v. Rector and Visitors of University of Virginia")]), _vm._v(" (1995) argues that if the University funds student publications, it cannot discriminate against student religious publications.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('em', [_vm._v("Good News Club v. Milford")]), _vm._v(" (2001) presented the equal access issue in an elementary school, and under the Free Speech Clause rather than the statute. The brief argues that if the school allows the Boy Scouts, Girl Scouts, and 4-H Club to meet, then it must also allow the Good News Club to meet. The Good News Club is an evangelical religious organization.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In "), _c('em', [_vm._v("Morse v. Frederick")]), _vm._v(" (2007), a high school student was suspended for displaying a banner that said “BONG HiTS 4 JESUS.” The brief argues that this speech could be punished if the Court interpreted it as advocating drug use, but that the school could not suppress any speech that threatened its “basic educational mission.” The 2008 article listed above is a broader and deeper exploration of the issue.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("In "), _c('em', [_vm._v("Christian Legal Society v. Martinez")]), _vm._v(" (2010), a public law school excluded a student religious organization because it required a statement of faith for voting membership. The brief argues that this was a simple question of freedom of association; religious organizations cannot exist without religious criteria for membership.")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('h1', {
    staticClass: "sec3b"
  }, [_c('strong', [_vm._v("… and the Short")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_c('em', [_vm._v("The Students Won!")]), _vm._v(" (1990) is a brief explanation of "), _c('em', [_vm._v("Board of Education v. Mergens")]), _vm._v(" (above) written for an audience of Christian lawyers.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('em', [_vm._v("Letter to Vanderbilt University")]), _vm._v(" (2011) attempts to persuade Vanderbilt not to exclude from campus every religious organization with a statement of faith.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3b"
  }, [_c('strong', [_vm._v("Cross References")])])]), _c('p', {
    staticClass: "HPara"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("Briefs, articles, and legislative testimony about religious speech with government sponsorship are in ")]), _c('a', {
    attrs: {
      "href": "#/#PT1.1.5.2"
    }
  }, [_vm._v("Section II. A")]), _vm._v(" of this volume and in overview articles cross-referenced there.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The brief in "), _c('em', [_vm._v("Rosenberger")]), _vm._v(" is here because the case presented a free speech issue. But it also presented a funding issue, and my other writings on funding religious institutions are in "), _c('span', {
    attrs: {
      "href": "#/013_Part02#pt-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Section II. B")]), _vm._v(" of this volume and in overview articles cross-referenced there.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2-br",
    attrs: {
      "id": "sec2-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("Equal Access and Moments of Silence: The Equal Status of Religious Speech by Private Speakers")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('h1', {
    staticClass: "sec3-a",
    attrs: {
      "id": "sec3-1"
    }
  }, [_c('em', [_vm._v("81 Northwestern University Law Review 1 (1986)")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara1"
  }, [_c('em', [_vm._v("In")]), _vm._v(" Widmar v. Vincent "), _c('em', [_vm._v("(1981), the Supreme Court upheld the right of student religious organizations to meet on college campuses. But the lower courts generally refused to apply that holding to high schools, and this at a time when constitutional protection for student free speech was considerably stronger than it became later. Religious groups were special, and subject to exclusion.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_c('em', [_vm._v("Congress responded in 1984 with the Equal Access Act. An early version that protected only religious organizations was denounced as “Son of School Prayer” and clearly could not be passed. A second version that protected all student organizations still drew opposition, but a delicately negotiated bill eventually passed by wide margins. Unfortunately, too many people made too many demands on those negotiations, and the text of the enacted bill was a mess. It didn’t always say what the drafters had intended to say. And whatever it said, critics and school boards immediately claimed that it was unconstitutional.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_c('em', [_vm._v("This article was part of a symposium on")]), _vm._v(" Associational Freedom and Private Discrimination"), _c('em', [_vm._v("—a title that anticipated many later debates—at the Northwestern University Law School. The article defends the constitutionality of the Equal Access Act, and it is foundational to all my later work on religious free speech and establishment of religion.")])])]), _c('p', {
    staticClass: "Body1"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('em', [_vm._v("The article rests on a fundamental distinction between private speech about religion, which is constitutionally protected, and government-sponsored speech taking a position on a religious question, which is constitutionally restricted. This article argues that protection for student religion clubs in public schools is consistent with")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('em', [_vm._v("the most rigorous understanding of the principle that government should not endorse religion. And it argues that opponents of equal access and advocates of school prayer were acting on the identical fallacy—were mirror images of each other. This article contains my first short and conclusory formulation of what I would later develop as the principle of substantive neutrality.")])])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "Body1"
  }, [_c('em', [_vm._v("This piece also carefully explores the Equal Access Act and its legislative history, trying to show how it could be construed to achieve its purpose of protecting student organizations despite the difficulties presented by the text. The final section argues that a properly implemented moment of silence would be constitutional in public schools, but that moments of silence are bad policy and difficult to properly implement.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_c('em', [_vm._v("This article compares and contrasts statutory protection under the Equal Access Act with constitutional protection under the Free Speech Clause. It sets forth a view of")]), _vm._v(" Tinker v. Des Moines Independent Community School District "), _c('em', [_vm._v("(1969), the foundational case on student free speech, as protecting the right of students to speak while they are in a place where they have a right to be. More recently, many lower courts have limited")]), _vm._v(" Tinker "), _c('em', [_vm._v("to simply a rule about viewpoint discrimination, and the Supreme Court has generally declined to review these decisions. The meaning and continued viability of")]), _vm._v(" Tinker "), _c('em', [_vm._v("is a recurring theme in the materials that follow.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_c('em', [_vm._v("The parts of this article addressing the Equal Access Act have held up well. The parts addressing")]), _vm._v(" Tinker "), _c('em', [_vm._v("and the Free Speech Clause have had a rougher time in the courts, but as of early 2018, the Supreme Court has not yet repudiated them.")])])]), _c('p', {
    staticClass: "HPara"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("The role of religion in the public schools is one of the most controversial issues of our time. Historically, the public schools openly taught Protestant Christianity, and many opened the day with prayers, Bible readings, or both.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-1",
      "id": "fn1_1"
    }
  }, [_c('sup', [_vm._v("1")])]), _vm._v(" In "), _c('em', [_vm._v("Engel v. Vitale")]), _c('a', {
    attrs: {
      "href": "#/#fn1-2",
      "id": "fn1_2"
    }
  }, [_c('sup', [_vm._v("2")])]), _vm._v(" and "), _c('em', [_vm._v("Abington School District v. Schempp")]), _vm._v(","), _c('a', {
    attrs: {
      "href": "#/#fn1-3",
      "id": "fn1_3"
    }
  }, [_c('sup', [_vm._v("3")])]), _vm._v(" the Supreme Court held these practices unconstitutional. "), _c('em', [_vm._v("Engel")]), _vm._v(" and "), _c('em', [_vm._v("Schempp")]), _vm._v(" triggered a new round in this long-running debate. A quarter century later, the debate is as intense as ever.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Opponents of the Supreme Court’s school prayer decisions have proceeded at two levels. They have denied the legitimacy of the school prayer decisions and the underlying premise that government must be neutral toward religion. "), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("I hope eventually to defend the requirement of strict government neutrality against the recurring claim that the Establishment Clause")]), _c('a', {
    attrs: {
      "href": "#/#fn1-4",
      "id": "fn1_4"
    }
  }, [_c('sup', [_vm._v("4")])]), _vm._v(" permits nonpreferential support for religion. But that must await a subsequent article."), _c('a', {
    attrs: {
      "href": "#/#fn1-5",
      "id": "fn1_5"
    }
  }, [_c('sup', [_vm._v("5")])]), _vm._v(" This Article will assume that the Supreme Court was right when it said that the Constitution requires the government to be neutral toward religion."), _c('a', {
    attrs: {
      "href": "#/#fn1-6",
      "id": "fn1_6"
    }
  }, [_c('sup', [_vm._v("6")])]), _vm._v(" This Article is about the meaning of “neutrality.”")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The meaning of “neutrality” is central to understanding the second level of response to the school prayer decisions. The Supreme Court’s opponents have sought to encourage or accommodate prayer in public schools in ways that they argued were consistent with neutrality. Their idea has been to attenuate the link between the state and the prayer; they want teachers to encourage students to pray in ways that make it possible to deny that they have done so. Many of these legislative efforts have been clumsy and transparent, and the courts have properly struck them down."), _c('a', {
    attrs: {
      "href": "#/#fn1-7",
      "id": "fn1_7"
    }
  }, [_c('sup', [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("This aspect of the school prayer controversy has come to focus on two more sophisticated statutory proposals: the federal Equal Access Act")]), _c('a', {
    attrs: {
      "href": "#/#fn1-8",
      "id": "fn1_8"
    }
  }, [_c('sup', [_vm._v("8")])]), _vm._v(" and state moment-of-silence laws."), _c('a', {
    attrs: {
      "href": "#/#fn1-9",
      "id": "fn1_9"
    }
  }, [_c('sup', [_vm._v("9")])]), _vm._v(" Many supporters of government neutrality toward religion have opposed these statutes, and courts also have been hostile. Undoubtedly such statutes can be implemented in unconstitutional ways. But much of the opposition to these statutes has been misplaced. I will argue that the Constitution "), _c('em', [_vm._v("permits")]), _vm._v(" a properly implemented moment of silence and that it "), _c('em', [_vm._v("requires")]), _vm._v(" a right of equal access for religious speech.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In taking these positions, I do not argue that the Establishment Clause permits even a little bit of government support for religion. Properly implemented equal access and moment-of-silence laws are strictly neutral toward religion. Defining neutrality in all the varied interactions between church and state is a major task for Religion Clause scholarship. I do not mean neutrality in the sense of a ban on religious classifications."), _c('a', {
    attrs: {
      "href": "#/#fn1-10",
      "id": "fn1_10"
    }
  }, [_c('sup', [_vm._v("10")])]), _vm._v(" Instead, I mean neutrality in the sense of government conduct that insofar as possible neither encourages nor discourages religious belief or practice. This requires identification of a base line from which to measure encouragement and discouragement. To do that as a general matter is a difficult task beyond the scope of this Article. But in the area of speech, the neutral course seems clear. The government must be neutral both in its own speech and in its treatment of private speech."), _c('a', {
    attrs: {
      "href": "#/#fn1-11",
      "id": "fn1_11"
    }
  }, [_c('sup', [_vm._v("11")])]), _vm._v(" It may not take a position on questions of religion in its own speech, and it must treat religious speech by private speakers exactly like secular speech by private speakers."), _c('a', {
    attrs: {
      "href": "#/#fn1-12",
      "id": "fn1_12"
    }
  }, [_c('sup', [_vm._v("12")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec4b"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('strong', [_vm._v("I. The Statutes at Issue")])])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('h1', {
    staticClass: "sec5bi"
  }, [_c('strong', [_c('em', [_vm._v("A. The Equal Access Act")])])])]), _c('p', {
    staticClass: "HPara"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("The Equal Access Act addresses the rights of student religious groups that seek to meet on school premises before or after school. Typically, such groups want to engage in group prayer, Bible study, or religious discussion. They seek to use school facilities on exactly the same terms as the chess club, the Junior Engineers, or any other student extracurricular group. In the case of religious groups, constitutional questions are minimized if the group is initiated by students and limited to students, and if it neither seeks nor accepts sponsorship from the school or a teacher.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-13",
      "id": "fn1_13"
    }
  }, [_c('sup', [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("A case with clear but not unusual facts is "), _c('em', [_vm._v("Bender v. Williamsport Area School District")]), _vm._v(","), _c('a', {
    attrs: {
      "href": "#/#fn1-14",
      "id": "fn1_14"
    }
  }, [_c('sup', [_vm._v("14")])]), _vm._v(" which the Supreme Court recently decided on standing grounds. The Williamsport schools had a student activity period open to any "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("student club that contributed to the “intellectual, physical or social development of the students.”")]), _c('a', {
    attrs: {
      "href": "#/#fn1-15",
      "id": "fn1_15"
    }
  }, [_c('sup', [_vm._v("15")])]), _vm._v(" Students could start their own clubs and meet during the activity period. Only one club had ever been denied permission to meet."), _c('a', {
    attrs: {
      "href": "#/#fn1-16",
      "id": "fn1_16"
    }
  }, [_c('sup', [_vm._v("16")])]), _vm._v(" That was Petros, a student group devoted to prayer and other religious activities. Members of Petros sued the school district, alleging violations of the Free Speech"), _c('a', {
    attrs: {
      "href": "#/#fn1-17",
      "id": "fn1_17"
    }
  }, [_c('sup', [_vm._v("17")])]), _vm._v(" and Free Exercise of Religion"), _c('a', {
    attrs: {
      "href": "#/#fn1-18",
      "id": "fn1_18"
    }
  }, [_c('sup', [_vm._v("18")])]), _vm._v(" Clauses of the Constitution. Schools that have allowed such groups to meet also have been sued by parents or taxpayers alleging violations of the Establishment Clause."), _c('a', {
    attrs: {
      "href": "#/#fn1-19",
      "id": "fn1_19"
    }
  }, [_c('sup', [_vm._v("19")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("These conflicting claims illustrate two of the three basic positions in the controversy over student religious groups:")]), _vm._v(" "), _c('p', {
    staticClass: "NListSb1"
  }, [_vm._v("(1)"), _c('span', {
    staticClass: "pad"
  }, [_vm._v("The Free Speech or Free Exercise Clause requires schools to treat religious groups just as they treat other groups;")])]), _vm._v(" "), _c('p', {
    staticClass: "NList1"
  }, [_vm._v("(2)"), _c('span', {
    staticClass: "pad"
  }, [_vm._v("The Establishment Clause requires schools to forbid religious groups from meeting on campus, even if other groups are allowed to meet; and")])]), _vm._v(" "), _c('p', {
    staticClass: "NList1"
  }, [_vm._v("(3)"), _c('span', {
    staticClass: "pad"
  }, [_vm._v("None of these clauses controls, and the political branches can decide whether to allow religious groups to meet on campus.")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("Universities are subject to the first rule; the Supreme Court has held that universities cannot discriminate against student religious groups."), _c('a', {
    attrs: {
      "href": "#/#fn1-20",
      "id": "fn1_20"
    }
  }, [_c('sup', [_vm._v("20")])]), _vm._v(" One court of appeals has implied that high schools are subject to either the first or third rule, although it decided that the record before it required affirmance of a preliminary injunction against letting a religious group meet."), _c('a', {
    attrs: {
      "href": "#/#fn1-21",
      "id": "fn1_21"
    }
  }, [_c('sup', [_vm._v("21")])]), _vm._v(" But two courts of appeals have held,"), _c('a', {
    attrs: {
      "href": "#/#fn1-22",
      "id": "fn1_22"
    }
  }, [_c('sup', [_vm._v("22")])]), _vm._v(" and "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("another has strongly suggested,")]), _c('a', {
    attrs: {
      "href": "#/#fn1-23",
      "id": "fn1_23"
    }
  }, [_c('sup', [_vm._v("23")])]), _vm._v(" that high schools are subject to the second rule. These courts of appeals have feared that students would infer school endorsement of prayer groups from the mere presence of such groups on school premises.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In 1984, Congress attempted to settle the debate with the Equal Access Act."), _c('a', {
    attrs: {
      "href": "#/#fn1-24",
      "id": "fn1_24"
    }
  }, [_c('sup', [_vm._v("24")])]), _vm._v(" The Act is not a model of drafting, but its intent is to require high schools to treat student religious groups equally with other extracurricular groups. It thus attempts to overrule the three court of appeals decisions barring religious meetings in high schools. District courts are split over the constitutionality of the Act."), _c('a', {
    attrs: {
      "href": "#/#fn1-25",
      "id": "fn1_25"
    }
  }, [_c('sup', [_vm._v("25")])]), _vm._v(" The Act is valid under either the first or third rules above, but invalid under the second. The Act’s very existence may influence the answer; the Supreme Court will give more deference to an act of Congress than to a policy of a local school board."), _c('a', {
    attrs: {
      "href": "#/#fn1-26",
      "id": "fn1_26"
    }
  }, [_c('sup', [_vm._v("26")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec5bi"
  }, [_c('strong', [_c('em', [_vm._v("B. Moment-of-Silence Laws")])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("Moment-of-silence laws are like the Equal Access Act in two ways. First, their political origin is in resistance to the Supreme Court’s ban on school-sponsored prayer. Second, their constitutionality turns on the distinction between government and private speech.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Moment-of-silence laws come in many varieties. What they have in common is that they require teachers to ask students to observe a moment of silence. Students so inclined may use the moment of silence to pray; others may use it to meditate, daydream, plot mischief, or ogle their favorite classmate.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Parents and teachers might well be astonished to learn that it is unconstitutional to tell school children to be quiet for a minute. Yet several courts have so held."), _c('a', {
    attrs: {
      "href": "#/#fn1-27",
      "id": "fn1_27"
    }
  }, [_c('sup', [_vm._v("27")])]), _vm._v(" Distinguished commentators have been more sympathetic, "), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("generally in passing references.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-28",
      "id": "fn1_28"
    }
  }, [_c('sup', [_vm._v("28")])]), _vm._v(" Unfortunately, the facts of the litigated cases indicate that many legislatures and teachers have used these moments of silence to officially encourage prayer. The Alabama moment-of-silence law invalidated in "), _c('em', [_vm._v("Wallace v. Jaffree")]), _c('a', {
    attrs: {
      "href": "#/#fn1-29",
      "id": "fn1_29"
    }
  }, [_c('sup', [_vm._v("29")])]), _vm._v(" is a good example. It is easy to invalidate moment-of-silence laws that are misused in this way. The more interesting question is whether moment-of-silence laws written in wholly neutral and secular terms are facially invalid without any showing of improper implementation. I think that they are not.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec4b",
    attrs: {
      "id": "PT1.1.5.2"
    }
  }, [_c('strong', [_vm._v("II. A Note on Underlying Assumptions")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("There is a logical difficulty in exploring the meaning of neutrality in a particular case without first establishing that neutrality is required as a general principle. Fortunately, in this case the logical difficulty is not a practical one. It is generally the religious right that demands government support for religion and denies that the Establishment Clause requires neutrality. By “religious right,” I mean to include politically active groups and individuals with generally conservative views on social issues and with generally evangelical or fundamentalist Christian views on religious issues, and the political allies "), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("of such groups.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-30",
      "id": "fn1_30"
    }
  }, [_c('sup', [_vm._v("30")])]), _vm._v(" The religious right will happily accept my support of equal access and moments of silence.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Opposition to these laws comes from a subset of separationists. I use the term “separationists” even though I think separation of church and state is a misleading metaphor."), _c('a', {
    attrs: {
      "href": "#/#fn1-31",
      "id": "fn1_31"
    }
  }, [_c('sup', [_vm._v("31")])]), _vm._v(" “Separationists” is less awkward than “disestablishmentarians,” and it accurately describes those disestablishmentarians who reason from the separation metaphor. Separationists are of two quite different schools, as Professor Esbeck recently has shown."), _c('a', {
    attrs: {
      "href": "#/#fn1-32",
      "id": "fn1_32"
    }
  }, [_c('sup', [_vm._v("32")])]), _vm._v(" A subgroup that Esbeck calls “secularists” accounts for most of the opposition to equal access laws. The “secularists” tend to think that the need for disestablishment takes precedence over free speech and free exercise rights in substantially all cases of conflict. They occupy the opposite end of the Establishment Clause spectrum from the religious right; it is only fair to call them the secular left.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The secular left includes some groups and individuals who are themselves religious; most notably, Jewish groups have tended to ally themselves with the secular left on Establishment Clause issues. I certainly do not mean to imply that all secularists are personally hostile to religion. Undoubtedly some are, and more are hostile to the fundamentalist and evangelical religions that demand government endorsement. But no separationist openly claims that the Constitution requires the government to share his hostility. Separationists who oppose equal access and moments of silence do so in the name of neutrality. Thus, the people I must persuade traditionally have accepted my premise that the Religion Clauses require the government to be neutral toward religion.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("With respect to government speech, my understanding of neutrality is as rigorous as that of the most orthodox secularist. In my view, the Establishment Clause absolutely disables the government from taking a position for or against religion. The government must treat every religious view with equal respect. “Agnostic” is the label that comes closest to describing the attitude required of the government, but that label is also misleading in an important way. An agnostic has no opinion on whether God exists, and neither should the government. But an agnostic also believes that humans are incapable of knowing whether God exists. If the government believed that, it would prefer agnostics "), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("over theists and atheists. Agnostics have no opinion for epistemological reasons; the government must have no opinion for constitutional reasons. The government must have no opinion because it is not the government’s role to have an opinion.")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("This principle explains the Supreme Court’s holdings that teachers cannot lead")]), _c('a', {
    attrs: {
      "href": "#/#fn1-33",
      "id": "fn1_33"
    }
  }, [_c('sup', [_vm._v("33")])]), _vm._v(" or encourage"), _c('a', {
    attrs: {
      "href": "#/#fn1-34",
      "id": "fn1_34"
    }
  }, [_c('sup', [_vm._v("34")])]), _vm._v(" prayer in public schools, or post the Ten Commandments on the bulletin board."), _c('a', {
    attrs: {
      "href": "#/#fn1-35",
      "id": "fn1_35"
    }
  }, [_c('sup', [_vm._v("35")])]), _vm._v(" The Court should have applied the same principle to its other cases. It should not have held that chaplains can open each meeting of a state legislature with prayer,"), _c('a', {
    attrs: {
      "href": "#/#fn1-36",
      "id": "fn1_36"
    }
  }, [_c('sup', [_vm._v("36")])]), _vm._v(" or that municipalities can erect Christmas displays."), _c('a', {
    attrs: {
      "href": "#/#fn1-37",
      "id": "fn1_37"
    }
  }, [_c('sup', [_vm._v("37")])]), _vm._v(" These decisions are wholly unprincipled and indefensible. A little bit of government support for religion may be only a little bit of establishment, but it is still an establishment. The government should not put “In God We Trust” on coins; it should not open court sessions with “God save the United States and this honorable Court”; and it should not name a city or a naval vessel for the Body of Christ"), _c('a', {
    attrs: {
      "href": "#/#fn1-38",
      "id": "fn1_38"
    }
  }, [_c('sup', [_vm._v("38")])]), _vm._v(" or the Queen of the Angels."), _c('a', {
    attrs: {
      "href": "#/#fn1-39",
      "id": "fn1_39"
    }
  }, [_c('sup', [_vm._v("39")])]), _vm._v(" Perhaps religious minorities "), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("should not waste political capital on minor violations such as these. But neither should the Supreme Court legitimate such violations.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-40",
      "id": "fn1_40"
    }
  }, [_c('sup', [_vm._v("40")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("I mention these views to make clear that my support for the Equal Access Act and my tolerance for properly conducted moments of silence do not stem from any view that the religious right’s desire for government support should be modestly indulged. The reason to allow equal access or moments of silence is not that they are acceptably small deviations from neutrality. Rather, they are strictly neutral.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The counterargument is that allowing religious speech on public property, and especially in schools, is a form of government support for religion. Separationists who reason from that starting point wind up actively discriminating against religious speech by excluding it from public fora. Most of them would not take this position with respect to speech on any other subject. But with respect to religious speech, they have been led into error by their fear of establishment and by their fear that the supporters of school prayer will so abuse any concessions that neutrality will never be properly implemented. Some separationists also have been led into error by hostility to the set of political and religious views that they associate with the supporters of school prayer.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The resulting attacks on equal access mistakenly have focused on the location of the speech. That religious speech occurs on public property is incidental and almost entirely irrelevant. Government speech in support of religion is forbidden even if it occurs on private property;"), _c('a', {
    attrs: {
      "href": "#/#fn1-41",
      "id": "fn1_41"
    }
  }, [_c('sup', [_vm._v("41")])]), _vm._v(" private speech in support of religion is protected even if it occurs on public property. What matters is not the location of the speech, but the identity of the speaker."), _c('a', {
    attrs: {
      "href": "#/#fn1-42",
      "id": "fn1_42"
    }
  }, [_c('sup', [_vm._v("42")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It is relevant that the speech occurs in a public school, as distinguished from other public property. But again, there is no magic transformation arising simply from the location of the speech. The school environment is relevant because of the risk that the school may make private speech its own by "), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("endorsing or sponsoring it. The central problem is to separate the students’ religious speech from the school’s religious speech, protecting the former and forbidding the latter.")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('h1', {
    staticClass: "sec4b"
  }, [_c('strong', [_vm._v("III. The Argument over Equal Access")])]), _vm._v(" "), _c('h1', {
    staticClass: "sec5bi"
  }, [_c('strong', [_c('em', [_vm._v("A. The Affirmative Argument:")]), _vm._v(" Widmar v. Vincent")])])]), _c('p', {
    staticClass: "HPara"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("The basic argument for equal access has been made repeatedly.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-43",
      "id": "fn1_43"
    }
  }, [_c('sup', [_vm._v("43")])]), _vm._v(" It is set out most prominently in "), _c('em', [_vm._v("Widmar v. Vincent")]), _vm._v("."), _c('a', {
    attrs: {
      "href": "#/#fn1-44",
      "id": "fn1_44"
    }
  }, [_c('sup', [_vm._v("44")])]), _vm._v(" Cornerstone, an interdenominational group of evangelical Christian students, was one of over one hundred registered student organizations at the University of Missouri at Kansas City. Like all other student organizations, it met in vacant classrooms and at the student center. After Cornerstone had been meeting for four years, the university decided that the group was violating a regulation that barred “religious worship or religious teaching” in the university’s buildings and on its grounds. The university barred Cornerstone from campus, and Cornerstone sued under the Free Speech and Free Exercise Clauses. The district court upheld the university’s rule and dismissed the lawsuit."), _c('a', {
    attrs: {
      "href": "#/#fn1-45",
      "id": "fn1_45"
    }
  }, [_c('sup', [_vm._v("45")])]), _vm._v(" The Eighth Circuit reversed,"), _c('a', {
    attrs: {
      "href": "#/#fn1-46",
      "id": "fn1_46"
    }
  }, [_c('sup', [_vm._v("46")])]), _vm._v(" and the Supreme Court affirmed the Eighth Circuit.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Supreme Court’s opinion is short and simple, reasoning from basic principles. Regulation of speech must be content neutral. When the government creates a forum for speech, it cannot pick and choose who can speak or what they can talk about. If students are free to discuss sex, politics, and philosophy, they must be free to discuss religion. The university let Students for a Democratic Society and the Young Socialist Alliance use university facilities."), _c('a', {
    attrs: {
      "href": "#/#fn1-47",
      "id": "fn1_47"
    }
  }, [_c('sup', [_vm._v("47")])]), _vm._v(" It would have let those facilities be used for discussions of agnosticism, Marxism, and other doctrines hostile to religion."), _c('a', {
    attrs: {
      "href": "#/#fn1-48",
      "id": "fn1_48"
    }
  }, [_c('sup', [_vm._v("48")])]), _vm._v(" There was no doubt that students and faculty enjoyed an open forum in university facilities. The exclusion of religion could not be justified by any policy of neutrality, strict or otherwise. Justice Stevens noted in his concurrence that the university could control its own curriculum, and that a shortage of meeting rooms would require it to "), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("choose among voluntary student groups.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-49",
      "id": "fn1_49"
    }
  }, [_c('sup', [_vm._v("49")])]), _vm._v(" But neither of those legitimate concerns had any relevance to the facts of "), _c('em', [_vm._v("Widmar")]), _vm._v(". Rather, the university openly discriminated against religious speech. The Supreme Court therefore invalidated the regulation, citing its cases on content neutrality"), _c('a', {
    attrs: {
      "href": "#/#fn1-50",
      "id": "fn1_50"
    }
  }, [_c('sup', [_vm._v("50")])]), _vm._v(" and public fora."), _c('a', {
    attrs: {
      "href": "#/#fn1-51",
      "id": "fn1_51"
    }
  }, [_c('sup', [_vm._v("51")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The decision seems so self-evident that it is hard to elaborate on the Court’s arguments. Whether one starts with the principle that the Free Speech Clause requires content-neutral regulation of speech, or with the principle that the Religion Clauses require strict neutrality toward religion,"), _c('a', {
    attrs: {
      "href": "#/#fn1-52",
      "id": "fn1_52"
    }
  }, [_c('sup', [_vm._v("52")])]), _vm._v(" one arrives immediately at the result in "), _c('em', [_vm._v("Widmar")]), _vm._v(". Critics have argued that some of the Court’s sweeping statements about the requirement of content neutrality are overbroad,"), _c('a', {
    attrs: {
      "href": "#/#fn1-53",
      "id": "fn1_53"
    }
  }, [_c('sup', [_vm._v("53")])]), _vm._v(" but they have not suggested that the state can suppress a whole category of constitutionally important speech without a substantive reason. There was nothing novel in the Court’s reasoning or in the application of that reasoning to religious speech.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Justice White’s dissent in "), _c('em', [_vm._v("Widmar")]), _vm._v(" argued that religious speech is constitutionally different from all other speech because the Constitution itself distinguishes religious speech from other speech."), _c('a', {
    attrs: {
      "href": "#/#fn1-54",
      "id": "fn1_54"
    }
  }, [_c('sup', [_vm._v("54")])]), _vm._v(" He cited the school prayer "), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("cases.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-55",
      "id": "fn1_55"
    }
  }, [_c('sup', [_vm._v("55")])]), _vm._v(" But this reasoning wholly ignores the difference between government speech and voluntary private speech. That the government cannot express religious opinions does not mean that it can censor religious expression by private speakers. Under the neutrality principle, the government can neither express religious views of its own nor interfere with the expression of religious views by others. The Court had always given religious speech the same constitutional protections as other speech. Indeed, many of the most basic principles of free speech were developed in the Jehovah’s Witness cases."), _c('a', {
    attrs: {
      "href": "#/#fn1-56",
      "id": "fn1_56"
    }
  }, [_c('sup', [_vm._v("56")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Court never had suggested that it mattered whether private religious speech was on public or private property. A series of cases in the 1940s and 1950s upheld the right of Jehovah’s Witnesses to hold services or meetings in public parks."), _c('a', {
    attrs: {
      "href": "#/#fn1-57",
      "id": "fn1_57"
    }
  }, [_c('sup', [_vm._v("57")])]), _vm._v(" The Court treated these cases as ordinary public forum cases. In one of the cases, the state argued that allowing a religious service in a public park would violate the Establishment Clause."), _c('a', {
    attrs: {
      "href": "#/#fn1-58",
      "id": "fn1_58"
    }
  }, [_c('sup', [_vm._v("58")])]), _vm._v(" The issue was fully briefed but not properly presented by the facts."), _c('a', {
    attrs: {
      "href": "#/#fn1-59",
      "id": "fn1_59"
    }
  }, [_c('sup', [_vm._v("59")])]), _vm._v(" Although the Establishment Clause issue was not squarely decided, the Court’s apparent assumption in all these cases was that religious groups were entitled to use public fora on the same terms "), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("as anyone else. This tacit assumption in the Supreme Court became holding in the courts of appeals: cases in the late 1970s allowed papal masses in public parks.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-60",
      "id": "fn1_60"
    }
  }, [_c('sup', [_vm._v("60")])]), _vm._v(" White’s dissent in "), _c('em', [_vm._v("Widmar")]), _vm._v(" conceded that “the right of the religious to nondiscriminatory access to the public forum is well established.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-61",
      "id": "fn1_61"
    }
  }, [_c('sup', [_vm._v("61")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Supreme Court’s most explicit equation of secular and religious speech on public property had come one year before "), _c('em', [_vm._v("Widmar")]), _vm._v(", in "), _c('em', [_vm._v("Heffron v. International Society for Krishna Consciousness, Inc")]), _vm._v("."), _c('a', {
    attrs: {
      "href": "#/#fn1-62",
      "id": "fn1_62"
    }
  }, [_c('sup', [_vm._v("62")])]), _vm._v(" The Hare Krishnas challenged a rule that required persons wishing to solicit or distribute literature at the Minnesota State Fair to remain in fixed booths."), _c('a', {
    attrs: {
      "href": "#/#fn1-63",
      "id": "fn1_63"
    }
  }, [_c('sup', [_vm._v("63")])]), _vm._v(" The Court upheld the rule as a reasonable response to the number of solicitors and the congestion on the fairgrounds. The Court rejected the Hare Krishnas’ claim that they were entitled to special dispensation because their solicitation was a religious duty. Applying ordinary public forum principles, the Court concluded that all noncommercial solicitors were entitled to equal treatment."), _c('a', {
    attrs: {
      "href": "#/#fn1-64",
      "id": "fn1_64"
    }
  }, [_c('sup', [_vm._v("64")])]), _vm._v(" If the rule were struck down for the Hare Krishnas, it would have to be struck down for everyone. This premise was central to the Court’s assessment of the reasonableness of the rule."), _c('a', {
    attrs: {
      "href": "#/#fn1-65",
      "id": "fn1_65"
    }
  }, [_c('sup', [_vm._v("65")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("On their facts, none of the earlier Supreme Court cases squarely controlled "), _c('em', [_vm._v("Widmar")]), _vm._v(". "), _c('em', [_vm._v("Heffron")]), _vm._v(" rejected a claim that religious speech is more protected than other noncommercial speech; the case did not present a claim that religious speech is "), _c('em', [_vm._v("less")]), _vm._v(" protected. There could be some difference between a public forum "), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("in a park or fairgrounds and a public forum in a university or high school. But the stated principle of all these cases was content neutrality, and "), _c('em', [_vm._v("Widmar")]), _vm._v(" fell squarely within that principle. That the speech was religious made an a fortiori case. Like political speech, religious speech is at the core of the constitutional right to free expression. It is singled out for special constitutional protection in the Free Exercise Clause. The Religion Clause principle of neutrality toward religion reinforces the Speech Clause principle of content neutrality toward speech. One is tempted to think that there was no case squarely on point because no one ever before had thought the state could discriminate against religious speech. The case for equal access depends less on elaboration of these basic principles than on responding to claims that an exception should be created.")])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("In commenting on this Article, Dean Stone notes that evenhanded suppression of all religious and antireligious speech is a form of neutrality and that a less compelling justification is required to ban all discussion of a subject matter than to ban expression of only some viewpoints on a subject matter.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-66",
      "id": "fn1_66"
    }
  }, [_c('sup', [_vm._v("66")])]), _vm._v(" He and I agree that it would be far worse for a school to permit a Christian prayer group while forbidding a Jewish prayer group, or to permit an atheist club while forbidding a prayer club. But suppression of speech is not desirable or constitutional merely because it can be characterized as evenhanded."), _c('a', {
    attrs: {
      "href": "#/#fn1-67",
      "id": "fn1_67"
    }
  }, [_c('sup', [_vm._v("67")])]), _vm._v(" Nor is it evenhanded to suppress all speech on a particular subject matter. A subject-matter ban, though less egregious than a ban against particular viewpoints, is still a content-based restriction on speech."), _c('a', {
    attrs: {
      "href": "#/#fn1-68",
      "id": "fn1_68"
    }
  }, [_c('sup', [_vm._v("68")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("With respect to the government’s own speech, taking no position on religion is the most neutral practice. But with respect to private speech, protecting religious and antireligious speech equally with secular speech is far more neutral than singling out religious and antireligious speech for special treatment. No one would suggest that the government was complying with the First Amendment, or being neutral toward religion, if it uniformly suppressed all religious and antireligious organizations. The argument for such suppression among public school students must turn on some overriding consideration, not on a claim that the suppression is evenhanded. Especially when the subject is "), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("religion or politics, with their special First Amendment status, even “neutral” subject-matter bans should require extraordinary justification. To say that religious or political speech can be suppressed in a forum where secular and apolitical speech is protected is to turn the First Amendment on its head.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-69",
      "id": "fn1_69"
    }
  }, [_c('sup', [_vm._v("69")])]), _vm._v(" I turn now to the alleged justifications for suppression.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec5bi"
  }, [_c('strong', [_c('em', [_vm._v("B. The Central Issue: Apparent Endorsement")])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("The argument most often pressed against the Equal Access Act is that allowing religious speech in high schools is an actual or apparent endorsement of religion."), _c('a', {
    attrs: {
      "href": "#/#fn1-70",
      "id": "fn1_70"
    }
  }, [_c('sup', [_vm._v("70")])]), _vm._v(" The claim of actual endorsement is absurd. Perhaps in a totalitarian state the government implicitly endorses all that it does not censor. But no such inference can be drawn in a nation with a constitutional guarantee of free speech. Indeed, the core case for First Amendment protection is speech critical of the government. No governmental unit can interfere with such speech, but it obviously does not follow that the government endorses the critical message. Similarly, the public forum may include Young Democrats and Young Republicans, Socialists and Libertarians, pro-Khomeini refugees and anti-Khomeini refugees, fundamentalists and agnostics. The government obviously does not endorse all these wildly inconsistent positions. Before "), _c('em', [_vm._v("Widmar")]), _vm._v(", my own university censored rallies by the Longhorn Christian Fellowship but allowed Students for Freedom from Religion to hold a “Phooey on Falwell” rally."), _c('a', {
    attrs: {
      "href": "#/#fn1-71",
      "id": "fn1_71"
    }
  }, [_c('sup', [_vm._v("71")])]), _vm._v(" No one could ever explain why this was neutral, or why tolerating the one group would be an endorsement if tolerating the other group was not.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Whether the speech is on public or private property is wholly irrelevant if the state lacks power to censor. It is almost a given that a public forum will be "), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("on public property; very few exist on private property.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-72",
      "id": "fn1_72"
    }
  }, [_c('sup', [_vm._v("72")])]), _vm._v(" Because the state lacks power to exclude views from a public forum on public property, there can be no reasonable inference that it endorses speech in such a forum.")]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_c('strong', [_vm._v("1. The Capacity of High School Students.")]), _vm._v("—Since "), _c('em', [_vm._v("Widmar")]), _vm._v(", the argument has been that even if there is no government endorsement, there will be an improper appearance of endorsement, especially if religious speech is allowed in public high schools. It is said that college students may understand the neutrality of an open public forum but that high school students are too young and impressionable. The argument is most fully developed in Judge Garth’s opinion in "), _c('em', [_vm._v("Bender v. Williamsport Area School District")]), _vm._v("."), _c('a', {
    attrs: {
      "href": "#/#fn1-73",
      "id": "fn1_73"
    }
  }, [_c('sup', [_vm._v("73")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The argument is wrong, both factually and legally. The proposition that government cannot censor speech, and therefore that it does not endorse everything it fails to censor, is not complicated. High school students can understand the proposition if it is explained to them. That is all they need to understand to avoid a mistaken inference of endorsement. Despite Judge Garth’s overblown rhetoric, students do not have to understand all “the subtleties and intricacies of the first amendment about which judges and legislators themselves find reason to pause.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-74",
      "id": "fn1_74"
    }
  }, [_c('sup', [_vm._v("74")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The proposition that government does not endorse everything it fails to censor is fundamental to our system of government. Grade schools and high schools should teach the values of free expression and open public fora by precept and example."), _c('a', {
    attrs: {
      "href": "#/#fn1-75",
      "id": "fn1_75"
    }
  }, [_c('sup', [_vm._v("75")])]), _vm._v(" Certainly junior high school civics courses should cover free speech. Many students never go on to college, but they too can be good citizens who understand the basic political values of our society."), _c('a', {
    attrs: {
      "href": "#/#fn1-76",
      "id": "fn1_76"
    }
  }, [_c('sup', [_vm._v("76")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("To the extent that high school students’ ability to understand is an empirical question, we could commission a team of developmental psychologists to do a sample survey.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-77",
      "id": "fn1_77"
    }
  }, [_c('sup', [_vm._v("77")])]), _vm._v(" But the question is only partly empirical. The constitutional commitment to open public fora should not be lightly undermined because of fears that the audience will misunderstand."), _c('a', {
    attrs: {
      "href": "#/#fn1-78",
      "id": "fn1_78"
    }
  }, [_c('sup', [_vm._v("78")])]), _vm._v(" At the very least, a heavy burden of persuasion rests on those who would exclude some views for fear that they mistakenly will be attributed to the state. In the equal access cases, there has been no evidence of the level of high school student understanding and no evidence that the schools tried to explain open fora to the students. The courts simply have assumed that high school students cannot understand.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In closely related contexts, the courts have made the opposite assumption, holding that high school students are not too young or impressionable to be allowed free speech rights. The leading case is "), _c('em', [_vm._v("Tinker v. Des Moines Independent Community School District")]), _vm._v("."), _c('a', {
    attrs: {
      "href": "#/#fn1-79",
      "id": "fn1_79"
    }
  }, [_c('sup', [_vm._v("79")])]), _vm._v(" The plaintiffs in "), _c('em', [_vm._v("Tinker")]), _vm._v(" were two high school students and a thirteen-year-old junior high school student. They were suspended from school for wearing black armbands to protest the war in Vietnam."), _c('a', {
    attrs: {
      "href": "#/#fn1-80",
      "id": "fn1_80"
    }
  }, [_c('sup', [_vm._v("80")])]), _vm._v(" School officials thought the schools were an inappropriate place for protest, and they feared that the resulting controversy would distract students from their schoolwork."), _c('a', {
    attrs: {
      "href": "#/#fn1-81",
      "id": "fn1_81"
    }
  }, [_c('sup', [_vm._v("81")])]), _vm._v(" In an apocalyptic dissent, Justice Black noted that the armbands had indeed been controversial among the students and suggested that the officials’ fears had been borne out by events."), _c('a', {
    attrs: {
      "href": "#/#fn1-82",
      "id": "fn1_82"
    }
  }, [_c('sup', [_vm._v("82")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The majority sharply disagreed. It reaffirmed that students do not surrender their rights at the schoolhouse door"), _c('a', {
    attrs: {
      "href": "#/#fn1-83",
      "id": "fn1_83"
    }
  }, [_c('sup', [_vm._v("83")])]), _vm._v(" and that “[t]he classroom is peculiarly the ‘marketplace of ideas.’”"), _c('a', {
    attrs: {
      "href": "#/#fn1-84",
      "id": "fn1_84"
    }
  }, [_c('sup', [_vm._v("84")])]), _vm._v(" It held that high school and junior high school students are constitutionally entitled to express their views, even on controversial subjects, so long as they do so “without ‘materially and substantially interfer[ing] with the requirements of appropriate discipline in the operation of the school’ and without colliding with the rights of others.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-85",
      "id": "fn1_85"
    }
  }, [_c('sup', [_vm._v("85")])]), _vm._v(" The “discomfort "), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("and unpleasantness that always accompany an unpopular viewpoint” were not enough.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-86",
      "id": "fn1_86"
    }
  }, [_c('sup', [_vm._v("86")])]), _vm._v(" The impossibility of listening to two people at the same time would undoubtedly justify a ban on vocal protest during class. But silent armbands were protected even in class, and so was speech “in the cafeteria, or on the playing field, or on the campus during the authorized hours.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-87",
      "id": "fn1_87"
    }
  }, [_c('sup', [_vm._v("87")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Court also has protected the First Amendment rights of even younger children. Most notably, in "), _c('em', [_vm._v("West Virginia State Board of Education v. Barnette")]), _vm._v(","), _c('a', {
    attrs: {
      "href": "#/#fn1-88",
      "id": "fn1_88"
    }
  }, [_c('sup', [_vm._v("88")])]), _vm._v(" the Supreme Court held that school children could not be forced to salute the flag. Since "), _c('em', [_vm._v("Tinker")]), _vm._v(", the lower courts have continued to protect the free speech rights of high school students."), _c('a', {
    attrs: {
      "href": "#/#fn1-89",
      "id": "fn1_89"
    }
  }, [_c('sup', [_vm._v("89")])]), _vm._v(" The Supreme Court recently upheld the power of high school authorities to censor offensive sexual metaphors unnecessary for the expression of ideas,"), _c('a', {
    attrs: {
      "href": "#/#fn1-90",
      "id": "fn1_90"
    }
  }, [_c('sup', [_vm._v("90")])]), _vm._v(" but it reaffirmed the “undoubted freedom to advocate unpopular and controversial views in schools and classrooms.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-91",
      "id": "fn1_91"
    }
  }, [_c('sup', [_vm._v("91")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("I am fairly confident that most opponents of the Equal Access Act think that "), _c('em', [_vm._v("Tinker")]), _vm._v(" and "), _c('em', [_vm._v("Barnette")]), _vm._v(" were great decisions. Certainly the American Civil Liberties Union takes that puzzling position."), _c('a', {
    attrs: {
      "href": "#/#fn1-92",
      "id": "fn1_92"
    }
  }, [_c('sup', [_vm._v("92")])]), _vm._v(" How can it be that students are mature enough to deal with war protests and refusals to salute the flag—in the presence of an entire class—but are not mature enough to deal with a secluded prayer meeting attended only by those who wish to attend?")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The fear of apparent endorsement is not sufficient to distinguish the cases. No one ever has suggested that students would think that the school opposed the war in Vietnam if it failed to stamp out the armbands in "), _c('em', [_vm._v("Tinker")]), _vm._v(", or that the school was unenthusiastic about flag salutes if it failed to coerce obedience in "), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('em', [_vm._v("Barnette")]), _vm._v(". Yet the argument should have been made in those cases if there were anything to it. A showing of confusion about the school’s support for national policy would give rise to a substantial state interest in clarifying the school’s position.")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("There are two reasons why the argument of mistaken attribution was not made in those cases. First, it is factually absurd; no one could reasonably attribute the position of a few protesters to the school itself. Second, it is fundamentally at war with the policies of the First Amendment. It depends on the proposition that the school can censor anything with which it disagrees because that is what students expect it to do. The cliché fits here: the remedy for bad speech is more speech.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-93",
      "id": "fn1_93"
    }
  }, [_c('sup', [_vm._v("93")])]), _vm._v(" If the school feels a need to clarify its position, it can explicitly state its position. It cannot censor opposing views.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The fear of mistaken attribution in the equal access controversy is as much at war with the First Amendment as it would have been in "), _c('em', [_vm._v("Tinker")]), _vm._v(" or "), _c('em', [_vm._v("Barnette")]), _vm._v(". The inference that the school supports everything it does not censor is just as fallacious. But it is not quite so absurd to assume that some students will draw that inference if they are not told otherwise. Many students will assume from the outset that their school supports flag salutes, American foreign policy, and religion, especially if the religious group involved represents a large portion of the community. When the school tolerates views it is assumed to oppose, there is an immediate tendency to look for some explanation other than endorsement of those views. That tendency will not operate when the school tolerates something that students assume the school supports; tolerating a student religious group may reinforce an unthinking assumption that schools support religion. But we are not dependent on what students assume without reflection or instruction. The school can explain its open forum policy, and there is no reason to believe that high school students are incapable of understanding that explanation.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Ruti Teitel offers a different distinction. She says that "), _c('em', [_vm._v("Tinker")]), _vm._v(" and "), _c('em', [_vm._v("Barnette")]), _vm._v(" involved “absolutely private or individual activities” with insufficient “government involvement” to “create establishment concerns.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-94",
      "id": "fn1_94"
    }
  }, [_c('sup', [_vm._v("94")])]), _vm._v(" But it does not help her to label the speech as “individual.” There was more than one protester in both "), _c('em', [_vm._v("Tinker")]), _vm._v(" and "), _c('em', [_vm._v("Barnette")]), _vm._v(". Group association for First Amendment purposes is constitutionally protected,"), _c('a', {
    attrs: {
      "href": "#/#fn1-95",
      "id": "fn1_95"
    }
  }, [_c('sup', [_vm._v("95")])]), _vm._v(" and it would not have changed the result in "), _c('em', [_vm._v("Tinker")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("or "), _c('em', [_vm._v("Barnette")]), _vm._v(" if the whole student body had worn black armbands or refused to salute the flag.")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("It is true that the government had even less “involvement” with the speech in "), _c('em', [_vm._v("Tinker")]), _vm._v(" and "), _c('em', [_vm._v("Barnette")]), _vm._v(" than it has with a student prayer group. The Tinker children did not have to reserve a room for use at a scheduled time, and thus the school did not have to monitor their use of a room. But this sort of time, place, and manner “involvement” is not an Establishment Clause “concern.”")]), _c('a', {
    attrs: {
      "href": "#/#fn1-96",
      "id": "fn1_96"
    }
  }, [_c('sup', [_vm._v("96")])]), _vm._v(" Large groups also must reserve time to use parks and auditoriums, but that does not make equal access to parks and auditoriums an establishment of religion. What is forbidden is government support, encouragement, or endorsement. On those criteria, the speech of a self-sustaining student prayer group is just as private as the speech of the Tinker children.")]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_c('strong', [_vm._v("2. The Common Fallacy of the Secular Left and the Religious Right.")]), _vm._v("—I wish now to consider the apparent endorsement argument from a different perspective, without regard to the truth of its factual premises. The argument that high school students cannot understand First Amendment rights is untenable even if true. It is untenable because it leads to an insoluble contradiction.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("According to the secular left, students cannot understand toleration of religion in the schools. But if students cannot understand toleration of religion in the schools, they are just as incapable of understanding exclusion of religion from the schools."), _c('a', {
    attrs: {
      "href": "#/#fn1-97",
      "id": "fn1_97"
    }
  }, [_c('sup', [_vm._v("97")])]), _vm._v(" The secular left’s attack on equal access is indistinguishable from the religious right’s attack on the school prayer cases. The religious right also points to students’ inability to understand; its advocates argue that if schools do not teach about religion, students will interpret that silence as hostility to religion."), _c('a', {
    attrs: {
      "href": "#/#fn1-98",
      "id": "fn1_98"
    }
  }, [_c('sup', [_vm._v("98")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("The secular left and the religious right can both be wrong, but they cannot both be correct. Nor is it possible for one to be correct and the other to be wrong. Both of their propositions depend on the same underlying premise. The premise is that students assume a perfect correspondence between the beliefs of the school administration and the views that it discusses or tolerates—that it endorses everything it approves and censors everything it disapproves. The premise cannot be true for the secular left and false for the religious right, nor vice versa.")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("In fact, both sides have made the same mistake. Both sides take the position that if the school is not for them, it is against them. Both sides say neutrality will be interpreted as supporting the other side. In short, both sides say that neutrality is impossible. Yet neutrality is what the Constitution requires.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Both sides have been led to the same mistake by similar considerations. Both sides consider it a breach of neutrality if the school does anything that might be understood to support the other side. In effect, each seeks to allocate all risk of uncertainty to the other. Neutrality is seen as support for the other side because it might be misunderstood as support for the other side.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("Ruti Teitel’s comment on this Article illustrates the problem.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-99",
      "id": "fn1_99"
    }
  }, [_c('sup', [_vm._v("99")])]), _vm._v(" Teitel focuses on the risks of equal access. Some students might misunderstand it; some teachers might improperly implement it; some proselytizers might take unfair advantage of it. The unspoken premise is that the Establishment Clause is entitled to the protection of prophylactic rules so generous that no human deviation from those rules will ever risk violating the clause itself. That premise cannot be defended. When the policies of one clause bump up so directly against the policies of another, neither clause can enjoy a wide margin of safety. Neither side can have all that it wants.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In the equal access controversy, a solution in which one side bears all of the risk of student misunderstanding while the other side bears none is not a neutral solution. The risk of misunderstanding must be shared. It is best shared by facially neutral rules in which the government takes no position on religion in its own speech and treats private religious speech exactly like private secular speech. Whatever the risk that some students will perceive an open forum as an endorsement of all groups that participate, that risk is far outweighed by the actual and apparent hostility in a rule that allows students to talk about anything except religion.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("For both sides in this controversy, the risk of misunderstanding can be minimized by explaining what is misunderstood—by teaching students about "), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("the values of free speech, public fora, disestablishment, and government neutrality toward religion.")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('h1', {
    staticClass: "sec5bi"
  }, [_c('strong', [_c('em', [_vm._v("C. The Supreme Court’s Three-Part Test")])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("If the Supreme Court cases had held straightforwardly that the Establishment Clause forbids government support for religion, that the Free Exercise Clause forbids government burdens on religion, and that together the clauses require government to treat religion as neutrally as possible, it would have been almost impossible for any court to conclude that students may talk about anything except religion.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("But neutrality is only part of the Court’s test under the Religion Clauses. It has elaborated a test with three parts—purpose, effect, and entanglement.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-100",
      "id": "fn1_100"
    }
  }, [_c('sup', [_vm._v("100")])]), _vm._v(" This much-criticized “test” does not begin to explain the Court’s decisions,"), _c('a', {
    attrs: {
      "href": "#/#fn1-101",
      "id": "fn1_101"
    }
  }, [_c('sup', [_vm._v("101")])]), _vm._v(" but the Court continues to invoke it, apparently because no majority can agree on an alternative. Because any program challenged under the Establishment Clause must pass all three parts, the test provides ready ammunition for those who challenge legislation affecting religion.")]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_c('strong', [_vm._v("1. The Ambiguity of Secular Purpose")]), _vm._v(".—The Supreme Court’s first requirement is that state action have a secular purpose."), _c('a', {
    attrs: {
      "href": "#/#fn1-102",
      "id": "fn1_102"
    }
  }, [_c('sup', [_vm._v("102")])]), _vm._v(" This requirement has been invoked only against transparent endorsements of religion."), _c('a', {
    attrs: {
      "href": "#/#fn1-103",
      "id": "fn1_103"
    }
  }, [_c('sup', [_vm._v("103")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In many of the equal access cases, the school created an open forum for secular speech, and then religious speakers sought equal access to it. There can be no doubt that the purpose of creating the forum was secular. But what is the purpose of granting equal access to religious speakers? I would say the purpose "), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("is to avoid discriminating against religion and to comply with the Free Speech and Free Exercise Clauses.")])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("One could argue that the purpose of admitting religious speakers to the forum is to enhance religious speech. But such an argument has little basis in the policy of the Religion Clauses; it is merely an artifact of the Court’s formulation of the question. State efforts to alleviate discriminatory or state-imposed burdens on religious exercise are consistent with neutrality, even though any such effort, considered in isolation, will appear to aid religion.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-104",
      "id": "fn1_104"
    }
  }, [_c('sup', [_vm._v("104")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Consider the statutes banning employment discrimination on the basis of religion."), _c('a', {
    attrs: {
      "href": "#/#fn1-105",
      "id": "fn1_105"
    }
  }, [_c('sup', [_vm._v("105")])]), _vm._v(" A principal purpose of such statutes is to assist religious minorities. Their purpose also can be characterized as restoring religious neutrality to the private labor market. There is no point to metaphysical debate over the religious or secular nature of such a purpose. Whatever we call it, it is a purpose consistent with the Establishment Clause. Barring discrimination against religious speech is equally consistent with the Establishment Clause.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Teitel offers a different version of the purpose argument."), _c('a', {
    attrs: {
      "href": "#/#fn1-106",
      "id": "fn1_106"
    }
  }, [_c('sup', [_vm._v("106")])]), _vm._v(" Teitel notes that the purpose of the primary supporters of the Equal Access Act was to protect religious speech. Many of them also supported school-sponsored prayer, and many of them historically had taken a dim and narrow view of free speech and civil liberties. But then they discovered that the only way to let the student prayer group meet was to protect all kinds of secular student speech as well. Deciding that the benefits of prayer were worth the price of free speech, they voted for the Equal Access Act. Teitel finds this an unconstitutional religious purpose."), _c('a', {
    attrs: {
      "href": "#/#fn1-107",
      "id": "fn1_107"
    }
  }, [_c('sup', [_vm._v("107")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("Although Teitel accurately describes the purpose of at least some of the supporters of the Equal Access Act, her legal conclusion does not follow. For one thing, her description begins too late in the process. Congress responded to reports of discriminatory exclusion of religious speech from schools that allowed student speech on other topics; congressional desire to protect religious speech is analogous to the ban on religious discrimination in employment.")])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("More fundamentally, Teitel’s argument misunderstands the scope of judicial inquiry into legislative motive. If secular and religious speech really do get equal access, it does not matter what motivated Congress. In a wide range of contexts, the Court has held that a bad motive does not invalidate an otherwise permissible statute.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-108",
      "id": "fn1_108"
    }
  }, [_c('sup', [_vm._v("108")])]), _vm._v(" Inquiries into motive have been reserved for statutes that facially discriminate on a permissible ground but in effect discriminate on a forbidden ground, and then only when the claim is that the permissible facial discrimination is a pretext adopted for the purpose of achieving the forbidden effect."), _c('a', {
    attrs: {
      "href": "#/#fn1-109",
      "id": "fn1_109"
    }
  }, [_c('sup', [_vm._v("109")])]), _vm._v(" A statute that is neutral on its face and in effect, such as the Equal Access Act if properly implemented, does not fall within this category.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Court’s usual reasons for not inquiring into legislative motive are fully applicable to neutral legislation alleged to have a religious motive."), _c('a', {
    attrs: {
      "href": "#/#fn1-110",
      "id": "fn1_110"
    }
  }, [_c('sup', [_vm._v("110")])]), _vm._v(" But there is another reason for not inquiring into religious motive. The usual way of showing the religious motive behind a statute is to show the religious affiliation of the statute’s supporters and to show that some of them expressed religious reasons for supporting the legislation. Teitel provides a detailed description of the religious affiliation of various supporters of the Equal Access Act"), _c('a', {
    attrs: {
      "href": "#/#fn1-111",
      "id": "fn1_111"
    }
  }, [_c('sup', [_vm._v("111")])]), _vm._v(" and "), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("implies that there is something conspiratorial about their ties.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-112",
      "id": "fn1_112"
    }
  }, [_c('sup', [_vm._v("112")])]), _vm._v(" Imagine the reaction if someone assembled a similar list of Jewish affiliations to show that a Zionist conspiracy had pushed through a controversial piece of legislation.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("If that sort of evidence renders the Equal Access Act constitutionally suspect, then religious citizens are effectively deprived of their right to participate in the political process. Statutes are not unconstitutional just because they coincide with the beliefs of some religious group,"), _c('a', {
    attrs: {
      "href": "#/#fn1-113",
      "id": "fn1_113"
    }
  }, [_c('sup', [_vm._v("113")])]), _vm._v(" and the result should not change just because the religious group had the effrontery to express its beliefs. Courts should assess the constitutionality of the statute, not the religious beliefs of its supporters.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Supreme Court’s limited inquiries into purpose under the three-part Establishment Clause test generally have been consistent with its refusal to examine the legislative motive of neutral statutes. With one possible exception,"), _c('a', {
    attrs: {
      "href": "#/#fn1-114",
      "id": "fn1_114"
    }
  }, [_c('sup', [_vm._v("114")])]), _vm._v(" statutes invalidated for lack of a secular purpose have openly favored religion and have shown their religious purpose on their face."), _c('a', {
    attrs: {
      "href": "#/#fn1-115",
      "id": "fn1_115"
    }
  }, [_c('sup', [_vm._v("115")])]), _vm._v(" The Court could have invalidated them for lack of a secular purpose, or it could have dispensed with the purpose test and invalidated them for lack of neutrality. Perhaps the Court has been using “purpose” in the sense of “intended consequence,” while Teitel is using it in the sense of “motivation.” Whatever the Court has in mind, it should not use the purpose test to explore legislative motive for statutes that do not in fact favor religion.")]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_c('strong', [_vm._v("2. Effects That Neither Advance nor Inhibit Religion.")]), _vm._v("—The second part of the Court’s Establishment Clause test is that the challenged program have a “principal or primary effect … that neither advances nor inhibits religion.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-116",
      "id": "fn1_116"
    }
  }, [_c('sup', [_vm._v("116")])]), _vm._v(" On its face, this is just a statement of the neutrality requirement, and that is how it originated. The phrase is derived from "), _c('em', [_vm._v("Abington School District v. Schempp")]), _vm._v(","), _c('a', {
    attrs: {
      "href": "#/#fn1-117",
      "id": "fn1_117"
    }
  }, [_c('sup', [_vm._v("117")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("in which it first appeared in a paragraph explicating the “wholesome ‘neutrality’ of which this Court’s cases speak.”")]), _c('a', {
    attrs: {
      "href": "#/#fn1-118",
      "id": "fn1_118"
    }
  }, [_c('sup', [_vm._v("118")])]), _vm._v(" I already have shown why equal access legislation is neutral.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But two characteristics of the Court’s formulation of the neutrality requirement have let it be put to other uses."), _c('a', {
    attrs: {
      "href": "#/#fn1-119",
      "id": "fn1_119"
    }
  }, [_c('sup', [_vm._v("119")])]), _vm._v(" First, the Court has held that a direct religious effect is primary even if the program has more important secular effects."), _c('a', {
    attrs: {
      "href": "#/#fn1-120",
      "id": "fn1_120"
    }
  }, [_c('sup', [_vm._v("120")])]), _vm._v(" The Court continues to speak of the principal or primary effect,"), _c('a', {
    attrs: {
      "href": "#/#fn1-121",
      "id": "fn1_121"
    }
  }, [_c('sup', [_vm._v("121")])]), _vm._v(" but that is misleading. A more accurate statement of the Court’s test would be that the legislation may have no “substantial” effect that advances or inhibits religion. Litigants can and do argue that almost any effect is substantial.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Second, the requirement of neutrality is divided into a ban on effects that “advance” and effects that “inhibit.” Those challenging a program can focus only on those effects that arguably advance religion. If those effects are substantial, the program is said to be invalid. Thus, the conclusion of invalidity seemingly follows even when the challenged legislation is the most neutral solution possible.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The argument against equal access has proceeded in exactly this way. No beneficial effect on religion is too trivial to be offered as damning. Not just the appearance of sponsorship, but free heat and light, free use of classrooms, free supervision by faculty monitors, and convenient access to the potential audience congregated at the public school are all alleged to be substantial effects that advance religion."), _c('a', {
    attrs: {
      "href": "#/#fn1-122",
      "id": "fn1_122"
    }
  }, [_c('sup', [_vm._v("122")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("These arguments are put in context when we recognize that the “effects” test was intended to implement the neutrality requirement. Any serious search for neutrality must compare the available options. If the school encourages religion, or discriminates in favor of religion, the effect is to advance religion. Thus, endorsement or sponsorship is forbidden. If the school discourages religion, or discriminates against religion, the effect is to inhibit religion. Thus, the school cannot have a rule that students may meet to discuss anything except religion. These are the “principal or primary” "), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("effects that must be avoided. Compared to these effects, heat, light, classrooms, monitors, and convenient access are merely incidental effects of a neutral policy.")])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("These incidental effects of neutrality are not new. Free fire and police protection also are provided pursuant to a neutral policy of serving all groups in the community. Even Teitel concedes that church groups may meet in the parks,")]), _c('a', {
    attrs: {
      "href": "#/#fn1-123",
      "id": "fn1_123"
    }
  }, [_c('sup', [_vm._v("123")])]), _vm._v(" but free use of park land is no different than free use of classrooms. Both park land and classrooms are expensive to acquire, but once in place, the marginal cost of one more use is very low. A student prayer club could meet for years and not cost the school as much as Philadelphia spent on police protection and crowd and traffic control for a papal mass. Those expenditures went unchallenged;"), _c('a', {
    attrs: {
      "href": "#/#fn1-124",
      "id": "fn1_124"
    }
  }, [_c('sup', [_vm._v("124")])]), _vm._v(" they were the incidental consequences of a neutral policy of equal access to the parks."), _c('a', {
    attrs: {
      "href": "#/#fn1-125",
      "id": "fn1_125"
    }
  }, [_c('sup', [_vm._v("125")])]), _vm._v(" The expense of monitors is especially irrelevant to the analysis. Monitors are required by the school, not requested by the student prayer group. A group should not be held unconstitutional because of a “benefit” it does not want.")]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_c('strong', [_vm._v("3. The Misleading Metaphors of Separation and Entanglement")]), _vm._v(".—The third element of the Court’s Establishment Clause test forbids “entanglement” between church and state."), _c('a', {
    attrs: {
      "href": "#/#fn1-126",
      "id": "fn1_126"
    }
  }, [_c('sup', [_vm._v("126")])]), _vm._v(" The Court frequently has invoked Thomas Jefferson’s metaphor that the Religion Clauses erect a “wall of separation” between church and state. Jefferson’s phrase has been enshrined in the public imagination; people talk of “separation of church and state”"), _c('a', {
    attrs: {
      "href": "#/#fn1-127",
      "id": "fn1_127"
    }
  }, [_c('sup', [_vm._v("127")])]), _vm._v(" as the fundamental principle of religious liberty in the United States.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In the equal access controversy, the metaphors of “separation” and “entanglement” encourage the misguided focus on the location of the speech instead of the identity of the speaker. A private speaker on public property may seem insufficiently separated from the government. If a student religious group meets on school property, there is undoubtedly a contact between religion and the state. Contact is not separation; a contact might even be an entanglement. If a judge’s analytic starting point is separation or entanglement, he is much more likely to convince himself that religion cannot be discussed on public property. "), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("In "), _c('em', [_vm._v("Bender v. Williamsport Area School District")]), _vm._v(",")]), _c('a', {
    attrs: {
      "href": "#/#fn1-128",
      "id": "fn1_128"
    }
  }, [_c('sup', [_vm._v("128")])]), _vm._v(" Judge Garth concluded that the religious group’s use of school property and the school’s responsibility for the safety of the students and the building were two separate entanglements; apparently, either entanglement was independently fatal to equal access."), _c('a', {
    attrs: {
      "href": "#/#fn1-129",
      "id": "fn1_129"
    }
  }, [_c('sup', [_vm._v("129")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Judge Garth also found entanglement in Petros’s concession that it would not use the school’s bulletin boards or public address system. He held that distinguishing religious from secular messages for purposes of censoring the bulletin board and public address system would be an excessive entanglement."), _c('a', {
    attrs: {
      "href": "#/#fn1-130",
      "id": "fn1_130"
    }
  }, [_c('sup', [_vm._v("130")])]), _vm._v(" If that were right, it would follow that distinguishing religious from secular messages for purposes of censoring meetings of student groups is also an excessive entanglement. The need to distinguish religious from secular speech results from the court’s commitment to censorship, not from equal access. Access to the school’s open forum should include access to the usual channels of internal communication, as the Supreme Court has held with respect to universities."), _c('a', {
    attrs: {
      "href": "#/#fn1-131",
      "id": "fn1_131"
    }
  }, [_c('sup', [_vm._v("131")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('em', [_vm._v("Bender")]), _vm._v("’s facts aside, the underlying problem is with the metaphors of separation and entanglement. I have argued before that these metaphors do more harm than good."), _c('a', {
    attrs: {
      "href": "#/#fn1-132",
      "id": "fn1_132"
    }
  }, [_c('sup', [_vm._v("132")])]), _vm._v(" The Constitution neither commands separation nor forbids entanglement. Neither word appears there. Some contacts are forbidden; others are not. Most important, the Religion Clauses regulate the state and not the church. The state can neither support nor oppose religion, but churches and religious citizens are as free as anyone else to support or oppose the state.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Like the secular purpose requirement,"), _c('a', {
    attrs: {
      "href": "#/#fn1-133",
      "id": "fn1_133"
    }
  }, [_c('sup', [_vm._v("133")])]), _vm._v(" the separation metaphor has been the basis of repeated efforts to censor religiously motivated speech. In the name of separation, Tennessee barred the clergy from running for the "), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("state legislature. The Supreme Court invalidated the restriction.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-134",
      "id": "fn1_134"
    }
  }, [_c('sup', [_vm._v("134")])]), _vm._v(" Pro-choice groups built on the metaphor, arguing that restrictions on abortion violated the Establishment Clause because religious groups actively supported them."), _c('a', {
    attrs: {
      "href": "#/#fn1-135",
      "id": "fn1_135"
    }
  }, [_c('sup', [_vm._v("135")])]), _vm._v(" The Supreme Court properly rejected that argument."), _c('a', {
    attrs: {
      "href": "#/#fn1-136",
      "id": "fn1_136"
    }
  }, [_c('sup', [_vm._v("136")])]), _vm._v(" When conservative ministers support Ronald Reagan and speak out on their social agenda; when Catholic bishops speak out on abortion, nuclear weapons, economic redistribution, and peace in Central America; or when rabbis speak out on behalf of Israel, someone on the other side of the political issue is sure to charge that these attempts to influence public policy violate separation of church and state. A moment’s reflection on free speech and free exercise reveals the absurdity of that charge; only the metaphor of separation has given it credence. The same confusion appears in the lower court cases rejecting equal access. Once again, the free speech rights of religious citizens are denied in the name of separation of church and state.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In many of the equal access cases, courts have used “entanglement” as a second label for their effects analysis. In "), _c('em', [_vm._v("Bender")]), _vm._v(", for example, Judge Garth suggested that allowing monitors at student meetings would create an appearance of support and also would be an entanglement."), _c('a', {
    attrs: {
      "href": "#/#fn1-137",
      "id": "fn1_137"
    }
  }, [_c('sup', [_vm._v("137")])]), _vm._v(" In this sense, entanglement is simply a synonym for contact and an antonym for separation. If monitors are wholly neutral and their presence neither supports nor interferes with religion, allowing them at student meetings is a neutral practice. Labeling it an entanglement does not make it an Establishment Clause violation. In other contexts, entanglements have involved burdensome state interference with religion. That is where the entanglement doctrine does its greatest mischief: it turns harm to religion into an Establishment Clause violation and thereby gives separationists standing to assert rights that should belong exclusively to churches and believers."), _c('a', {
    attrs: {
      "href": "#/#fn1-138",
      "id": "fn1_138"
    }
  }, [_c('sup', [_vm._v("138")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("These two misleading metaphors are surely responsible for much of the resistance to equal access. Neither metaphor accurately summarizes the Establishment Clause, and neither has much power to explain Supreme "), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("Court precedent.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-139",
      "id": "fn1_139"
    }
  }, [_c('sup', [_vm._v("139")])]), _vm._v(" It would be a great boon to clear thinking if we could banish “separation” and “entanglement” from our vocabulary and speak only of free speech, free exercise, and establishment. The purpose and effects parts of the three-part test can be salvaged if properly understood, but we probably would do better to abandon them as well and to start over from square one.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec5bi"
  }, [_c('strong', [_c('em', [_vm._v("D. Miscellaneous Arguments Against Equal Access")])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("Opponents of equal access have emphasized high school students’ inability to understand tolerance as the primary reason for denying equal access in high schools, and the students’ youth as the primary reason for their inability to understand. They also have made a number of less plausible arguments.")]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_c('strong', [_vm._v("1. The Tradition of High School Censorship")]), _vm._v(".—One such argument is factually plausible but wholly inconsistent with the policies of the First Amendment. The argument runs that many high schools continue to censor student speech, so that uninstructed students reasonably may infer that their school approves of every student group it tolerates."), _c('a', {
    attrs: {
      "href": "#/#fn1-140",
      "id": "fn1_140"
    }
  }, [_c('sup', [_vm._v("140")])]), _vm._v(" But even if that were true, the inference from past school censorship can hardly be a justification for more censorship. If schools that have violated the free speech rights of their students could never change course without violating the Establishment Clause, a constitutional violation would become a constitutional requirement.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Equal Access Act offers a far better solution to the problem. It requires schools with non-curriculum-related student groups to stop censoring those groups. Student religious groups are not the only beneficiaries; no student group can be denied permission to meet because of “the religious, political, philosophical, or other content of the speech at such meetings.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-141",
      "id": "fn1_141"
    }
  }, [_c('sup', [_vm._v("141")])]), _vm._v(" Thus, the Act does not allow schools to continue to censor so long as they exempt religious groups; schools subject to the Act must run a genuinely open forum for student groups. Under the Act, both left and right wing political groups have the same access as religious groups. The more diverse the participation in the forum, the clearer it will be that the school does not endorse the views of all the participants.")]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_c('strong', [_vm._v("2. The Need for Supervision")]), _vm._v(".—Many high schools require that meetings of student groups be monitored by a teacher or other adult.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-142",
      "id": "fn1_142"
    }
  }, [_c('sup', [_vm._v("142")])]), _vm._v(" A monitor is a representative of the school who is responsible for keeping order.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Opponents of equal access have worried that the presence of such a monitor will enhance the appearance of school endorsement. In "), _c('em', [_vm._v("Bender")]), _vm._v(", the Third Circuit characterized the role of a monitor in a sentence that is extraordinary for its studied ambiguity and cavalier treatment of the evidence:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("While the students in their affidavits characterized the monitor’s activities as benign and neutral, designed only to maintain order, it is readily apparent that a school teacher or someone associated with the school necessarily must impart the impression to students that the school’s authority and that the school’s endorsement is implicated in the relevant activity, since every monitor must be approved by the school."), _c('a', {
    attrs: {
      "href": "#/#fn1-143",
      "id": "fn1_143"
    }
  }, [_c('sup', [_vm._v("143")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodySb"
  }, [_vm._v("This sentence apparently means that the monitor’s presence shows that the school supports religion. If that is what it means, the court ordered summary judgment on the basis of what was “readily apparent,” even though the only evidence on the issue was the students’ contrary affidavits. The court would have reason to be suspicious of conclusory affidavits on such an issue, but the students’ affidavits contained details of the sort that come from witnesses, rather than lawyers."), _c('a', {
    attrs: {
      "href": "#/#fn1-144",
      "id": "fn1_144"
    }
  }, [_c('sup', [_vm._v("144")])]), _vm._v(" Even if doubts about uncontradicted affidavits can justify a trial, such doubts cannot support a summary judgment rejecting the affidavits. Yet that is what the court ordered."), _c('a', {
    attrs: {
      "href": "#/#fn1-145",
      "id": "fn1_145"
    }
  }, [_c('sup', [_vm._v("145")])]), _vm._v(" The court apparently held as a matter of law that the students perceived an endorsement that they denied perceiving. Or perhaps it held as a matter of law that some other student, who had not filed an affidavit, would perceive an endorsement.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Or perhaps the court did not say any of those things. Note the slippery wording of the final clauses: “[T]he school’s endorsement is implicated in the relevant activity, since every monitor must be approved by the school.” Those clauses might be literally true: the school endorses the monitor, and its endorsement "), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("of the monitor is “implicated” in the activity. But it is a long leap from endorsing the monitor to endorsing religion. When the police are sent to preserve order at a demonstration, no one infers that the city endorses the goals of the demonstrators. It is no more reasonable to infer that a monitor sent to protect furnishings and to suppress spitballs endorses the goals of the group he supervises.")])]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("It is undoubtedly true that for most student groups, the monitor is also the group’s sponsor, and that most student groups find sponsors who endorse their activities. Uninformed students might assume that a monitor at a student religious meeting is also a supportive sponsor. But again, we should not be bound by what the least informed student might assume without benefit of explanation. It is not difficult for the monitor to explain that religion is committed to private choice in our society, that the school cannot take a position on religious questions or participate in the students’ religious activities, and that consequently the monitor is not a sponsor and is present only to keep order. Then, the monitor can read a book or grade papers. Schools concerned about collusion could send a different monitor every week.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("Jay Westbrook has asked if these restrictions on the monitor’s role are necessary. He suggests an argument, based on neutrality, that the student religious group is entitled to the assistance of an adult sponsor on the same terms as any other group.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-146",
      "id": "fn1_146"
    }
  }, [_c('sup', [_vm._v("146")])]), _vm._v(" One easily can imagine schools sponsoring and advising competing student political groups without endorsing either group’s position; they could do the same for student religious groups. Why should only the religious group have to make do with juvenile leadership?")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The question is more serious than the conventional wisdom would suggest. But I think the conventional wisdom is right on this one. The line between the religious speech protected by the Free Speech and Free Exercise Clauses and the religious speech forbidden by the Establishment Clause is the line between private speech and government speech. That line is conceptually clear, even if in some applications its location is murky and crossing over seems harmless.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The meaning of neutrality must take account of this line. That is why I have offered a two-part formulation: government must be neutral in its own speech as well as in its treatment of private speech. Withholding advisors from student religious groups preserves neutrality in government speech, because the government avoids having its agent take a position on religion. Withholding the advisor is neutral toward private speech because it leaves private speakers free to say whatever they want. It is nonneutral only in the sense that it denies the religious group help that the government gives to other groups.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("If it is nonneutral to deny this help, the refusal to teach religion in the public schools is also nonneutral. Public schools teach the information and skills for all our other social institutions; why is it only religion that has to transmit itself to the next generation without aid from public schools? The answer is that that is the cost of committing religion to private choice and avoiding the dangers associated with governments that take positions on religion. The dangers associated with a public school providing an advisor to a voluntary student religious group are attenuated, but the principle is the same. The meaning of neutrality is that government should take no position on religion, not that it should provide equal assistance to religious and secular groups.")])]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("Teitel comes at this issue from another angle. She notes that teachers have free speech rights")]), _c('a', {
    attrs: {
      "href": "#/#fn1-147",
      "id": "fn1_147"
    }
  }, [_c('sup', [_vm._v("147")])]), _vm._v(" and suggests that it is inconsistent for the Equal Access Act to forbid teacher participation."), _c('a', {
    attrs: {
      "href": "#/#fn1-148",
      "id": "fn1_148"
    }
  }, [_c('sup', [_vm._v("148")])]), _vm._v(" She tries to discredit equal access by showing that it proves too much.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Teitel is certainly right that teachers have free speech rights. Religious groups made up entirely of teachers are constitutionally entitled to meet on the teachers’ personal time during times that the teachers are entitled to be in the building."), _c('a', {
    attrs: {
      "href": "#/#fn1-149",
      "id": "fn1_149"
    }
  }, [_c('sup', [_vm._v("149")])]), _vm._v(" The sticky issue is whether such a group of teachers, or a single teacher, can meet jointly with a student religious group. The teachers would have to join in their personal capacity and not in their role as teachers; they would have to be ordinary members of the group and not the school’s monitors. And they would have to make these role distinctions clear to students.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Teachers probably cannot meet these requirements."), _c('a', {
    attrs: {
      "href": "#/#fn1-150",
      "id": "fn1_150"
    }
  }, [_c('sup', [_vm._v("150")])]), _vm._v(" The Equal Access Act’s ban on teacher participation is a prophylactic rule based on that judgment. "), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("It is one thing for students to understand the role of a nonparticipating faculty monitor; his conduct reflects his role. It would be much harder for students to remember that a participating teacher was acting in one capacity at the prayer group and in a different capacity in the classroom half an hour later. It is unlikely that even the teachers could keep their roles straight. There would be no visible evidence of the change in roles. Few, if any, students or teachers have had any experience with teachers joining student organizations in their personal capacity as ordinary members. Lack of precedent would make the role change harder to understand. Lack of precedent also would mean that a religious group’s demand for joint membership is more than merely a demand for equal access.")])]), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Fine lines may have to be drawn on occasion, but the principle is clear. The school may monitor the meetings to protect students and property from harm, but the school may not lead, sponsor, encourage, or discourage religious activity.")])]), _c('p', {
    staticClass: "HPara"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_c('strong', [_vm._v("3. Social Pressure and the Size of High School Campuses")]), _vm._v(".—Judge Garth’s opinion in "), _c('em', [_vm._v("Bender")]), _vm._v(" contains an even more extraordinary attempt to distinguish high schools from colleges. According to Judge Garth, high school campuses are “more confined,”")]), _c('a', {
    attrs: {
      "href": "#/#fn1-151",
      "id": "fn1_151"
    }
  }, [_c('sup', [_vm._v("151")])]), _vm._v(" and their environment is more “structured and controlled.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-152",
      "id": "fn1_152"
    }
  }, [_c('sup', [_vm._v("152")])]), _vm._v(" Consequently,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("[i]nvoluntary contact between nonparticipating students and religious groups is inevitable. Students of different or conflicting creeds would therefore be less able to overlook the activities of such a group within their school, and by the same token would be more likely to perceive a message of endorsement by school authorities."), _c('a', {
    attrs: {
      "href": "#/#fn1-153",
      "id": "fn1_153"
    }
  }, [_c('sup', [_vm._v("153")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodySb"
  }, [_vm._v("If Judge Garth meant to say that an open forum on a small campus implies endorsement more strongly than an open forum on a large campus, the argument is silly. Maybe he meant that if impressionable high school students are inclined to mistakenly infer endorsement from toleration, they will have more opportunities to do so on a small campus, because they will be more aware that the religious group is tolerated. But that assertion is wholly dependent on the claim that high school students are inclined to mistake toleration for "), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("endorsement; the argument based on the size of high school campuses has no independent force.")])]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("Perhaps Judge Garth’s comments were intended to support another argument: that meetings of student religious groups would put social pressure on other students to join the group or change their religious beliefs.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-154",
      "id": "fn1_154"
    }
  }, [_c('sup', [_vm._v("154")])]), _vm._v(" There is some truth to that, but again the distinction between government speech and religious speech is dispositive. The government cannot forbid the exercise of one religion to protect the sensibilities of other religions. Contrary to the bizarre view of the Second Circuit,"), _c('a', {
    attrs: {
      "href": "#/#fn1-155",
      "id": "fn1_155"
    }
  }, [_c('sup', [_vm._v("155")])]), _vm._v(" the captain of the football team does not have to conceal his religion lest others be unduly influenced. The right to proselytize is at the core of the First Amendment; the right to attend religious services openly rather than in secret was heretofore unchallenged.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Despite all that, friction between students of different religions is likely to be a problem with or without equal access, and equal access has some tendency to aggravate it. The school must address such frictions by teaching tolerance, not by stamping out religious expression. Unless schools are training students to live in a system of religious apartheid, contact between students of different faiths is a good thing. Students in a pluralistic society must learn to deal constructively with religious differences. To the extent they do, both dominant and minority religions will benefit.")]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_c('strong', [_vm._v("4. The Remains of "), _c('em', [_vm._v("McCollum")]), _vm._v(" and "), _c('em', [_vm._v("Zorach")])]), _vm._v(".—Judge Garth also relied on the Supreme Court’s first encounters with religion in public schools, the released-time cases. In released-time programs, public schools suspended classes for a period of religious instruction offered by local clergy. In theory, students were not required to attend religious instruction. But they could not leave the school, and secular instruction was suspended. Justice Jackson aptly characterized the programs as providing “a temporary jail for a pupil who will not go to Church.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-156",
      "id": "fn1_156"
    }
  }, [_c('sup', [_vm._v("156")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Court struck down these programs in "), _c('em', [_vm._v("Illinois ex rel. McCollum v. Board of Education")]), _vm._v("."), _c('a', {
    attrs: {
      "href": "#/#fn1-157",
      "id": "fn1_157"
    }
  }, [_c('sup', [_vm._v("157")])]), _vm._v(" It did so for the reason stated by Justice Jackson, although the majority spoke only of compulsory education laws and not of jails. The point was the same: the state’s power to compel school attendance was used to coerce attendance at religious instruction.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("There was bitter opposition to "), _c('em', [_vm._v("McCollum")]), _vm._v(", and in "), _c('em', [_vm._v("Zorach v. Clauson")]), _vm._v(","), _c('a', {
    attrs: {
      "href": "#/#fn1-158",
      "id": "fn1_158"
    }
  }, [_c('sup', [_vm._v("158")])]), _vm._v(" the Court backed down. "), _c('em', [_vm._v("McCollum")]), _vm._v(" and "), _c('em', [_vm._v("Zorach")]), _vm._v(" were identical in all ways but one. "), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("In "), _c('em', [_vm._v("McCollum")]), _vm._v(", the clergy went to the school to provide religious instruction to released students; in "), _c('em', [_vm._v("Zorach")]), _vm._v(", the released students left the school and went to church. That distinction was wholly irrelevant to the coercive use of the compulsory education laws: under both plans, the penalty for not taking religious instruction was detention in a school building where secular instruction had been suspended. But the place of instruction was the only distinction the Court had, so that was the line it drew, holding that released-time programs are constitutional if the religious instruction takes place off campus.")])]), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_c('em', [_vm._v("Zorach")]), _vm._v(" is utterly indefensible. Released-time programs are unconstitutional no matter where the instruction takes place. But "), _c('em', [_vm._v("Zorach")]), _vm._v(" held differently, and neither it nor "), _c('em', [_vm._v("McCollum")]), _vm._v(" has been overruled.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-159",
      "id": "fn1_159"
    }
  }, [_c('sup', [_vm._v("159")])]), _vm._v(" The distinction remains an embarrassment that fools no one,"), _c('a', {
    attrs: {
      "href": "#/#fn1-160",
      "id": "fn1_160"
    }
  }, [_c('sup', [_vm._v("160")])]), _vm._v(" and its reasoning has not been applied in other cases. "), _c('em', [_vm._v("Zorach")]), _vm._v("’s finding that pupils were not coerced is inconsistent with the finding of coercion in the more recent school prayer cases."), _c('a', {
    attrs: {
      "href": "#/#fn1-161",
      "id": "fn1_161"
    }
  }, [_c('sup', [_vm._v("161")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But Judge Garth revived the distinction and found it “critical.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-162",
      "id": "fn1_162"
    }
  }, [_c('sup', [_vm._v("162")])]), _vm._v(" In light of "), _c('em', [_vm._v("Zorach")]), _vm._v(", he thought "), _c('em', [_vm._v("McCollum")]), _vm._v(" held that religious activity in a school building is what made released time unconstitutional. He concluded that it was therefore irrelevant that released time singles out religion for preferential treatment and that equal access does not. He did not even mention that released time is coercive and that equal access is not.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But even if "), _c('em', [_vm._v("McCollum")]), _vm._v(" and "), _c('em', [_vm._v("Zorach")]), _vm._v(" are still good law, Judge Garth’s argument does not follow. On any realistic view of the facts, and certainly in light of the subsequent school prayer cases, "), _c('em', [_vm._v("McCollum")]), _vm._v(" and "), _c('em', [_vm._v("Zorach")]), _vm._v(" hold that the validity of coerced religious instruction may depend on its location. Neither case says what would happen if the coercive element were wholly removed. "), _c('em', [_vm._v("Zorach")]), _vm._v(" supports the view that the government can trample on the Establishment Clause so long as the coercive element is not more than the Court can stomach. A judge with Garth’s stringent view of the Establishment Clause can argue only that "), _c('em', [_vm._v("Zorach")]), _vm._v(" has been eroded by subsequent decisions. To argue that "), _c('em', [_vm._v("Zorach")]), _vm._v(" supports Judge Garth’s stringent view is simply wrong.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("On my view of "), _c('em', [_vm._v("McCollum")]), _vm._v(" and "), _c('em', [_vm._v("Zorach")]), _vm._v(", equal access would be invalid if schools used the compulsory education laws to encourage attendance at religious meetings. That is not a risk when extracurricular groups meet before or "), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("after school. Nonparticipating students are free to leave the campus altogether, so the compulsory education laws are not implicated. Students inclined to join a student religious group may find it easier to do so, but no one who has seen students flee school at the closing bell can think that uninterested students are coerced to remain.")])]), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("The situation in "), _c('em', [_vm._v("Bender")]), _vm._v(" was a little different. There, the student religious group sought to meet in a student activity period during school hours; students were not free to leave. But there are two crucial differences between "), _c('em', [_vm._v("McCollum")]), _vm._v(" and "), _c('em', [_vm._v("Bender")]), _vm._v(". First, the program in "), _c('em', [_vm._v("McCollum")]), _vm._v(" was sponsored by the school; the student group in "), _c('em', [_vm._v("Bender")]), _vm._v(" was created by students, and the school refrained from any form of endorsement. This is the difference between government speech and private speech. Second, and most important, students in "), _c('em', [_vm._v("McCollum")]), _vm._v(" were required to come to school and then given no attractive alternative to religious instruction. In "), _c('em', [_vm._v("Bender")]), _vm._v(", students had many choices. The student religious group was simply one more option in a preexisting student activity period. A wide variety of other student groups met at the same time. Students could join one of those groups, go to the library, use the computer, go to the placement office and learn about jobs or colleges, or remain in their homeroom. The coercion in "), _c('em', [_vm._v("McCollum")]), _vm._v(" was wholly absent in "), _c('em', [_vm._v("Bender")]), _vm._v(".")]), _c('a', {
    attrs: {
      "href": "#/#fn1-163",
      "id": "fn1_163"
    }
  }, [_c('sup', [_vm._v("163")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Teitel nevertheless thinks that the compulsory school attendance laws create an Establishment Clause problem for the Equal Access Act."), _c('a', {
    attrs: {
      "href": "#/#fn1-164",
      "id": "fn1_164"
    }
  }, [_c('sup', [_vm._v("164")])]), _vm._v(" All groups "), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_vm._v("hoping to speak to a student audience know that they can find lots of students in one place at a school. That religious groups seek the same convenient access is one more incidental consequence of neutrality. If religious proselytizers were forbidden to approach any audience assembled by the government, they would be discriminatorily barred from state fairs, subway stations, and courthouses. Teitel refers to students as a “captive” audience,")]), _c('a', {
    attrs: {
      "href": "#/#fn1-165",
      "id": "fn1_165"
    }
  }, [_c('sup', [_vm._v("165")])]), _vm._v(" but she does not contend that they are forced to attend meetings of student prayer groups or even to read posters announcing that such groups will meet. The most she can possibly mean is that there is a captive audience for announcements of meetings over the school’s public address system. That is a reason to keep such announcements brief and factual, but it is not a reason to ban private religious speech in the school.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec4b"
  }, [_c('strong', [_vm._v("IV. The Implementation of Equal Access")])]), _vm._v(" "), _c('h1', {
    staticClass: "sec5bi"
  }, [_c('strong', [_c('em', [_vm._v("A. The Existence of an Open or Public Forum")])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("I have discussed the constitutional merits of equal access in the context of a school that plainly creates an open forum for student organizations. Such a school is useful for clarifying the basic principle: if there is an open forum for student organizations, student religious organizations cannot be excluded. But the principle may be more difficult to apply in schools with fewer and more restricted student organizations. Student organizations probably have been created informally and haphazardly at many schools; with no articulated policy, schools may try to rationalize their past practice in a way that minimizes their obligation to honor free speech. The resulting ambiguities may be addressed either under the Equal Access Act or the Constitution.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Equal Access Act refers to an “open forum” in public secondary schools,"), _c('a', {
    attrs: {
      "href": "#/#fn1-166",
      "id": "fn1_166"
    }
  }, [_c('sup', [_vm._v("166")])]), _vm._v(" but most of the constitutional cases refer to a “public forum.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-167",
      "id": "fn1_167"
    }
  }, [_c('sup', [_vm._v("167")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_vm._v("The terms may be interchangeable, but “open forum” is more precise, and I will generally use it. No one contends that a forum in a school is open to the general public. The issue is whether there is a forum open to students and faculty.")])]), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }), _c('p', {
    staticClass: "HPara"
  }, [_c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_c('strong', [_vm._v("1. The Statutory Meaning of “Open Forum.”")]), _vm._v("—The drafters of the Equal Access Act tried to solve the problem by providing a generous, objective definition of “open forum.” The sponsors emphasized that the school’s actual practice was determinative, not its stated policy.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-168",
      "id": "fn1_168"
    }
  }, [_c('sup', [_vm._v("168")])]), _vm._v(" Unfortunately, the Act is so badly drafted that it may not achieve its purpose."), _c('a', {
    attrs: {
      "href": "#/#fn1-169",
      "id": "fn1_169"
    }
  }, [_c('sup', [_vm._v("169")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("According to the Act, a public secondary school that receives federal financial assistance and has a “limited open forum” cannot exclude student groups because of the content of the speech at their meetings—whether religious, political, philosophical, or “other.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-170",
      "id": "fn1_170"
    }
  }, [_c('sup', [_vm._v("170")])]), _vm._v(" The definition of “limited open forum” is in § 4071(b), which states that “[a] public secondary school has a limited open forum whenever such school grants an offering to or opportunity for one or more noncurriculum related student groups to meet on school premises during noninstructional time.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-171",
      "id": "fn1_171"
    }
  }, [_c('sup', [_vm._v("171")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This definition resembles the constitutional concept of “limited public forum,” but it goes well beyond the Supreme Court’s cases. The statutory “limited open forum” is an artificial construct, and comparisons with the constitutional cases can be misleading. Most notably, government speech does not create a constitutional public forum,"), _c('a', {
    attrs: {
      "href": "#/#fn1-172",
      "id": "fn1_172"
    }
  }, [_c('sup', [_vm._v("172")])]), _vm._v(" but a school-sponsored student group that is not curriculum related (if there is such a thing) creates a statutory open forum.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Schools seeking to avoid statutory coverage must argue that they do not have even one “noncurriculum related student group.” That key phrase is not defined, and it arguably contains two ambiguities: What is “curriculum related”? And what is a “student group”? The football team is a student group, and it is not curriculum related. On the other hand, it is not an outlet for expression of student views; apart from the statute, a football team would not be relevant to any analysis of open fora or content neutrality. And some schools undoubtedly will argue that the football team is curriculum related, because physical "), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_vm._v("education is part of the curriculum.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-173",
      "id": "fn1_173"
    }
  }, [_c('sup', [_vm._v("173")])]), _vm._v(" Indeed, in one of the first cases under the Act, the defendant argued that every group in the school was curriculum related, including the scuba-diving club and a service organization sponsored by the Rotary Club."), _c('a', {
    attrs: {
      "href": "#/#fn1-174",
      "id": "fn1_174"
    }
  }, [_c('sup', [_vm._v("174")])]), _vm._v(" Schools may also argue that the football team is not a student group—that “student group” means student-initiated group and does not include school-sponsored groups.")]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_c('strong', [_c('em', [_vm._v("a. Legislative History and Statutory Text")])]), _vm._v(".—The legislative history of the Equal Access Act only compounds these ambiguities. The bill was completely rewritten in a series of multilateral negotiations after it was passed by the House and reported out of committee in the Senate. Thus, the committee reports cast no light on the language actually adopted. Senator Hatfield offered the negotiated compromise as a floor amendment in the midst of the Senate’s rush to adjourn for the Fourth of July. He repeatedly emphasized that as many as one thousand people had been involved in the negotiations that produced the compromise version,"), _c('a', {
    attrs: {
      "href": "#/#fn1-175",
      "id": "fn1_175"
    }
  }, [_c('sup', [_vm._v("175")])]), _vm._v(" and that not all the Senators sponsoring the compromise agreed with everything in it."), _c('a', {
    attrs: {
      "href": "#/#fn1-176",
      "id": "fn1_176"
    }
  }, [_c('sup', [_vm._v("176")])]), _vm._v(" Senator Gorton accurately observed that too many cooks had spoiled the broth."), _c('a', {
    attrs: {
      "href": "#/#fn1-177",
      "id": "fn1_177"
    }
  }, [_c('sup', [_vm._v("177")])]), _vm._v(" But Hatfield had a large majority committed to his compromise, and he resisted any change that might have caused the deal to fall apart. The Hatfield compromise later passed the House under a special rule that precluded amendments and limited debate to one hour."), _c('a', {
    attrs: {
      "href": "#/#fn1-178",
      "id": "fn1_178"
    }
  }, [_c('sup', [_vm._v("178")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The most direct legislative history on the meaning of “limited open forum” is a colloquy between Senators Gorton and Hatfield. Under skillful cross-examination, Hatfield offered just about every possible interpretation in less than two columns of the "), _c('em', [_vm._v("Congressional Record")]), _vm._v("."), _c('a', {
    attrs: {
      "href": "#/#fn1-179",
      "id": "fn1_179"
    }
  }, [_c('sup', [_vm._v("179")])]), _vm._v(" First, he agreed that the chess club was not curriculum related, so that a school with a chess club had an open forum. He explained that curriculum-related clubs were those that are “really a kind of extension of the classroom.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-180",
      "id": "fn1_180"
    }
  }, [_c('sup', [_vm._v("180")])]), _vm._v(" He offered the example "), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_vm._v("of a French club made up of students in a French class, who met to practice speaking French.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-181",
      "id": "fn1_181"
    }
  }, [_c('sup', [_vm._v("181")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Then, in response to a question about the pep club, Hatfield said: “Conceivably, some of your sports activities could grow out of a physical ed curriculum requirement in the school.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-182",
      "id": "fn1_182"
    }
  }, [_c('sup', [_vm._v("182")])]), _vm._v(" Gorton asked about the football team, and “conceivably” became certainly. Hatfield said that the football team “is curriculum-related because that is how they can use tax dollars.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-183",
      "id": "fn1_183"
    }
  }, [_c('sup', [_vm._v("183")])]), _vm._v(" Of course, if the standard is “tax dollars,” everything the school supports is curriculum related. That is a vastly different standard than the “extension of the classroom” standard that Hatfield had just invoked.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Gorton asked if the school district would have full authority to decide what was curriculum related. Hatfield replied, “We in no way seek to limit that discretion.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-184",
      "id": "fn1_184"
    }
  }, [_c('sup', [_vm._v("184")])]), _vm._v(" So the school district could decide that the cheerleading squad is curriculum related? “Correct,” said Hatfield."), _c('a', {
    attrs: {
      "href": "#/#fn1-185",
      "id": "fn1_185"
    }
  }, [_c('sup', [_vm._v("185")])]), _vm._v(" Could the school district make the same determination with reference to a chess club? “I would not say that no district could, but I cannot readily conceive of a criterion that could be used at this time to establish that as a curriculum-related activity. I am not saying it could not be, because as long as you have lawyers, they can find ways of doing things one way or another.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-186",
      "id": "fn1_186"
    }
  }, [_c('sup', [_vm._v("186")])]), _vm._v(" What about a drama club that puts on a play? Hatfield said that a play was curriculum related and volunteered that the school band and other cultural activities were also curriculum related, because schools offer courses in music and the arts.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Gorton said, “It seems to me … that one of the keys to the noncurriculum related student organization is that it is not sponsored by the school.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-187",
      "id": "fn1_187"
    }
  }, [_c('sup', [_vm._v("187")])]), _vm._v(" Hatfield replied, “That is correct.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-188",
      "id": "fn1_188"
    }
  }, [_c('sup', [_vm._v("188")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("By this time, Hatfield had gone from only things that are an extension of the classroom, to anything the school spends tax dollars on, to anything the school says is curriculum related (except that the school’s lawyer must be clever enough to state a criterion), to anything that the school sponsors. Another sponsor said that we must judge the school’s actual practice and not its stated policy, lest schools evade application of the Act."), _c('a', {
    attrs: {
      "href": "#/#fn1-189",
      "id": "fn1_189"
    }
  }, [_c('sup', [_vm._v("189")])]), _vm._v(" A House opponent was "), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_vm._v("surely correct when he said that not even the sponsors of the bill knew what it meant.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-190",
      "id": "fn1_190"
    }
  }, [_c('sup', [_vm._v("190")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It is hard to know what courts should or will do with all this. Hatfield can be quoted to prove anything, which means he proves nothing. It is almost certainly the case that the parties to the compromise had not agreed on the meaning of “curriculum related.” But the committee reports and debate do reflect agreement on a broad legislative purpose. The committees believed that there was widespread discrimination against student religious speech."), _c('a', {
    attrs: {
      "href": "#/#fn1-191",
      "id": "fn1_191"
    }
  }, [_c('sup', [_vm._v("191")])]), _vm._v(" The lopsided majorities"), _c('a', {
    attrs: {
      "href": "#/#fn1-192",
      "id": "fn1_192"
    }
  }, [_c('sup', [_vm._v("192")])]), _vm._v(" that voted for the Act plainly wanted to end that discrimination. Such discrimination can be ended either by admitting religious speech to the schools or by excluding much of the speech now allowed in the schools. But any interpretation that largely validates the status quo is not faithful to the legislative purpose.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The sponsors clearly believed that the Equal Access Act would make a difference. They clearly believed that many schools have limited open fora. To define “noncurriculum related student group” in a way that results in almost no schools having such fora, or in a way that lets schools evade the Act by cleverly describing existing student groups, is not faithful to the legislative purpose. At the very least, limited open fora exist in schools that entertain student suggestions for the creation of new student groups. Several comments in the floor debate suggest an emphasis on whether the groups are student-initiated as the key to defining whether a limited open forum has been created."), _c('a', {
    attrs: {
      "href": "#/#fn1-193",
      "id": "fn1_193"
    }
  }, [_c('sup', [_vm._v("193")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Yet this interpretation is subject to two serious objections. The first is textual. Both phrases—“noncurriculum related” and “student-initiated”—appear in the text of the statute, and the statute makes sense if we ascribe to the two phrases their quite different ordinary meanings. We must rewrite the statute to conclude that “noncurriculum related” in § 4071(b) means the same thing as “student-initiated” in § 4071(c)(1).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The second objection is that a limitation to student-initiated groups defeats the broader purpose of the statute. A school with many faculty-initiated student groups can largely preempt demand for student-initiated groups. The result "), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_vm._v("could be an open forum for mainstream interests and views, all sponsored by the faculty, with minority views excluded because of faculty hostility or indifference.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-194",
      "id": "fn1_194"
    }
  }, [_c('sup', [_vm._v("194")])]), _vm._v(" Such a school would exclude religious groups with the ironclad excuse that the faculty could not sponsor one.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("There is also evidence that the Act’s sponsors thought they had defined “limited open forum” in a way that included virtually all schools. Indeed, some members of Congress thought the existence of a French club would trigger application of the Act."), _c('a', {
    attrs: {
      "href": "#/#fn1-195",
      "id": "fn1_195"
    }
  }, [_c('sup', [_vm._v("195")])]), _vm._v(" Senator Gorton, an opponent, thought that athletic teams and cheerleading squads would trigger the Act."), _c('a', {
    attrs: {
      "href": "#/#fn1-196",
      "id": "fn1_196"
    }
  }, [_c('sup', [_vm._v("196")])]), _vm._v(" Senator Dole, a sponsor, said that the open forum included all groups that were not “directly” related to the school’s curriculum."), _c('a', {
    attrs: {
      "href": "#/#fn1-197",
      "id": "fn1_197"
    }
  }, [_c('sup', [_vm._v("197")])]), _vm._v(" A narrow interpretation of “curriculum related” would maximize coverage, although some schools will always remain exempt unless courts accept Senator Gorton’s view that athletic teams are non-curriculum related student groups.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Maximizing coverage is fully consistent with the views of those who sought to end discrimination by allowing religious speech in the schools. This group includes conservatives who supported religious speech in particular and liberals who supported student free speech in general. Maximizing coverage is undoubtedly the interpretation desired by those most committed to the Act. But the final draft was a compromise; presumably, some of the supporters went along grudgingly, or cared only about ending discrimination and expected that schools would be able to close their limited fora after the Act was passed."), _c('a', {
    attrs: {
      "href": "#/#fn1-198",
      "id": "fn1_198"
    }
  }, [_c('sup', [_vm._v("198")])]), _vm._v(" Representative Pepper thought that the sponsors would be disappointed because most schools did not have open fora."), _c('a', {
    attrs: {
      "href": "#/#fn1-199",
      "id": "fn1_199"
    }
  }, [_c('sup', [_vm._v("199")])]), _vm._v(" My best sense "), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_vm._v("of common ground in the legislative history is that closing a limited forum should be possible, but not cost-free.")])]), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("More than one interpretation of “curriculum related” is legitimately open to the courts. The best interpretation is the one that Senator Hatfield volunteered before he got entangled in Senator Gorton’s cross-examination: curriculum-related groups are those that are an extension of the classroom. That is what the statutory language seems to say, and that interpretation achieves the purposes of the sponsors and avoids the risk of abuse inherent in distinguishing between student-initiated and faculty-initiated groups. If a group is sponsored by a teacher who teaches a closely related course, and if nearly all the members of the group take that course, then the group is curriculum related, and its existence does not trigger any obligation to recognize other groups.")]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_c('strong', [_c('em', [_vm._v("b. Some Problematic Cases")])]), _vm._v(".—That still leaves some problematic cases in which an inquiry focusing on relationship to the curriculum will produce results that are counterintuitive to many judges and probably to many of the legislators who voted for the Act. The relationship between athletic teams and the physical education curriculum is tenuous at best, especially when the coach is a history teacher. But athletic teams generally do not engage in speech or expression and do not appear to create limited public fora. Thus, it is defensible in terms of statutory policy to say that all athletic teams are curriculum related.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_vm._v("Activities devoted to expression are more problematic. The debate team, the drama club, the band, and the chorus may or may not be linked to a class in speech, theater, or music. But even if these activities are wholly extracurricular, there is an argument that they are more like athletic teams than like open fora. All are under the direct supervision of a faculty coach or director who has legitimate reasons, unrelated to censorship, for closely controlling student expression in these activities. The play cast, the band, and the chorus must all cooperate to produce a single play or concert; the play and the music are typically selected by the faculty director. Thus, school plays and concerts are plausibly viewed as official expression of the school rather than private expression of students.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-200",
      "id": "fn1_200"
    }
  }, [_c('sup', [_vm._v("200")])]), _vm._v(" A competitive debate team must debate the topic selected by the state’s high school association and take the side assigned by the tournament schedule or coin toss. It is free to create its own arguments for that side, but the expression is so channeled that it is hard to treat the debate team as creating a limited open forum.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_vm._v("That rationale does not fit contestants in an oratory contest who do pick their own topics. That the orator represents the school in an interschool competition does not make his speech an official school speech; many schools probably would deny endorsing the substantive positions taken by their contestants. Still, it is wildly counterintuitive to say that the debate team is curriculum related but the oratory team is not. The sense that all contestants compete on behalf of the school probably has something to do with that intuition. Perhaps a plausible rule is that no forum is established by any school-sponsored entry into a competition sponsored by an association of high schools.")])]), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("These suggestions take us increasingly far from the statutory test—whether the group is curriculum related. The purpose of that test is to identify the existence of a limited open forum, and courts can consider that purpose in construing the statute. But “limited open forum” is a defined term; such a forum exists at any school with one or more non-curriculum-related student groups. If courts manipulate “curriculum related” to fit their own concept of limited open forum, they effectively repeal the statutory definition. There is much to be said for asking only whether an activity is related to a course in the curriculum, and for answering that the school play and the football team are not. But I suspect that many courts would instinctively decide that neither the play nor the football team should trigger application of the Act. The reasons for that instinct must be identified so that the Act is not swallowed by exceptions that start with the school play and expand to cover any extracurricular activity that a school is reluctant to abolish.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_vm._v("The school paper and the yearbook are activities for which a pure “curriculum-related” test works well. These publications are sometimes in-class projects of an art or journalism class, and sometimes extracurricular outlets for student expression. This difference has been treated as an issue of fact in some of the censorship cases litigated under the First Amendment;")]), _c('a', {
    attrs: {
      "href": "#/#fn1-201",
      "id": "fn1_201"
    }
  }, [_c('sup', [_vm._v("201")])]), _vm._v(" the same treatment is appropriate under the Equal Access Act. An in-class publication should not trigger the Act; a freestanding publication should.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("If we concede that football does not count, student government is probably the most widespread non-curriculum-related activity. Student government is "), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_vm._v("sometimes thought of as a model for teaching students about democracy, but that is not enough to make it curriculum related. If “curriculum related” were watered down to “educational,” nearly all student clubs would qualify. I suspect it is a rare school where student government has any direct relationship to a course in civics or government. Absent such a relationship, student government should trigger application of the Equal Access Act.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-202",
      "id": "fn1_202"
    }
  }, [_c('sup', [_vm._v("202")])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_c('strong', [_c('em', [_vm._v("c. A Statutory Glitch")])]), _vm._v(".—Senator Gorton’s cross-examination of Senator Hatfield also uncovered another troubling issue. Section 4071(c) sets out five criteria for equal access; a school “shall be deemed to offer a fair opportunity” to meet if it complies with these five criteria."), _c('a', {
    attrs: {
      "href": "#/#fn1-203",
      "id": "fn1_203"
    }
  }, [_c('sup', [_vm._v("203")])]), _vm._v(" The five criteria are of two quite different kinds. The first three arise from Establishment Clause restrictions on religious meetings: the meeting must be voluntary and student initiated, there can be no sponsorship by the school, and school employees cannot participate. The other two criteria protect legitimate interests of the school: the meeting may not interfere with education, and nonschool persons may not regularly attend. The school need not be required to impose these last two criteria, but most schools would probably want to impose them on all groups, secular as well as religious.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Act should say that schools must impose the first three criteria on religious groups, and that they may apply any of the criteria to all groups. Unfortunately, the first three criteria and the last two criteria are tacked on to the same introductory clause, even though they are wildly nonparallel. Most troubling, the introductory clause says that the school has offered a fair opportunity to meet if it “uniformly provides” for these five criteria. The restriction on participation by school employees applies by its own terms only to religious meetings. But there is no similar qualifier in the requirement that meetings be student initiated and without school sponsorship. Read literally, the effect is to "), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_vm._v("apply to all meetings two criteria that are essential only to religious meetings. That is, the statute seems to say that Petros has been offered a fair opportunity to meet only if the school “uniformly provides” that non-curriculum-related student meetings are student initiated and without school sponsorship.")])]), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_vm._v("Any court interested in avoiding absurd results would recognize this as a statutory glitch.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-204",
      "id": "fn1_204"
    }
  }, [_c('sup', [_vm._v("204")])]), _vm._v(" There is no federal interest in forbidding schools to sponsor any group not related to the curriculum."), _c('a', {
    attrs: {
      "href": "#/#fn1-205",
      "id": "fn1_205"
    }
  }, [_c('sup', [_vm._v("205")])]), _vm._v(" Surely what Congress meant to say is that student religious groups must be student initiated and without school sponsorship, and a group like Petros cannot complain that the lack of school sponsorship denies it a fair opportunity to meet. It is bizarre to provide that school sponsorship of the chess club denies Petros a fair opportunity to meet. “Uniformly” is one of those misleading statutory modifiers—like the misplaced negative in the Communications Act"), _c('a', {
    attrs: {
      "href": "#/#fn1-206",
      "id": "fn1_206"
    }
  }, [_c('sup', [_vm._v("206")])]), _vm._v(" and “otherwise” in the Rehabilitation Act"), _c('a', {
    attrs: {
      "href": "#/#fn1-207",
      "id": "fn1_207"
    }
  }, [_c('sup', [_vm._v("207")])]), _vm._v("—that even a firmly committed textualist will ignore in the interest of sensible construction."), _c('a', {
    attrs: {
      "href": "#/#fn1-208",
      "id": "fn1_208"
    }
  }, [_c('sup', [_vm._v("208")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Unfortunately, Senator Gorton got Senator Hatfield to say that “uniformly” means exactly what it says."), _c('a', {
    attrs: {
      "href": "#/#fn1-209",
      "id": "fn1_209"
    }
  }, [_c('sup', [_vm._v("209")])]), _vm._v(" Hatfield said that the restrictions in § 4071(c) "), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_vm._v("apply to all groups in the school’s open forum, but not to curriculum-related groups. So the school still can sponsor the football team, but it no longer can sponsor the chess club. Hatfield’s interpretation pulls the chess club into the same net with Petros and other religious organizations. If his interpretation is taken to be authoritative, it creates enormous pressures to hold that every existing student group is curriculum related, lest it lose its faculty sponsors and be left with a nonparticipating monitor. But if all existing groups are curriculum related, there is no open forum, and the Act does not apply. And if there are one or two groups that the school cannot somehow claim as curriculum related, it will be much easier to abolish them to avoid the Act than it would be to abolish ten or twenty non-curriculum-related groups to avoid the Act.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-210",
      "id": "fn1_210"
    }
  }, [_c('sup', [_vm._v("210")])]), _vm._v(" No wonder Ruti Teitel reads this provision literally."), _c('a', {
    attrs: {
      "href": "#/#fn1-211",
      "id": "fn1_211"
    }
  }, [_c('sup', [_vm._v("211")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Courts and conscientious school administrators should probably take a deep breath and ignore both Hatfield and the statutory text. Otherwise, the statute completely fails to serve its purpose. A broad spectrum of groups involved in debate over the Act has agreed that “Congress did not intend to prohibit teacher participation in nonreligious student meetings.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-212",
      "id": "fn1_212"
    }
  }, [_c('sup', [_vm._v("212")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_vm._v("But there is also a technical solution, at least for courts. By following ordinary standing rules, courts can avoid an absurd interpretation of the Act and occasionally apply this provision sensibly. No one has standing to complain that the school is sponsoring the chess club. It is impossible to identify any intended beneficiary of such a prohibition, or anyone who is injured in fact by its violation. But if a school district sponsors the Young Democrats and refuses to sponsor the Young Republicans, the Young Republicans might have a legitimate complaint about this unequal treatment. Section 4071(c) might plausibly be read to address that complaint. The Young Republicans could argue that they were denied a fair opportunity to meet because the school had no uniform policy with respect to sponsorship of non-curriculum-related groups. The only remedy on the face of the statute would be to enjoin sponsorship of the Young Democrats. But if the school began to sponsor both groups, standing would disappear, and the court would have no further reason to interfere.")])]), _c('a', {
    attrs: {
      "id": "page_56"
    }
  }), _c('p', {
    staticClass: "HPara"
  }, [_c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_c('strong', [_vm._v("2. The Constitutional Meaning of Open or Public Forum.")]), _vm._v("—Any school that does not have a limited open forum as defined in the Equal Access Act remains vulnerable to a constitutional claim. Perhaps there are some rare configurations of student organizations that give rise to constitutional open fora even though they do not give rise to statutory open fora. Or perhaps some junior high schools have established open fora even though the statute does not apply to them.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-213",
      "id": "fn1_213"
    }
  }, [_c('sup', [_vm._v("213")])]), _vm._v(" Much more important, perhaps schools are inherently open fora. That is, the First Amendment may require schools to establish open fora even though they would prefer not to."), _c('a', {
    attrs: {
      "href": "#/#fn1-214",
      "id": "fn1_214"
    }
  }, [_c('sup', [_vm._v("214")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This possibility requires a brief excursion into the Supreme Court’s recent public forum cases. A concept that once was reasonably clear has become obscured by increasingly ill-fitting doctrine. It seems unlikely that the Court will be able to live with the lines it has drawn, because the existing doctrine is inherently unstable. But the three categories of fora reviewed in "), _c('em', [_vm._v("Cornelius v. NAACP Legal Defense & Education Fund")]), _c('a', {
    attrs: {
      "href": "#/#fn1-215",
      "id": "fn1_215"
    }
  }, [_c('sup', [_vm._v("215")])]), _vm._v(" provide a starting point.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("“Traditional public fora” are places devoted to speech and assembly by “long tradition or by government fiat.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-216",
      "id": "fn1_216"
    }
  }, [_c('sup', [_vm._v("216")])]), _vm._v(" The recurring examples are streets and parks. Speakers can be excluded from traditional public fora “only when "), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_vm._v("the exclusion is necessary to serve a compelling state interest and the exclusion is narrowly drawn to achieve that interest.”")]), _c('a', {
    attrs: {
      "href": "#/#fn1-217",
      "id": "fn1_217"
    }
  }, [_c('sup', [_vm._v("217")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("“Limited public fora” are fora designated by the government “for use by the public at large for assembly and speech, for use by certain speakers, or for the discussion of certain subjects.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-218",
      "id": "fn1_218"
    }
  }, [_c('sup', [_vm._v("218")])]), _vm._v(" The existence of a limited public forum is said to depend on the government’s intention to create it, and the designation of a limited public forum is revocable. But while the limited forum exists, only a compelling state interest can justify the exclusion of speakers who fall within the group for whom the forum exists and who wish to address a topic for which the forum exists.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Any other government property or channel of communication is apparently a “nonpublic forum.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-219",
      "id": "fn1_219"
    }
  }, [_c('sup', [_vm._v("219")])]), _vm._v(" The government can exclude speakers from nonpublic fora so long as the restrictions are “reasonable and not an effort to suppress expression merely because public officials oppose the speaker’s view.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-220",
      "id": "fn1_220"
    }
  }, [_c('sup', [_vm._v("220")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The most troubling thing about this three-category formulation is that censorship can become self-justifying in the second and third categories. The implication is that the government can convert a limited public forum to a nonpublic forum without any reason whatever, or even because of hostility to speech. The government’s intention to close or limit the forum may be shown by evidence that it has excluded speakers in the past."), _c('a', {
    attrs: {
      "href": "#/#fn1-221",
      "id": "fn1_221"
    }
  }, [_c('sup', [_vm._v("221")])]), _vm._v(" A choice to close the limited public forum is not constrained by a requirement that all speech be treated equally; the government can allow some speakers into a nonpublic forum while excluding others."), _c('a', {
    attrs: {
      "href": "#/#fn1-222",
      "id": "fn1_222"
    }
  }, [_c('sup', [_vm._v("222")])]), _vm._v(" Thus, outside the traditional public forum, the only real protection is that exclusion of speech must be reasonable and not motivated by hostility to the views expressed. And the Court’s application of that test has been deferential."), _c('a', {
    attrs: {
      "href": "#/#fn1-223",
      "id": "fn1_223"
    }
  }, [_c('sup', [_vm._v("223")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_vm._v("It makes little sense to apply the compelling interest test to a category of cases and then let the government opt out of the category at will. The limited public forum category needs to be remodeled in a way that provides more protection for speech. "), _c('em', [_vm._v("Cornelius")]), _vm._v(" did not purport to overrule earlier cases that examined the weight and legitimacy of the government’s need to exclude private speakers from particular public property.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-224",
      "id": "fn1_224"
    }
  }, [_c('sup', [_vm._v("224")])]), _vm._v(" If most of those cases are still good law, then the three-category formulation must be revised to explain all the cases.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("One such earlier case is "), _c('em', [_vm._v("Tinker v. Des Moines Independent Community School District")]), _vm._v(","), _c('a', {
    attrs: {
      "href": "#/#fn1-225",
      "id": "fn1_225"
    }
  }, [_c('sup', [_vm._v("225")])]), _vm._v(" which upheld high school and junior high school students’ right to wear black armbands to protest the Vietnam War. The dissent in "), _c('em', [_vm._v("Cornelius")]), _vm._v(" found the majority’s opinion inconsistent with "), _c('em', [_vm._v("Tinker")]), _vm._v("."), _c('a', {
    attrs: {
      "href": "#/#fn1-226",
      "id": "fn1_226"
    }
  }, [_c('sup', [_vm._v("226")])]), _vm._v(" I think that the dissent is wrong; "), _c('em', [_vm._v("Cornelius")]), _vm._v(" is simply inapplicable to "), _c('em', [_vm._v("Tinker")]), _vm._v(". But comparing "), _c('em', [_vm._v("Tinker")]), _vm._v(" to the equal access cases in light of the Court’s three new categories will illuminate the equal access issue and expose some of the problems with the Court’s categories.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('em', [_vm._v("Cornelius")]), _vm._v(" is inapplicable to "), _c('em', [_vm._v("Tinker")]), _vm._v(" because "), _c('em', [_vm._v("Tinker")]), _vm._v(" did not involve a question of access to public property. When citizens claim a right to enter government "), _c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_vm._v("property for the particular purpose of speaking, it is relevant to ask whether other speakers have been allowed the same privilege, or whether the property is especially appropriate for speech. The various versions of the public forum doctrine address these questions. But public forum analysis is irrelevant when access is not at issue. When citizens are going about their business in a place they are entitled to be, they are presumptively entitled to speak.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-227",
      "id": "fn1_227"
    }
  }, [_c('sup', [_vm._v("227")])]), _vm._v(" Because students were indisputably entitled to be on the school grounds, the only question in "), _c('em', [_vm._v("Tinker")]), _vm._v(" was whether the school had a constitutionally sufficient reason to suppress their speech. The Court’s requirement that the school show a material and substantial interference with the educational function is addressed to that question.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('em', [_vm._v("Tinker")]), _vm._v(" thus protects the right to speak in the halls and on the school grounds—in all the students’ free time when the school is not presenting its own messages. It protects the right to nondisruptive expression such as buttons and armbands, even in class. Religious speech is included in these rights, and these rights have nothing to do with the school’s status as a public forum. "), _c('em', [_vm._v("Tinker")]), _vm._v(" did not hold that the school had created a public forum."), _c('a', {
    attrs: {
      "href": "#/#fn1-228",
      "id": "fn1_228"
    }
  }, [_c('sup', [_vm._v("228")])]), _vm._v(" The decision certainly did not depend on the school’s intention. Rather, "), _c('em', [_vm._v("Tinker")]), _vm._v(" held that the Constitution protected the students’ right to speak, a right that was not contingent on whether the school had allowed others to speak.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Requests to meet in schoolrooms before or after classes do present a question of access to public property. Schools that deny such requests do not suppress speech among students who would have been in the rooms anyway. Rather, they deny the use of the rooms to students who have no reason or desire to be there if they cannot hold a meeting.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("If these cases are forced into one of the Court’s three new categories, schools fit only in the relatively unprotected category of nonpublic fora. Schools are not traditional public fora because they are not open to the entire population. The more sensible view is that schools are open fora for students and faculty. In such fora, students and faculty are free to speak on any topic, and the rest of the world can be excluded."), _c('a', {
    attrs: {
      "href": "#/#fn1-229",
      "id": "fn1_229"
    }
  }, [_c('sup', [_vm._v("229")])]), _vm._v(" But in the Court’s three new categories, a forum "), _c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_vm._v("limited to students and faculty can exist only if the government intends to create it.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-230",
      "id": "fn1_230"
    }
  }, [_c('sup', [_vm._v("230")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("There is an arbitrary mixing of analytic categories here. That the forum is limited to students and faculty has no relationship in logic or policy to whether the forum is permanent or revocable, or to whether the forum exists by constitutional entitlement or by the school’s volition. That the limitation to students and faculty should seem to control these other unrelated issues is an arbitrary and unexamined consequence of the three categories in "), _c('em', [_vm._v("Cornelius")]), _vm._v("."), _c('a', {
    attrs: {
      "href": "#/#fn1-231",
      "id": "fn1_231"
    }
  }, [_c('sup', [_vm._v("231")])]), _vm._v(" The consequence is unexamined because it has never actually arisen in a Supreme Court case."), _c('a', {
    attrs: {
      "href": "#/#fn1-232",
      "id": "fn1_232"
    }
  }, [_c('sup', [_vm._v("232")])]), _vm._v(" This part of the description of the three categories exists only in dictum.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("School authorities who are sued will surely deny that they intended to create a limited public forum, especially now that a Supreme Court opinion appears to make such a self-serving denial so efficacious. Even if a school does have a limited public forum, "), _c('em', [_vm._v("Cornelius")]), _vm._v(" implies that the school can close it at will. But that is inconsistent with the Court’s repeated recognition that schools are especially the marketplace of ideas."), _c('a', {
    attrs: {
      "href": "#/#fn1-233",
      "id": "fn1_233"
    }
  }, [_c('sup', [_vm._v("233")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The "), _c('em', [_vm._v("Cornelius")]), _vm._v(" majority did not mention "), _c('em', [_vm._v("Tinker")]), _vm._v(". It did undertake to explain "), _c('em', [_vm._v("Widmar v. Vincent")]), _vm._v(", the university religious speech case. The Court tried to shoehorn "), _c('em', [_vm._v("Widmar")]), _vm._v(" into its limited public forum category; it almost, but not quite, succeeded."), _c('a', {
    attrs: {
      "href": "#/#fn1-234",
      "id": "fn1_234"
    }
  }, [_c('sup', [_vm._v("234")])]), _vm._v(" But the Court’s description of "), _c('em', [_vm._v("Widmar")]), _vm._v(" went further: “Additionally, "), _c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_vm._v("we noted that a university campus, at least as to its students, possesses many of the characteristics of a traditional public forum.”")]), _c('a', {
    attrs: {
      "href": "#/#fn1-235",
      "id": "fn1_235"
    }
  }, [_c('sup', [_vm._v("235")])]), _vm._v(" This formulation gets closer to the essence of "), _c('em', [_vm._v("Widmar")]), _vm._v(" and to the view of the schools espoused in "), _c('em', [_vm._v("Tinker")]), _vm._v(". The essential characteristic of what the Court now calls a traditional public forum is that it is inherently a forum—that is, a place so appropriate for free speech that the government cannot deny access for the purpose of speech. For students and faculty, schools would seem to be such a place. The Court will have a chance to clarify the law of traditional public fora this Term."), _c('a', {
    attrs: {
      "href": "#/#fn1-236",
      "id": "fn1_236"
    }
  }, [_c('sup', [_vm._v("236")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Teitel argues that a high school never can be an open forum, because the educational function requires the school to control so much of the speech that goes on there."), _c('a', {
    attrs: {
      "href": "#/#fn1-237",
      "id": "fn1_237"
    }
  }, [_c('sup', [_vm._v("237")])]), _vm._v(" That is equally true in universities. Any educational institution must control the agenda of its classes and other instructional periods. But as the cases hold, that necessity justifies only those restraints on speech that are needed to protect the educational process from disruption."), _c('a', {
    attrs: {
      "href": "#/#fn1-238",
      "id": "fn1_238"
    }
  }, [_c('sup', [_vm._v("238")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Even so, none of the cases finding traditional or inherent open fora involved a right to hold regular meetings that the school would have to monitor."), _c('a', {
    attrs: {
      "href": "#/#fn1-239",
      "id": "fn1_239"
    }
  }, [_c('sup', [_vm._v("239")])]), _vm._v(" Given the disruption and violence in some of our public schools, the Court is unlikely to hold that high school students have a constitutional right to meet on school property without a monitor. And the Court might be reluctant to hold that the First Amendment requires schools to provide monitors for every student organization that requests one. But that is more a prediction about the present Court than a normative judgment. If the Court is serious "), _c('a', {
    attrs: {
      "id": "page_62"
    }
  }, [_vm._v("about the role of schools as a natural site for the free exchange of ideas, then the minor expense of monitors for student meetings should not be sufficient to deny the right to meet. Schools could minimize the expense by having one monitor circulate among adjacent rooms during a scheduled student activity period, or by recruiting parents as volunteer monitors. Just as the expense of cleaning up litter does not justify a ban on leafleting in the streets,")]), _c('a', {
    attrs: {
      "href": "#/#fn1-240",
      "id": "fn1_240"
    }
  }, [_c('sup', [_vm._v("240")])]), _vm._v(" and the expense of police protection does not justify a ban on parades and demonstrations,"), _c('a', {
    attrs: {
      "href": "#/#fn1-241",
      "id": "fn1_241"
    }
  }, [_c('sup', [_vm._v("241")])]), _vm._v(" the expense of supervising students should not justify a ban on student organizations in the public schools. It also has been suggested that the state can charge private groups for the expense of using public facilities, further minimizing the state’s interest in denying a forum."), _c('a', {
    attrs: {
      "href": "#/#fn1-242",
      "id": "fn1_242"
    }
  }, [_c('sup', [_vm._v("242")])]), _vm._v(" In the case of high school students, this could include the cost of monitors.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("If the Court holds that schools are inherently open fora for student organizations, then a wide range of student groups, including student religious groups, could meet at every public school in the land. If the Court holds that there is an open forum for student organizations only at schools that create such a forum, much litigation would be required to identify the schools with open fora under either the statute or the Constitution. The end result would be that some schools have open fora and some do not, and that student religious groups could be excluded from those that do not. The religious right would be unhappy with that result. But so long as the rules were administered without discrimination against religious speech and without distortion by fear that neutrality would be misunderstood as support, the grievance of student religious groups would be no different from that of any other excluded group. In schools that avoided creating an open forum, the loss would be to student speech rights generally, not to religious speech rights in particular.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec5bi"
  }, [_c('a', {
    attrs: {
      "id": "page_63"
    }
  }, [_c('strong', [_c('em', [_vm._v("B. Junior High and Elementary Schools")])])])]), _c('a', {
    attrs: {
      "id": "page_63"
    }
  }), _c('p', {
    staticClass: "HPara"
  }, [_c('a', {
    attrs: {
      "id": "page_63"
    }
  }, [_vm._v("The Equal Access Act applies to high schools, and arguably to junior high schools in some states.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-243",
      "id": "fn1_243"
    }
  }, [_c('sup', [_vm._v("243")])]), _vm._v(" Therefore, the claims of all or most junior high students and all elementary students must be addressed under the Constitution. Whether the school has created an open forum depends on the constitutional definition of open forum; it is not enough to show the existence of one non-curriculum-related group.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Junior high schools are less likely than high schools to create an open forum, and hardly any elementary schools will have open fora. But when a junior high or elementary school does create an open forum, there is no reason to distinguish it from a high school."), _c('a', {
    attrs: {
      "href": "#/#fn1-244",
      "id": "fn1_244"
    }
  }, [_c('sup', [_vm._v("244")])]), _vm._v(" Exclusion of religious speech is still discriminatory and hostile to religion. The argument for exclusion still depends on the premise that government approves of everything it does not censor. Junior high school students have somewhat less ability than high school students to understand the premises of an open forum, and elementary school students have even less ability. But their ability to understand that exclusion of religion reflects disestablishment rather than hostility is diminished to the same degree. The argument that students cannot understand still leads to the same contradiction and is still soluble by the same facially neutral rules. Student maturity goes to whether the school should create an open forum in the first place. It cannot justify excluding religion from a forum that a school voluntarily creates.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Student maturity is more relevant to claims that junior high and elementary schools are inherently open fora. I am confident that even elementary school students have a right to free speech on their own time—in the halls, cafeterias, and playgrounds. The Supreme Court so held with respect to junior high students in "), _c('em', [_vm._v("Tinker")]), _vm._v("."), _c('a', {
    attrs: {
      "href": "#/#fn1-245",
      "id": "fn1_245"
    }
  }, [_c('sup', [_vm._v("245")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("On the other hand, my intuition is that elementary school students certainly, and junior high school students probably, have no constitutional right to an open forum for extracurricular groups with time and space to meet on "), _c('a', {
    attrs: {
      "id": "page_64"
    }
  }, [_vm._v("school property.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-246",
      "id": "fn1_246"
    }
  }, [_c('sup', [_vm._v("246")])]), _vm._v(" Two reasons support this distinction between group meetings and individual speech. First, the organizational capacities of students at that level are so limited that an open forum of student-initiated groups is illusory. By contrast, individual student speech is real, and the right to it may be strongly felt. Second, the school’s interest in not supervising extracurricular groups is legitimate, even if the burden is small. But its interest in silencing speech on school grounds is an interest in censorship pure and simple.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But this is an aside. Identifying the free speech rights of younger students involves a classic line-drawing problem, and that line is not the subject of this Article. The only proposition to which I am committed is this: Wherever the line is drawn, it must be drawn neutrally with respect to religion. At whatever age the schools or the courts accord students freedom of secular speech, they must accord equal freedom of religious speech.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec5bi"
  }, [_c('strong', [_c('em', [_vm._v("C. The Risk of Abuse")])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("The American Civil Liberties Union opposed early drafts of the Equal Access Act that protected only religious speech. It took no position on the Hatfield compromise, which protected all student speech from content discrimination. The ACLU remained “suspicious” of the enacted legislation,"), _c('a', {
    attrs: {
      "href": "#/#fn1-247",
      "id": "fn1_247"
    }
  }, [_c('sup', [_vm._v("247")])]), _vm._v(" and it began a project with the American Jewish Congress to monitor implementation."), _c('a', {
    attrs: {
      "href": "#/#fn1-248",
      "id": "fn1_248"
    }
  }, [_c('sup', [_vm._v("248")])]), _vm._v(" Subsequently, the ACLU’s biennial conference opposed the Act as “a flagrant violation of the Establishment Clause.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-249",
      "id": "fn1_249"
    }
  }, [_c('sup', [_vm._v("249")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The ACLU’s fears of improper implementation should not have produced hostility to a statute that on its face is a great victory for civil liberties. But it is good that someone plans to police implementation. The impetus for the Equal Access Act came from a political sector that traditionally is hostile both to the Establishment Clause and to the Free Speech Clause. The religious right proposed the statute only when its own speech rights were systematically violated. To get statutory relief, it had to protect the speech rights of everyone else as well, and it had to build in safeguards against violations of the Establishment Clause. Now that the benefits of the bargain are embodied in the United States "), _c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_vm._v("Code, it would not be surprising if some in the religious right tried to renege on the consideration. Two kinds of abuse are foreseeable.")])]), _c('a', {
    attrs: {
      "id": "page_65"
    }
  }), _c('p', {
    staticClass: "HPara"
  }, [_c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_c('strong', [_vm._v("1. School Sponsorship of Religious Groups.")]), _vm._v("—The first potential abuse is school sponsorship of student religious groups. Schools that never have accepted the ban on school-sponsored prayer might encourage or even coerce participation in student prayer groups. Evidence of precisely this abuse colored "), _c('em', [_vm._v("Lubbock Civil Liberties Union v. Lubbock Independent School District")]), _vm._v(",")]), _c('a', {
    attrs: {
      "href": "#/#fn1-250",
      "id": "fn1_250"
    }
  }, [_c('sup', [_vm._v("250")])]), _vm._v(" the first court of appeals decision against equal access at the high school level. Such sponsorship clearly violates both the Constitution and the Equal Access Act. Ruti Teitel is certainly right when she says that student initiation of religious speech does not justify subsequent government sponsorship."), _c('a', {
    attrs: {
      "href": "#/#fn1-251",
      "id": "fn1_251"
    }
  }, [_c('sup', [_vm._v("251")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But identifying who initiates religious speech may be relevant to determining the remedy. A sufficient remedy for noncoercive endorsement of student-initiated groups would be to enjoin further sponsorship. Any remedy aimed at the student groups themselves would leave such groups vulnerable to school officials, who could render them unconstitutional with unwanted endorsements. But when the school creates the student organization in the first place, or coerces students to attend, the presumptive remedy would be to enjoin the sponsored organization from meeting, just as we decertify sweetheart unions with improper company sponsorship."), _c('a', {
    attrs: {
      "href": "#/#fn1-252",
      "id": "fn1_252"
    }
  }, [_c('sup', [_vm._v("252")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Enforcement will never be perfect; it will not always be easy to discover and prove sponsorship by school officials."), _c('a', {
    attrs: {
      "href": "#/#fn1-253",
      "id": "fn1_253"
    }
  }, [_c('sup', [_vm._v("253")])]), _vm._v(" On the other hand, there is little incentive for such abuse. Evangelical students have been quite aggressive about creating their own organizations, and any minister can encourage a devout student to organize a voluntary religious group. The origins of these groups are quite independent of the school administration. Even from the perspective of the religious right, there is no reason to jeopardize the group with school sponsorship when it can function well without it. The religious right will continue its campaign for school-sponsored prayer in the classroom, but potentially "), _c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_vm._v("fatal school sponsorship of otherwise legal extracurricular groups is not a likely vehicle.")])]), _c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_c('p', {
    staticClass: "HPara"
  }, [_c('strong', [_vm._v("2. Exclusion of Unpopular Groups.")]), _vm._v("—The second form of potential abuse is discrimination against other groups applying for access to the school’s open forum. The Lubbock Independent School District may happily recognize the Student Christian Fellowship and refuse to recognize the Students for Nuclear Disarmament or the Student Gay Rights Club. That sort of discrimination presents a straightforward dispute that is easy to police. The excluded group can sue for permission to meet. Such a case is no different from the Williamsport school’s recognition of the student Audubon Society and refusal to recognize Petros.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_vm._v("There may be some hard issues at the fringes. The congressional debate is full of argument about whether schools would have to tolerate gay rights groups, paramilitary groups, hate groups, unpopular religious groups, or extreme political groups.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-254",
      "id": "fn1_254"
    }
  }, [_c('sup', [_vm._v("254")])]), _vm._v(" Senator Hatfield was almost as erratic on this issue as he was on the definition of “curriculum related.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-255",
      "id": "fn1_255"
    }
  }, [_c('sup', [_vm._v("255")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Some of these hard cases will actually arise; many will not. The Ku Klux Klan or the Hare Krishnas cannot send a solicitor to the school and claim protection under the Equal Access Act. A group can invoke the Act only if student members of the group seek to form a student organization; most extreme or deviant groups will have no high school members. When such groups do arise, their right to meet should be protected."), _c('a', {
    attrs: {
      "href": "#/#fn1-256",
      "id": "fn1_256"
    }
  }, [_c('sup', [_vm._v("256")])]), _vm._v(" But "), _c('em', [_vm._v("Brandenburg v. Ohio")]), _c('a', {
    attrs: {
      "href": "#/#fn1-257",
      "id": "fn1_257"
    }
  }, [_c('sup', [_vm._v("257")])]), _vm._v(" is not the standard in the public high schools. Courts are somewhat less protective of student speech rights than of adult speech rights. The courts of appeals have been dealing with these issues since "), _c('em', [_vm._v("Tinker")]), _vm._v(","), _c('a', {
    attrs: {
      "href": "#/#fn1-258",
      "id": "fn1_258"
    }
  }, [_c('sup', [_vm._v("258")])]), _vm._v(" and they will not be any more difficult under the Equal Access Act.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("There is room for reasonable disagreement here. Excluding a few extremist organizations is not desirable, but neither does it turn the Equal Access Act into "), _c('a', {
    attrs: {
      "id": "page_67"
    }
  }, [_vm._v("a front for religion. The perceived dangers of a Ku Klux Klan chapter in a high school undergoing court-ordered desegregation are different in kind from the perceived dangers of a student religious group in the same high school. A thoroughgoing commitment to free speech would allow both to meet, but there is no inconsistency in deciding that the dangers of violence and race hatred justify censorship while the dangers of mistaken attribution do not.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-259",
      "id": "fn1_259"
    }
  }, [_c('sup', [_vm._v("259")])]), _vm._v(" The fear that students will think the school endorses everything it fails to censor strikes at the heart of the First Amendment. Exclusion of extremists strikes at the margins.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("What schools plainly cannot do is to restrict their open fora to only those groups whose goals they approve. Including the prayer club while excluding the disarmament club would be an abuse by any standard. But it is a highly visible abuse that is easily policed. The solution to such problems is not to exclude religious groups from the open forum, but to police the implementation of equal access.")]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_c('strong', [_vm._v("3. Religious Worship on School Property.")]), _vm._v("—Some have expressed the view that a worship service is different from other religious speech and that student religious groups should not be permitted to worship even if they are permitted to meet."), _c('a', {
    attrs: {
      "href": "#/#fn1-260",
      "id": "fn1_260"
    }
  }, [_c('sup', [_vm._v("260")])]), _vm._v(" But the distinction is untenable. To let these groups meet and then censor their meetings would be the worst possible result.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The argument has been explored before. Justice White’s dissent in "), _c('em', [_vm._v("Widmar")]), _vm._v(" insisted that religious worship is a special category of religious speech, completely unprotected by the Free Speech Clause and excludable from a public forum at the government’s option."), _c('a', {
    attrs: {
      "href": "#/#fn1-261",
      "id": "fn1_261"
    }
  }, [_c('sup', [_vm._v("261")])]), _vm._v(" Justice White thought that worship is protected only by the Free Exercise Clause, that the Free Exercise and Establishment Clauses give rise to conflicting arguments about the right to worship in a public forum, and that resolution of that conflict is left to the political branches."), _c('a', {
    attrs: {
      "href": "#/#fn1-262",
      "id": "fn1_262"
    }
  }, [_c('sup', [_vm._v("262")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The majority responded incredulously to Justice White’s distinction between worship and other religious speech."), _c('a', {
    attrs: {
      "href": "#/#fn1-263",
      "id": "fn1_263"
    }
  }, [_c('sup', [_vm._v("263")])]), _vm._v(" First, they thought the distinction "), _c('a', {
    attrs: {
      "id": "page_68"
    }
  }, [_vm._v("lacked “intelligible content.”")]), _c('a', {
    attrs: {
      "href": "#/#fn1-264",
      "id": "fn1_264"
    }
  }, [_c('sup', [_vm._v("264")])]), _vm._v(" They were surely right. The content of worship varies from religion to religion, but a least-common-denominator definition would be that worship is an expression of reverence for, or devotion to, a deity. This suggests that worship is more a state of mind or mode of thought than a category of speech. A sermon, a hymn, a scripture reading, or even a prayer, will sometimes be worship and sometimes not, depending partly on close analysis of its content, partly on the speaker’s mental state, and partly on his theology.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The majority’s second point had even more force: they argued that even if a distinction between worship and other religious speech could be drawn and administered, the government is constitutionally incompetent to draw it."), _c('a', {
    attrs: {
      "href": "#/#fn1-265",
      "id": "fn1_265"
    }
  }, [_c('sup', [_vm._v("265")])]), _vm._v(" Forbidding worship while allowing other religious speech would require secular officials to categorize all religious speech as either worship or nonworship. But assessing the theological significance of subcategories of religious speech is plainly a religious question properly reserved to religious authorities."), _c('a', {
    attrs: {
      "href": "#/#fn1-266",
      "id": "fn1_266"
    }
  }, [_c('sup', [_vm._v("266")])]), _vm._v(" The Religion Clauses sometimes require courts to make sensitive religious determinations, but doctrines should not be structured in ways that maximize the difficulty."), _c('a', {
    attrs: {
      "href": "#/#fn1-267",
      "id": "fn1_267"
    }
  }, [_c('sup', [_vm._v("267")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The majority in "), _c('em', [_vm._v("Widmar")]), _vm._v(" had a third response to Justice White’s distinction. Even assuming there was some Establishment Clause value at stake, the majority could see no reason to distinguish religious worship from other religious speech. The majority did not see why worship should be less protected than the proselytizing in "), _c('em', [_vm._v("Heffron")]), _vm._v("."), _c('a', {
    attrs: {
      "href": "#/#fn1-268",
      "id": "fn1_268"
    }
  }, [_c('sup', [_vm._v("268")])]), _vm._v(" The majority should have gone further. Both proselytizing and worship go to the essence of evangelical religion; it is hard to distinguish them in terms of religious intensity."), _c('a', {
    attrs: {
      "href": "#/#fn1-269",
      "id": "fn1_269"
    }
  }, [_c('sup', [_vm._v("269")])]), _vm._v(" Proselytizing is much more likely to offend other religious groups. If public (and sometimes offensive) proselytizing is protected, private and inoffensive worship should be protected a fortiori.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Three responses to one bad idea are probably enough, but the majority missed an important one. If religious groups are allowed to meet, any limitation on speech at their meetings would require censorship of the most intrusive and offensive kind. Drawing the line at worship would exacerbate the "), _c('a', {
    attrs: {
      "id": "page_69"
    }
  }, [_vm._v("problem by maximizing the sensitivity and murkiness of the distinction, but the problem is inherent wherever the line is drawn.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-270",
      "id": "fn1_270"
    }
  }, [_c('sup', [_vm._v("270")])]), _vm._v(" Any serious attempt to enforce such a distinction would quickly lead to Orwellian absurdities. For example, before "), _c('em', [_vm._v("Widmar")]), _vm._v(", the University of Texas had a rule that permitted academic discussions of religion but forbade attempts to persuade. When a group called Students for Freedom from Religion demanded enforcement, an assistant dean monitored rallies and pulled the plug on a sound system when a speaker crossed the forbidden line into persuasion."), _c('a', {
    attrs: {
      "href": "#/#fn1-271",
      "id": "fn1_271"
    }
  }, [_c('sup', [_vm._v("271")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Rules that allow schools to monitor the content of religious meetings and break them up when they become “too religious” trample the core of the Free Speech and Free Exercise Clauses. They also violate the Establishment Clause by giving official sanction to those religious meetings that are allowed to continue. If some of the meetings protected by the Equal Access Act include religious worship, there is no abuse, but rather the exercise of a statutory and constitutional right.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec4b"
  }, [_c('strong', [_vm._v("V. Moment-of-Silence Laws")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("Moment-of-silence laws require less elaborate analysis. The basic legal analysis is derivative of the analysis of the Equal Access Act. A school that sets aside a moment of silence is creating an open forum for private thought in the midst of the school day. It is not obligated to do so, but it is free to do so. Some students may think religious thoughts, or say a silent prayer. But private religious thought is even less capable of violating the Establishment Clause than private religious speech. Freedom of thought may be the only constitutional right that is absolutely protected.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Even so, most of the cases that have invalidated moments of silence have reached the right result. Neutral moments of silence are harder to implement than equal access. A religious meeting under the Equal Access Act is initiated by students and attended only by volunteers; the faculty monitor need not open his mouth. But inescapably, the teacher must introduce a moment of silence. And he must do so in the presence of the whole class. It requires careful preparation for a teacher to introduce a moment of silence without encouraging or discouraging prayer or appearing to do either. That task does not appear unmanageable in theory, but so far, it has exceeded the capacity of the schools in the litigated "), _c('a', {
    attrs: {
      "id": "page_70"
    }
  }, [_vm._v("cases. Whether through overreaching by the religious right or through sheer incompetence, implementation has largely been disastrous. Even with the best of implementation, moments of silence are more problematic than equal access.")])]), _c('a', {
    attrs: {
      "id": "page_70"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("In addition, legislatures have also found it difficult to draft these statutes in neutral terms. Because we need a properly drafted statute before we can talk about proper implementation, I will consider drafting problems first.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec5bi"
  }, [_c('strong', [_c('em', [_vm._v("A. Drafting a Proper Moment-of-Silence Law")])])])]), _c('p', {
    staticClass: "HPara"
  }, [_c('a', {
    attrs: {
      "id": "page_70"
    }
  }, [_c('strong', [_vm._v("1. Finding Neutral Statutory Language.")]), _vm._v("—In "), _c('em', [_vm._v("Wallace v. Jaffree")]), _vm._v(",")]), _c('a', {
    attrs: {
      "href": "#/#fn1-272",
      "id": "fn1_272"
    }
  }, [_c('sup', [_vm._v("272")])]), _vm._v(" the Supreme Court held one of Alabama’s two moment-of-silence statutes facially invalid. One Alabama statute directed teachers to announce that a “period of silence … shall be observed for meditation.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-273",
      "id": "fn1_273"
    }
  }, [_c('sup', [_vm._v("273")])]), _vm._v(" A more recent statute authorized teachers to announce that “a period of silence … shall be observed for meditation or voluntary prayer.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-274",
      "id": "fn1_274"
    }
  }, [_c('sup', [_vm._v("274")])]), _vm._v(" The plaintiff in "), _c('em', [_vm._v("Wallace")]), _vm._v(" abandoned his challenge to the meditation statute"), _c('a', {
    attrs: {
      "href": "#/#fn1-275",
      "id": "fn1_275"
    }
  }, [_c('sup', [_vm._v("275")])]), _vm._v(" and focused the Court’s attention on the addition of the word “prayer” in the second statute. The Court found that once the meditation statute was on the books, reenacting essentially the same statute to add a reference to prayer could only have been intended to legislatively endorse prayer. In the Court’s view, the legislative history confirmed that purpose. Thus, the Court invalidated the statute under the purpose component of its three-part test for Establishment Clause violations."), _c('a', {
    attrs: {
      "href": "#/#fn1-276",
      "id": "fn1_276"
    }
  }, [_c('sup', [_vm._v("276")])]), _vm._v(" The Court correctly noted that a moment of silence that “merely protect[ed]” each student’s right to pray voluntarily and without state endorsement would be “quite different.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-277",
      "id": "fn1_277"
    }
  }, [_c('sup', [_vm._v("277")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('em', [_vm._v("Wallace")]), _vm._v(" was correctly decided, and on the narrowest possible ground. Under the peculiar facts of "), _c('em', [_vm._v("Wallace")]), _vm._v(", it was plausible for the Court to read insertion of the word “prayer” as an endorsement of prayer. But "), _c('em', [_vm._v("Wallace")]), _vm._v(" should not be understood as depending on the use of magic words, with “meditation” statutes permitted and “prayer” statutes invalid. Use of the word “prayer” should not be fatal in a statute that neutrally accommodates each student’s right to private prayer."), _c('a', {
    attrs: {
      "href": "#/#fn1-278",
      "id": "fn1_278"
    }
  }, [_c('sup', [_vm._v("278")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_71"
    }
  }, [_vm._v("Nor should use of the word “meditation” shield a statute from scrutiny. Meditation can mean contemplation of any subject, but it most often means contemplation of a religious subject. This observation is not based on mere connotation or frequency of usage. Dictionaries offer religious contemplation as a distinct meaning of “meditation.”")]), _c('a', {
    attrs: {
      "href": "#/#fn1-279",
      "id": "fn1_279"
    }
  }, [_c('sup', [_vm._v("279")])]), _vm._v(" No modifier is required to make the word specifically and denotatively refer to a religious exercise.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Alabama legislature probably intended the religious meaning of the word. In any case, millions of citizens will understand the word in its religious meaning. Jaffree unaccountably abandoned his challenge to the meditation statute, but someone else will challenge it sooner or later."), _c('a', {
    attrs: {
      "href": "#/#fn1-280",
      "id": "fn1_280"
    }
  }, [_c('sup', [_vm._v("280")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Court did not reach the main problem with the two Alabama statutes. Teachers were authorized to announce that “a period of silence not to exceed one minute in duration shall be observed for meditation or voluntary prayer.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-281",
      "id": "fn1_281"
    }
  }, [_c('sup', [_vm._v("281")])]), _vm._v(" The passive voice and the adjective “voluntary” introduce some ambiguity. But the fairest reading is that this statute authorizes teachers to encourage, and even to command, prayer or religious meditation. It is plain that all students are required to “observe” the moment of silence. And “observe” is modified by the phrase “for meditation or voluntary prayer.” The most apparent meaning is that each student’s observation of the moment must be for the purpose of meditation or prayer. The statutory juxtaposition of “meditation” and “prayer” makes the religious sense of meditation inevitable. Moreover, “meditation” is not modified by “voluntary.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-282",
      "id": "fn1_282"
    }
  }, [_c('sup', [_vm._v("282")])]), _vm._v(" Under this statute, teachers would command students to engage in a religious exercise. The command may be unenforceable, but its mere issuance violates the Establishment Clause.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Similarly, the earlier Alabama statute required teachers to command students to meditate. The multiple meanings of meditation introduce a slight additional ambiguity, but the essential problem is the same. Many reasonable students would understand this announcement as a state command to engage in a religious exercise. If that is not what the state meant, it should have spoken more clearly.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_72"
    }
  }, [_vm._v("One three-judge district court panel has disagreed, upholding a substantially identical Massachusetts statute.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-283",
      "id": "fn1_283"
    }
  }, [_c('sup', [_vm._v("283")])]), _vm._v(" The court held that the statute used “meditation” in its secular sense."), _c('a', {
    attrs: {
      "href": "#/#fn1-284",
      "id": "fn1_284"
    }
  }, [_c('sup', [_vm._v("284")])]), _vm._v(" More precisely, the court said that the statute was “capable of a reasonable construction by which the constitutional difficulties … may be avoided.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-285",
      "id": "fn1_285"
    }
  }, [_c('sup', [_vm._v("285")])]), _vm._v(" But the court’s approach was misguided. The interpretive problem here is not one of construing a statute narrowly to avoid a constitutional question. Legislative endorsements are not filtered through lawyers and state supreme courts. Within limits, the legislature endorses what the public reasonably understands it to endorse."), _c('a', {
    attrs: {
      "href": "#/#fn1-286",
      "id": "fn1_286"
    }
  }, [_c('sup', [_vm._v("286")])]), _vm._v(" If the legislature endorses “meditation,” citizens who understand the legislature to mean “religious meditation” are simply understanding the word in one of its common dictionary senses. They are not making some demonstrable mistake analogous to those who perceive toleration of equal access as endorsement of religion."), _c('a', {
    attrs: {
      "href": "#/#fn1-287",
      "id": "fn1_287"
    }
  }, [_c('sup', [_vm._v("287")])]), _vm._v(" If the legislature cannot speak more clearly, it must at least provide that the teachers who implement the statute speak more clearly. But that was not done in the Massachusetts case."), _c('a', {
    attrs: {
      "href": "#/#fn1-288",
      "id": "fn1_288"
    }
  }, [_c('sup', [_vm._v("288")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Massachusetts court also concluded that the statute required students merely to be quiet and did not require anyone to pray or meditate. This conclusion apparently was drawn from a concession at oral argument;"), _c('a', {
    attrs: {
      "href": "#/#fn1-289",
      "id": "fn1_289"
    }
  }, [_c('sup', [_vm._v("289")])]), _vm._v(" the concession presumably resulted from a careless examination of the statutory language.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Not all moment-of-silence laws follow the Massachusetts and Alabama language. New Mexico did a little better, providing that the moment “may be used for contemplation, meditation, or prayer.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-290",
      "id": "fn1_290"
    }
  }, [_c('sup', [_vm._v("290")])]), _vm._v(" That statute should be upheld if it is properly implemented; it is close enough to neutral to be saved by reasonable explanation. But it is not wholly neutral on its face. “Contemplation” takes on religious coloration from its close association with meditation and prayer, and there is a negative implication that the moment may not be used for anything other than contemplation, meditation, or prayer.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_73"
    }
  }, [_vm._v("The New Jersey statute is considerably better. It specifies that the moment of silence is “to be used solely at the discretion of the individual student … for quiet and private contemplation or introspection.”")]), _c('a', {
    attrs: {
      "href": "#/#fn1-291",
      "id": "fn1_291"
    }
  }, [_c('sup', [_vm._v("291")])]), _vm._v(" New Jersey’s specification of uses does not explicitly direct students toward religious thought. But the most important difference is the statute’s clear declaration that the use of the moment of silence is in the sole discretion of the individual student. That is the critical point. The New Mexico statute blurred this point, and the Alabama and Massachusetts statute negated it.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Another reasonably well-drafted provision is a West Virginia constitutional amendment that provides:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("Public schools shall provide a designated brief time at the beginning of each school day for any student desiring to exercise their [sic] right to personal and private contemplation, meditation, or prayer. No student of a public school may be denied their [sic] right to personal and private contemplation, meditation or prayer nor shall any student be required or encouraged to engage in any given contemplation, meditation or prayer as a part of the school curriculum."), _c('a', {
    attrs: {
      "href": "#/#fn1-292",
      "id": "fn1_292"
    }
  }, [_c('sup', [_vm._v("292")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodySb"
  }, [_vm._v("The first sentence of this constitutional amendment makes clear that any prayer is the prayer of the individual student and that the school is merely providing a brief time during which students can exercise private rights. The final clause makes it reasonably clear that the school may not encourage any particular use of the moment of silence. The drafting could be tighter, but I would have no difficulty upholding the facial validity of the West Virginia provision.")]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_c('strong', [_vm._v("2. Secular Purpose Revisited.")]), _vm._v("—Courts invalidated the New Jersey, West Virginia, and New Mexico provisions despite their apparent neutrality."), _c('a', {
    attrs: {
      "href": "#/#fn1-293",
      "id": "fn1_293"
    }
  }, [_c('sup', [_vm._v("293")])]), _vm._v(" The New Mexico and West Virginia decisions rest in part on findings of improper "), _c('a', {
    attrs: {
      "id": "page_74"
    }
  }, [_vm._v("implementation in particular schools,")]), _c('a', {
    attrs: {
      "href": "#/#fn1-294",
      "id": "fn1_294"
    }
  }, [_c('sup', [_vm._v("294")])]), _vm._v(" but the opinions also appear to facially invalidate the statutes. These decisions rest on the view that even a neutrally worded moment-of-silence statute reflects an impermissible legislative purpose to encourage religion.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The view that a state moment-of-silence law encourages religion by accommodating silent prayer reflects many of the same fallacious assumptions as the view that the state encourages religion when it permits equal access. But the neutral moment of silence poses the “purpose” issue even more sharply than equal access."), _c('a', {
    attrs: {
      "href": "#/#fn1-295",
      "id": "fn1_295"
    }
  }, [_c('sup', [_vm._v("295")])]), _vm._v(" Equal access builds on a long tradition of open fora for secular speech. There is no such tradition for moments of silence, and no state would mandate a moment of silence for secular thought alone. Rather, the state creates moments of silence for all private thought in order to accommodate religious thought. Even more clearly than in the Equal Access Act, the legislative motivation in moment-of-silence laws is to provide an opportunity for private prayer in the public schools. Courts have not been fooled by the transparently dishonest rationalizations for these laws, such as the claim that they were enacted to help students focus their attention on the day’s work."), _c('a', {
    attrs: {
      "href": "#/#fn1-296",
      "id": "fn1_296"
    }
  }, [_c('sup', [_vm._v("296")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In ordinary usage, a purpose to make it easier for individuals to pray is a religious purpose. This reasoning is most explicit in the court of appeals holding in the New Jersey case. The court found the statute neutral on its face"), _c('a', {
    attrs: {
      "href": "#/#fn1-297",
      "id": "fn1_297"
    }
  }, [_c('sup', [_vm._v("297")])]), _vm._v(" and in effect;"), _c('a', {
    attrs: {
      "href": "#/#fn1-298",
      "id": "fn1_298"
    }
  }, [_c('sup', [_vm._v("298")])]), _vm._v(" it found no improper implementation"), _c('a', {
    attrs: {
      "href": "#/#fn1-299",
      "id": "fn1_299"
    }
  }, [_c('sup', [_vm._v("299")])]), _vm._v(" and no excessive entanglement."), _c('a', {
    attrs: {
      "href": "#/#fn1-300",
      "id": "fn1_300"
    }
  }, [_c('sup', [_vm._v("300")])]), _vm._v(" Nevertheless, the court struck down the statute because two legislators stated a “purpose of permitting prayer by those who want to pray.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-301",
      "id": "fn1_301"
    }
  }, [_c('sup', [_vm._v("301")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_75"
    }
  }, [_vm._v("The court of appeals misdirected its inquiry. Whether the statute’s purpose is religious in ordinary usage is irrelevant to the Establishment Clause. First, courts should not inquire into purpose if the statute is neutral on its face and in effect.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-302",
      "id": "fn1_302"
    }
  }, [_c('sup', [_vm._v("302")])]), _vm._v(" Second, a purpose to neutralize a state-imposed burden on religion is constitutionally permissible, even if religion benefits from removal of the burden."), _c('a', {
    attrs: {
      "href": "#/#fn1-303",
      "id": "fn1_303"
    }
  }, [_c('sup', [_vm._v("303")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Moment-of-silence laws ease the burden that compulsory education laws impose on some faiths. The compulsory education laws appropriate six or so hours of each student’s time each day. The state devotes those six hours to activities of its choice, and none of its choices can be religious. Students inclined to pray are free to do so on their own time,"), _c('a', {
    attrs: {
      "href": "#/#fn1-304",
      "id": "fn1_304"
    }
  }, [_c('sup', [_vm._v("304")])]), _vm._v(" but there is no assurance that they will get an uninterrupted opportunity. The result is a constraint on the right to pray that would not exist in the absence of compulsory education laws. That constraint generates substantial resentment among certain religious groups. Some believers genuinely feel a need to pray in connection with each of their important activities, of which school is certainly one. Probably a large number are unhappy because they misinterpret the ban on school-sponsored religious activity, viewing it as a hostile exclusion of religion from the public schools.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The state is not required to alleviate this incidental burden, but it does not violate the Establishment Clause if it chooses to do so. A moment of silence accommodates the needs of those who feel a need to pray during the school day. It also helps negate the impression of hostility arising from misunderstanding of the Establishment Clause."), _c('a', {
    attrs: {
      "href": "#/#fn1-305",
      "id": "fn1_305"
    }
  }, [_c('sup', [_vm._v("305")])]), _vm._v(" A legislative desire to accommodate prayer in this way should not invalidate a moment-of-silence law that is neutrally drafted and neutrally implemented. Nor does neutral drafting require the legislature to pretend it was not thinking about prayer when it created the moment of silence. Legislators can even say that their purpose is to “return prayer to the public schools,”"), _c('a', {
    attrs: {
      "href": "#/#fn1-306",
      "id": "fn1_306"
    }
  }, [_c('sup', [_vm._v("306")])]), _vm._v(" if the legislature is willing to settle for private prayer, and if both the schools and the legislature refrain from endorsement.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Throughout this subsection, I have used the words “accommodate” and “accommodation.” Some in the religious right have almost destroyed the utility of these words by misusing them as code words for government sponsorship. "), _c('a', {
    attrs: {
      "id": "page_76"
    }
  }, [_vm._v("But partisan misuse of the words does not destroy the concepts they embody, and I continue to use the words because no other words express their meaning as well. It should be clear that when I say “accommodate,” I merely mean “provide an opportunity for,” and that I would rigorously exclude government sponsorship or encouragement of any private activity that takes advantage of the opportunity.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-307",
      "id": "fn1_307"
    }
  }, [_c('sup', [_vm._v("307")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec5bi"
  }, [_c('strong', [_c('em', [_vm._v("B. Implementing Moments of Silence")])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("Moment-of-silence laws have posed far more serious implementation problems than drafting problems. A review of the cases is extraordinarily discouraging to those who believe in the rule of law. There is evidence that moments of silence worked well in some schools that were not sued,"), _c('a', {
    attrs: {
      "href": "#/#fn1-308",
      "id": "fn1_308"
    }
  }, [_c('sup', [_vm._v("308")])]), _vm._v(" but in most of the schools that were sued, moments of silence were implemented in unconstitutional ways and became the source of much rancor. There is considerable evidence that teachers encouraged or coerced students to pray"), _c('a', {
    attrs: {
      "href": "#/#fn1-309",
      "id": "fn1_309"
    }
  }, [_c('sup', [_vm._v("309")])]), _vm._v(" and that teachers, students, and the public understood the statutes as requiring students to pray."), _c('a', {
    attrs: {
      "href": "#/#fn1-310",
      "id": "fn1_310"
    }
  }, [_c('sup', [_vm._v("310")])]), _vm._v(" And there is a chilling tale of a praying student harassing a nonpraying student with anti-Semitic epithets."), _c('a', {
    attrs: {
      "href": "#/#fn1-311",
      "id": "fn1_311"
    }
  }, [_c('sup', [_vm._v("311")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("These efforts to force students to pray appear to have had very little effect. A study in Las Cruces reported that fewer than twenty percent of students adopted a posture that suggested they were praying."), _c('a', {
    attrs: {
      "href": "#/#fn1-312",
      "id": "fn1_312"
    }
  }, [_c('sup', [_vm._v("312")])]), _vm._v(" Reliance on such a study must allow a wide margin of error; the difficulties of identifying prayer through posture are obvious. Still, the study is suggestive. Some student witnesses have testified that moments of silence were “boring and stupid,”"), _c('a', {
    attrs: {
      "href": "#/#fn1-313",
      "id": "fn1_313"
    }
  }, [_c('sup', [_vm._v("313")])]), _vm._v(" while "), _c('a', {
    attrs: {
      "id": "page_77"
    }
  }, [_vm._v("other witnesses have opposed the moment of silence on the ground that the school atmosphere was not conducive to real prayer and the whole exercise trivialized prayer.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-314",
      "id": "fn1_314"
    }
  }, [_c('sup', [_vm._v("314")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("There is ample basis in the cases to conclude that moments of silence heighten religious tensions, distract students and faculty from their primary tasks, invite careless, uninformed, or recalcitrant teachers to wittingly or unwittingly violate the Establishment Clause, and succeed in accommodating only the most superficial forms of prayer. As a means of dispelling the impression that schools are hostile to religion, moments of silence are probably less effective than equal access. The facts of the litigated cases suggest that, wholly apart from constitutional questions, moment-of-silence laws are bad public policy. Even so, there is every reason to assume that legislatures will continue to enact them. A neutral way to implement them is needed.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Careful implementation could reduce many of the problems associated with moments of silence. But careful implementation will require a substantial investment of time and effort that the schools could better use in other ways. The facts of the cases make clear that implementation cannot be left to individual teachers, and probably not to individual school boards. The confusion and misinformation about school prayer is too great to expect tolerable results. The only hope is that state boards of education will provide clear guidelines for implementing moments of silence. A well-advised state would give every classroom teacher a little card with a prepared speech for introducing the moment of silence, like the "), _c('em', [_vm._v("Miranda")]), _vm._v(" warning cards that police officers carry. The card should say something like this:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("We will now observe a moment of silence. You are free to think about anything you wish during this moment of silence, but you must remain still and quiet.")]), _vm._v(" "), _c('p', {
    staticClass: "BodySb"
  }, [_vm._v("That is a sufficient introduction once the moment of silence has become a customary part of the school day. It is probably sufficient to withstand constitutional attack even if no other explanation is ever offered. But it is also clear from the facts of the cases that widespread confusion and hostility are likely unless students are given a more detailed explanation the first time they are asked to observe a moment of silence. Too many students and parents know that the moment of silence is closely linked to prayer; they draw their own correct and incorrect impressions about the school’s reasons for observing it. "), _c('a', {
    attrs: {
      "id": "page_78"
    }
  }, [_vm._v("The school must dispel those misimpressions to ensure a peaceful moment of silence that is understood to be neutral. And if moments of silence become occasions for the expression of religious intolerance by students, the schools have a duty to respond by teaching tolerance in connection with the moment of silence.")])]), _c('a', {
    attrs: {
      "id": "page_78"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("State boards of education should provide teachers with a more elaborate explanation. I would give teachers a written version that they could take to the classroom to read to their students before the first moment of silence. I would require teachers to reread the more elaborate explanation to their students at regular intervals, and I would also hold faculty meetings in every school to explain it and to review teachers’ experiences in the classrooms. Teachers must understand the law well enough to answer questions from their students. My written version for the classroom would go something like this:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("The legislature has asked you to have this moment of silence. One reason for the moment of silence is that some students want a chance to pray. But no one is required to pray during the moment of silence. Whether you pray, and how you pray, and when you pray are entirely up to you and your parents.")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteInd"
  }, [_vm._v("We have religious freedom in our country. That means that every family gets to choose its own religion or no religion at all. Some people want to pray at school. Others want to pray only at home or in their church or synagogue. Others don’t want to pray at all. All of these choices are fine with the school. Students who make a different choice than the one you make can still be good students and good Americans.")]), _vm._v(" "), _c('p', {
    staticClass: "BodySb"
  }, [_vm._v("It may be that the religious right would rather do without a moment of silence than have teachers say the school does not care whether students pray. But if they take that position, they will prove the claims of those groups that instinctively have opposed moments of silence. The only point of the suggested explanation is to make it clear that the moment of silence is an opportunity for private prayer, and not a state endorsement of prayer. Those who oppose such an explanation must be seeking covert state endorsement, the very thing the Constitution forbids.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Nor is it credible to oppose such an explanation on the ground that students cannot understand it. If they cannot understand a neutral moment of silence with an explanation, they certainly cannot understand a neutral moment of silence without an explanation. The explanation may have to be simplified even further in the lower grades. But to argue that students cannot understand the explanation is to argue against a moment of silence altogether.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_78"
    }
  }), _c('a', {
    attrs: {
      "id": "page_79"
    }
  }, [_vm._v("Even careful attention to implementation will not eliminate all problems. Some teachers will endorse or coerce prayer, and some schools will not correct such violations unless they are sued. Policing implementation in every classroom is a bigger task than facially invalidating statutes in every state. But nothing is more neutral than an open forum for thought. Courts should not invalidate all moment-of-silence laws because of fears that they may be implemented improperly, even if experience so far has been discouraging. Legislatures are free to enact bad public policy, within the limits of the Constitution. A properly drafted and implemented moment-of-silence law is within those limits.")])]), _c('a', {
    attrs: {
      "id": "page_79"
    }
  }, [_c('h1', {
    staticClass: "sec4b"
  }, [_c('strong', [_vm._v("VI. Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("Civil libertarians are quick to defend political dissidents, because in those cases the threat to civil liberties comes from only one direction. The state may harass or silence political dissidents, but there is no imminent danger that dissidents will succeed in violating the civil liberties of the rest of us. If the push for the Equal Access Act had come from excluded political groups, the reaction of civil libertarians would have been quite different.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Religious speech poses more complex problems. The risk that the government will sponsor religion is as imminent as the risk that the government will suppress religion. It is hard to rush to the barricades in both directions at the same time. It is harder when you are supposed to be neutral toward people you cannot understand and do not trust, especially when some of those whose speech is being suppressed are simultaneously demanding wholesale violations of the Establishment Clause. Of course, there is nothing unusual about a group loudly defending its own rights while threatening the rights of others. What makes the religious right different is that it is large enough to threaten the rights of others effectively.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Whatever the sins of some evangelicals and fundamentalists on the Establishment Clause front, they are suffering widespread censorship on the free speech and free exercise front. They are not required to remain silent or to confine their religious speech to private places, or to places without children. They are not required to follow the example of the adult bookstores and avoid or warn off listeners who might be offended by their beliefs. We should protect their right to speak as vigilantly as we protect the rights of political groups. Simultaneously, and with equal vigilance, we should fight the government’s efforts to endorse or oppose them or any other religious groups, either openly or subtly.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_79"
    }
  }), _c('a', {
    attrs: {
      "id": "page_80"
    }
  }, [_vm._v("I have proposed a simple rule for this two-front war. The government must be absolutely neutral toward religion in its own speech, and it must be absolutely neutral in its treatment of private speech. Under this rule, equal access is constitutionally required. Moment-of-silence laws are not required and are not a good idea, but if neutrally drafted and implemented, they are not unconstitutional.")])]), _c('a', {
    attrs: {
      "id": "page_80"
    }
  }, [_c('p', {
    staticClass: "ast"
  }, [_vm._v("I am grateful to Dean Kelley, Sanford Levinson, L. A. Powe, David Rabban, Teresa Sullivan, Jay Westbrook, Charles Alan Wright, and Mark Yudof for helpful comments on earlier drafts, and to Fred Garrett for research assistance.")]), _vm._v(" "), _c('p', {
    staticClass: "image-f"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/foot.jpg"
    }
  })])]), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "id": "page_80"
    }
  }), _c('a', {
    attrs: {
      "href": "#/#fn1_1",
      "id": "fn1-1"
    }
  }, [_vm._v("1.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AWRENCE")]), _vm._v(" A. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("REMIN")]), _vm._v(", T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MERICAN")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OMMON")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHOOL")]), _vm._v(" 66–70 (Columbia Univ. Teachers College 1951); D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IANE")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AVITCH")]), _vm._v(", T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("REAT")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHOOL")]), _vm._v(" W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARS")]), _vm._v(": N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EW")]), _vm._v(" Y"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORK")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ITY")]), _vm._v(", 1805–1973, at 18–19, 34–35, 47 (Basic Books 1974); 1 A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NSON")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HELPS")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TOKES")]), _vm._v(", C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HURCH")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TATE")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IN")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE")]), _vm._v(" U"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NITED")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TATES")]), _vm._v(" 824–27 (Harper Bros. 1950).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_2",
      "id": "fn1-2"
    }
  }, [_vm._v("2.")]), _vm._v(" 370 U.S. 421 (1962).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_3",
      "id": "fn1-3"
    }
  }, [_vm._v("3.")]), _vm._v(" 374 U.S. 203 (1963) [in this volume at 282].")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_4",
      "id": "fn1-4"
    }
  }, [_vm._v("4.")]), _vm._v(" U.S. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONST")]), _vm._v(". amend. I.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_5",
      "id": "fn1-5"
    }
  }, [_vm._v("5.")]), _vm._v(" For the historical part of that argument, see Douglas Laycock, "), _c('em', [_vm._v("“Non-Preferential” Aid to Religion: A False Claim About Original Intent")]), _vm._v(", 27 W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("M")]), _vm._v(". & M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARY")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 875 (1986) [in volume 1 at 531].")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_6",
      "id": "fn1-6"
    }
  }, [_vm._v("6.")]), _vm._v(" Bender v. Williamsport Area Sch. Dist., 475 U.S. 534, 554 (1986) (Burger, C.J., dissenting); Grand Rapids Sch. Dist. v. Ball, 473 U.S. 373, 382 (1985); Wallace v. Jaffree, 472 U.S. 38, 53 n.37, 60–61 (1985); Lynch v. Donnelly, 465 U.S. 668, 714 (1983) (Brennan, J., dissenting); Marsh v. Chambers, 463 U.S. 783, 802–03 (1983) (Brennan, J., dissenting); Mueller v. Allen, 463 U.S. 388, 404 (1983) (Marshall, J., dissenting); Thomas v. Review Board, 450 U.S. 707, 717 (1981); McDaniel v. Paty, 435 U.S. 618, 629 (1978) (plurality opinion); "), _c('em', [_vm._v("id")]), _vm._v(". at 636 (Brennan, J., concurring); Maher v. Roe, 432 U.S. 464, 475 n.8 (1977); Roemer v. Board of Pub. Works, 426 U.S. 736, 747 (1976) (plurality opinion); Meek v. Pittenger, 421 U.S. 349, 372 (1975); Committee for Pub. Educ. & Religious Liberty v. Nyquist, 413 U.S. 756, 792–93 (1973); Wisconsin v. Yoder, 406 U.S. 205, 220 (1972); Gillette v. United States, 401 U.S. 437, 449 (1971); "), _c('em', [_vm._v("id")]), _vm._v(". at 469 (Douglas, J., dissenting); Welsh v. United States, 398 U.S. 333, 372 (1970) (White, J., dissenting); Epperson v. Arkansas, 393 U.S. 97, 103–04, 109 (1968); Board of Educ. v. Allen, 392 U.S. 236, 242 (1968); "), _c('em', [_vm._v("id")]), _vm._v(". at 249 (Harlan, J., concurring); Sherbert v. Verner, 374 U.S. 398, 409 (1963); "), _c('em', [_vm._v("id")]), _vm._v(". at 422–23 (Harlan, J., dissenting); Abington Sch. Dist. v. Schempp, 374 U.S. 203, 215–22, 226 (1963); "), _c('em', [_vm._v("id")]), _vm._v(". at 243–45, 295, 299 (Brennan, J., concurring); "), _c('em', [_vm._v("id")]), _vm._v(". at 306 (Goldberg, J., concurring); Engel v. Vitale, 370 U.S. 421, 443 (1962) (Douglas, J., concurring); McGowan v. Maryland, 366 U.S. 420, 564 (1961) (Douglas, J., dissenting); Everson v. Board of Educ., 330 U.S. 1, 18 (1947).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-Body"
  }, [_vm._v("Perhaps the Court’s most frequent formulation of the neutrality requirement is that “the principal or primary effect [of legislation] must be one that neither advances nor inhibits religion.” Lemon v. Kurtzman, 403 U.S. 602, 612 (1971). Two Justices have dissented from the neutrality requirement. See Wallace v. Jaffree, 472 U.S. 38, 83 (1985) (O’Connor, J., concurring); "), _c('em', [_vm._v("id")]), _vm._v(". at 99–100, 108 (Rehnquist, J., dissenting). But even they invoke neutrality on occasion. See Bender v. Williamsport Area Sch. Dist., 474 U.S. 534, 554 (1986) (Burger, C.J., dissenting, joined by Rehnquist, J.); Witters v. Wash. Dep’t of Servs. for the Blind, 474 U.S. 481, 493 (1986) (O’Connor, J., concurring).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_7",
      "id": "fn1-7"
    }
  }, [_vm._v("7.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" Wallace v. Jaffree, 472 U.S. 38 (1985) (statutes directed teachers to announce that students “shall observe” period of silence for meditation and authorized them to announce that period was for meditation or prayer); Karen B. v. Treen, 653 F.2d 897 (5th Cir. 1981), "), _c('em', [_vm._v("aff’d mem.")]), _vm._v(", 455 U.S. 913 (1982) (statute authorized teachers to ask if any student wanted to lead class in prayer, and to lead prayer themselves if no student volunteered); "), _c('em', [_vm._v("see also")]), _vm._v(" Stone v. Graham, 449 U.S. 39 (1980) (statute directed schools to permanently post Ten Commandments on bulletin boards, with expenses paid by private contributions).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_8",
      "id": "fn1-8"
    }
  }, [_vm._v("8.")]), _vm._v(" 20 U.S.C. §§ 4071–4074 (Supp. 1985).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_9",
      "id": "fn1-9"
    }
  }, [_vm._v("9.")]), _vm._v(" These statutes are collected in "), _c('em', [_vm._v("Wallace")]), _vm._v(", 472 U.S. at 70 n.1 (O’Connor, J., concurring). They are summarized in tabular form in David Z. Seide, Note, "), _c('em', [_vm._v("Daily Moments of Silence in Public Schools: A Constitutional Analysis")]), _vm._v(", 58 N.Y.U.L. Rev. 364, 407–08 (1983).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_10",
      "id": "fn1-10"
    }
  }, [_vm._v("10.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" Philip B. Kurland, "), _c('em', [_vm._v("Of Church and State and the Supreme Court")]), _vm._v(", 29 U. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HI")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1 (1961).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_11",
      "id": "fn1-11"
    }
  }, [_vm._v("11.")]), _vm._v(" On the distinction between private and government speech, see M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARK")]), _vm._v(" G. Y"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UDOF")]), _vm._v(", W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HEN")]), _vm._v(" G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OVERNMENT")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PEAKS")]), _vm._v(": P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OLITICS")]), _vm._v(", L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AW")]), _vm._v(", "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND")]), _vm._v(" G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OVERNMENT")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IN")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MERICA")]), _vm._v(" (Univ. of California Press 1983).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_12",
      "id": "fn1-12"
    }
  }, [_vm._v("12.")]), _vm._v(" This formulation is arguably implicit in earlier commentary. Judges and commentators have argued that the Free Speech Clause guarantees religious student groups equal access to open fora on school property and that high school students can understand that the school does not endorse every student group. "), _c('em', [_vm._v("See, e.g")]), _vm._v("., Bender v. Williamsport Area Sch. Dist., 475 U.S. 534, 553 (1986) (Burger, C.J., dissenting); Bender v. Williamsport Area Sch. Dist., 741 F.2d 538, 561 (3d Cir. 1984) (Adams, J., dissenting), "), _c('em', [_vm._v("vacated on other grounds")]), _vm._v(", 475 U.S. 534 (1986); S. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EP")]), _vm._v(". No. 357, 98th Cong., 2d Sess. 8–10, 21–24, "), _c('em', [_vm._v("reprinted in")]), _vm._v(" 1984 U.S.C.C.A.N 2348, 2354–56, 2367–70; Arnold H. Loewy, "), _c('em', [_vm._v("School Prayer, Neutrality, and the Open Forum: Why We Don’t Need a Constitutional Amendment")]), _vm._v(", 61 N.C.L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 141 (1982); Ira C. Lupu, "), _c('em', [_vm._v("Keeping the Faith: Religion, Equality and Speech in the U.S. Constitution")]), _vm._v(", 18 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONN")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 739, 755–61 (1986); John E. Leach, Note, "), _c('em', [_vm._v("Religion in Public Schoolrooms—Striking a Balance Between Freedom of Speech and Establishment of Religion")]), _vm._v(": "), _c('em', [_vm._v("Bender v. Williamsport Area School District")]), _vm._v(", 1984 B.Y.U.L. Rev. 671; Note, Lowell V. Sturgill, Jr. & Nancy S. Oliver, "), _c('em', [_vm._v("Religious Expression in the Public Schools Forum: The High School Student’s Right to Free Speech")]), _vm._v(", 72 G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EO")]), _vm._v(". L.J. 135 (1983); Scott C. Benjamin, Comment, "), _c('em', [_vm._v("Widmar v. Vincent and the Public Forum Doctrine: Time to Reconsider Public School Prayer")]), _vm._v(", 1984 Wis. L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 147; Note, "), _c('em', [_vm._v("The Constitutional Dimensions of Student-Initiated Religious Activity in Public High Schools")]), _vm._v(", 92 Y"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALE")]), _vm._v(" L.J. 499 (1983) (hereinafter Note, "), _c('em', [_vm._v("Student-Initiated Religious Activity")]), _vm._v("); "), _c('em', [_vm._v("see also")]), _vm._v(" Keegan v. Univ. of Del., 349 A.2d 14 (Del. 1975); Linda S. Leparulo, Note, "), _c('em', [_vm._v("The Rights of Student Religious Groups Under the First Amendment to Hold Religious Meetings on the Public University Campus")]), _vm._v(", 33 R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UTGERS")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1008 (1981). For quite different arguments, see Donald L. Drakeman & Robert P. Seawright, "), _c('em', [_vm._v("God and Kids at School: Voluntary Religious Activities in the Public Schools")]), _vm._v(", 14 S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ETON")]), _vm._v(" H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALL")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 252 (1984) (balancing Establishment Clause rights against Free Exercise Clause rights and finding free exercise rights weightier); Robert L. Toms & John W. Whitehead, "), _c('em', [_vm._v("The Religious Student in Public Education: Resolving a Constitutional Dilemma")]), _vm._v(", 27 E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MORY")]), _vm._v(" L.J. 3 (1978) (equal access is consistent with “benevolent” or “accommodating” neutrality, in which modest government aid to religion is permitted).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-Body"
  }, [_vm._v("This Article further develops the principles underlying equal access and responds more thoroughly to arguments against it. The most important new argument in this Article is the attempt to show that arguments against equal access are based on the same fallacy as arguments in favor of school prayer. "), _c('em', [_vm._v("See infra")]), _vm._v(" notes 97–99 and accompanying text. This Article also offers a thorough analysis of the Equal Access Act. "), _c('em', [_vm._v("See infra")]), _vm._v(" notes 168–212 and accompanying text.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_13",
      "id": "fn1-13"
    }
  }, [_vm._v("13.")]), _vm._v(" This would not preclude the school from monitoring meetings for reasons of safety and discipline. "), _c('em', [_vm._v("See infra")]), _vm._v(" notes 142–50 and accompanying text.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_14",
      "id": "fn1-14"
    }
  }, [_vm._v("14.")]), _vm._v(" 475 U.S. 534 (1986).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_15",
      "id": "fn1-15"
    }
  }, [_vm._v("15.")]), _vm._v(" Bender v. Williamsport Area Sch. Dist., 741 F.2d 538, 544 (3d Cir. 1984) (quoting testimony of school principal), "), _c('em', [_vm._v("vacated on other grounds")]), _vm._v(", 475 U.S. 534 (1986).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_16",
      "id": "fn1-16"
    }
  }, [_vm._v("16.")]), _vm._v(" "), _c('em', [_vm._v("Bender")]), _vm._v(", 741 F.2d at 543–44.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_17",
      "id": "fn1-17"
    }
  }, [_vm._v("17.")]), _vm._v(" U.S. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONST")]), _vm._v(". amend. I.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_18",
      "id": "fn1-18"
    }
  }, [_vm._v("18.")]), _vm._v(" "), _c('em', [_vm._v("Id.")])]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_19",
      "id": "fn1-19"
    }
  }, [_vm._v("19.")]), _vm._v(" "), _c('em', [_vm._v("See, e.g")]), _vm._v("., Lubbock Civil Liberties Union v. Lubbock Indep. Sch. Dist., 669 F.2d 1038 (5th Cir. 1982).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_20",
      "id": "fn1-20"
    }
  }, [_vm._v("20.")]), _vm._v(" Widmar v. Vincent, 454 U.S. 263 (1981).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_21",
      "id": "fn1-21"
    }
  }, [_vm._v("21.")]), _vm._v(" Nartowicz v. Clayton County Sch. Dist., 736 F.2d 646, 649 (11th Cir. 1984) (“The ultimate question, of course, is whether the school district merely accommodates, as opposed to endorses, the [Youth for Christ Club].”).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_22",
      "id": "fn1-22"
    }
  }, [_vm._v("22.")]), _vm._v(" Bender v. Williamsport Area Sch. Dist., 741 F.2d 538 (3d Cir. 1984), "), _c('em', [_vm._v("vacated on other grounds")]), _vm._v(", 475 U.S. 534 (1986); Lubbock Civil Liberties Union v. Lubbock Indep. Sch. Dist., 669 F.2d 1038 (5th Cir. 1982); "), _c('em', [_vm._v("accord")]), _vm._v(", Johnson v. Huntington Beach Union High Sch. Dist., 137 Cal. Rptr. 43 (Ct. App. 1977); "), _c('em', [_vm._v("see also")]), _vm._v(" Bell v. Little Axe Indep. Sch. Dist. No. 70, 766 F.2d 1391 (10th Cir. 1985) (applying same rule to junior high school); Mich. State Board of Educ. v. Tri-County Area Sch. Dist., 5 Religious Freedom Rep. (Christian Legal Soc’y) 47 (W.D. Mich. 1984) (applying same rule to elementary school).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_23",
      "id": "fn1-23"
    }
  }, [_vm._v("23.")]), _vm._v(" Brandon v. Board of Educ., 635 F.2d 971 (2d Cir. 1980).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_24",
      "id": "fn1-24"
    }
  }, [_vm._v("24.")]), _vm._v(" 20 U.S.C. §§ 4071 to 4074 (Supp. 1985).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_25",
      "id": "fn1-25"
    }
  }, [_vm._v("25.")]), _vm._v(" "), _c('em', [_vm._v("Compare")]), _vm._v(" Mergens v. Board of Educ., 5 Religious Freedom Rep. (Christian Legal Soc’y) 86 (D. Neb. 1985) (denying preliminary injunction to enforce Act and expressing serious doubt about its validity); "), _c('em', [_vm._v("with")]), _vm._v(" Amidei v. Spring Branch Indep. Sch. Dist., 5 Religious Freedom Rep. (Christian Legal Soc’y) 67 (S.D. Tex. 1985) (upholding Act and ordering school board to comply). [The Eighth Circuit reversed in "), _c('em', [_vm._v("Mergens")]), _vm._v(", 867 F.2d 1076 (8th Cir. 1989), and the Supreme Court affirmed the Eighth Circuit. 496 U.S. 226 (1990). My amicus brief in "), _c('em', [_vm._v("Mergens")]), _vm._v(" is in this volume at 81.]")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_26",
      "id": "fn1-26"
    }
  }, [_vm._v("26.")]), _vm._v(" "), _c('em', [_vm._v("See, e.g")]), _vm._v("., Walters v. Radiation Survivors, 473 U.S. 305, 319 (1985).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_27",
      "id": "fn1-27"
    }
  }, [_vm._v("27.")]), _vm._v(" Wallace v. Jaffree, 472 U.S. 38 (1985); May v. Cooperman, 780 F.2d 240 (3d Cir. 1985), "), _c('em', [_vm._v("juris. postponed sub nom.")]), _vm._v(" Karcher v. May, 479 U.S. 1062 (1987) [this appeal was later dismissed, because the former legislative leaders seeking to appeal no longer held their legislative positions, 484 U.S. 72 (1987)]; Walter v. West Va. State Board of Educ., 610 F. Supp. 1169 (S.D.W. Va. 1985); Duffy v. Las Cruces Pub. Schs., 557 F. Supp. 1013 (D.N.M. 1983); Beck v. McElrath, 548 F. Supp. 1161 (M.D. Tenn. 1982). "), _c('em', [_vm._v("Contra")]), _vm._v(" Gaines v. Anderson, 421 F. Supp. 337 (D. Mass. 1976) (three-judge court); Opinion of the Justices, 307 A.2d 558, 560 (N.H. 1973). The Supreme Court has strongly implied that a properly drafted and implemented moment-of-silence law would be upheld. "), _c('em', [_vm._v("See")]), _vm._v(" Wallace v. Jaffree, 472 U.S. 38, 59 (1985); "), _c('em', [_vm._v("id")]), _vm._v(". at 66 (Powell, J., concurring); "), _c('em', [_vm._v("id")]), _vm._v(". at 71–75 (O’Connor, J., concurring); "), _c('em', [_vm._v("id")]), _vm._v(". at 91 (White, J., dissenting).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_28",
      "id": "fn1-28"
    }
  }, [_vm._v("28.")]), _vm._v(" "), _c('em', [_vm._v("See, e.g.,")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AURENCE")]), _vm._v(" H. T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RIBE")]), _vm._v(", A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MERICAN")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONSTITUTIONAL")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AW")]), _vm._v(" § 14–6, at 828 (Foundation Press 1978); Jesse H. Choper, "), _c('em', [_vm._v("Religion in the Public Schools: A Proposed Constitutional Standard")]), _vm._v(", 47 M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("INN")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 329, 371 (1963); Paul A. Freund, "), _c('em', [_vm._v("The Legal Issue")]), _vm._v(", in R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ELIGION")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UBLIC")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHOOLS")]), _vm._v(" 2 (Harvard 1965); Paul G. Kauper, "), _c('em', [_vm._v("Prayer, Public Schools and the Supreme Court")]), _vm._v(", 61 M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ICH")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1031, 1041 (1963); Andrew Woodbridge Hull, Note, "), _c('em', [_vm._v("A Moment of Silence: A Permissible Accommodation Protecting the Capacity to Form Religious Belief")]), _vm._v(", 61 I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ND")]), _vm._v(". L.J. 429 (1986); Donald L. Swanson, Comment, "), _c('em', [_vm._v("Accommodating Religion in the Public Schools")]), _vm._v(", 59 N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EB")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 425, 450–54 (1980); P. Raymond Bartholomew, Note, "), _c('em', [_vm._v("Religion and the Public Schools")]), _vm._v(", 20 V"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1078, 1092–93 (1967). "), _c('em', [_vm._v("But see")]), _vm._v(" Donald L. Drakeman, "), _c('em', [_vm._v("Prayer in the Schools: Is New Jersey’s Moment of Silence Law Constitutional?")]), _vm._v(", 35 R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UTGERS")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 341 (1983); Kaneaster Hodges, Jr., Comment, "), _c('em', [_vm._v("Constitutional Law—Religious Exercises and the Public Schools")]), _vm._v(", 20 A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RK")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 320, 352–53 (1967); Note, "), _c('em', [_vm._v("The Unconstitutionality of State Statutes Authorizing Moments of Silence in the Public Schools")]), _vm._v(", 96 H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARV")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1874 (1983) [hereinafter Note, "), _c('em', [_vm._v("State Statutes")]), _vm._v("]; Seide, "), _c('em', [_vm._v("supra")]), _vm._v(" note 9; Robert Tilewick, Note, "), _c('em', [_vm._v("Constitutional Law—Ritual Silence in Public Schools")]), _vm._v(", 57 T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EMP")]), _vm._v(". L.Q. 95 (1984).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_29",
      "id": "fn1-29"
    }
  }, [_vm._v("29.")]), _vm._v(" 472 U.S. 38 (1985).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_30",
      "id": "fn1-30"
    }
  }, [_vm._v("30.")]), _vm._v(" Examples drawn from the religious and political leadership of such groups include Rev. Jerry Falwell, Rev. Oral Roberts, Rev. Pat Robertson, Sen. Jesse Helms, and former Sen. Jeremiah Denton.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_31",
      "id": "fn1-31"
    }
  }, [_vm._v("31.")]), _vm._v(" "), _c('em', [_vm._v("See infra")]), _vm._v(" notes 126–39 and accompanying text.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_32",
      "id": "fn1-32"
    }
  }, [_vm._v("32.")]), _vm._v(" Esbeck distinguishes “secularists” from “institutional-separationists.” See Carl H. Esbeck, "), _c('em', [_vm._v("Religion and a Neutral State: Imperative or Impossibility?")]), _vm._v(", 15 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UMB")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 67, 75–77 (1984). The unfortunately named institutional separationists are typified by the liberal Protestant denominations, which oppose school prayer and financial aid to church schools.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_33",
      "id": "fn1-33"
    }
  }, [_vm._v("33.")]), _vm._v(" Abington School Dist. v. Schempp, 374 U.S. 203 (1963) [in this volume at 282]; Engel v. Vitale, 370 U.S. 421 (1962).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_34",
      "id": "fn1-34"
    }
  }, [_vm._v("34.")]), _vm._v(" Wallace v. Jaffree, 472 U.S. 38 (1985); "), _c('em', [_vm._v("see also")]), _vm._v(" Karen B. v. Treen, 653 F.2d 897 (5th Cir. 1981), "), _c('em', [_vm._v("aff’d mem")]), _vm._v("., 455 U.S. 913 (1982).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_35",
      "id": "fn1-35"
    }
  }, [_vm._v("35.")]), _vm._v(" Stone v. Graham, 449 U.S. 39 (1980).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_36",
      "id": "fn1-36"
    }
  }, [_vm._v("36.")]), _vm._v(" Marsh v. Chambers, 463 U.S. 783 (1983).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_37",
      "id": "fn1-37"
    }
  }, [_vm._v("37.")]), _vm._v(" Lynch v. Donnelly, 465 U.S. 668 (1984).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_38",
      "id": "fn1-38"
    }
  }, [_vm._v("38.")]), _vm._v(" Corpus Christi, the name of a major city in Texas, is a Latin phrase meaning “Body of Christ.” Town boosters refer to residents as Corpus Christians. Numerous religious protesters, including the National Conference of Catholic Bishops, were deeply offended when the Navy named a nuclear submarine the Corpus Christi. President Reagan renamed the ship the "), _c('em', [_vm._v("City of Corpus Christi")]), _vm._v(". For reasons that are wholly unclear, that was considered more acceptable. The controversy is chronicled in Phil Gailey, "), _c('em', [_vm._v("Protester Ends His Fast a Winner and a Loser")]), _vm._v(", N.Y. T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IMES")]), _vm._v(", Apr. 29, 1982; "), _c('em', [_vm._v("Church, State, and a Submarine")]), _vm._v(", N.Y. T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IMES")]), _vm._v(", Dec. 8, 1981; Robert E. Tomasson, "), _c('em', [_vm._v("Corpus Christi Launched in Groton as 1,000 Protest Sub and Its Name")]), _vm._v(", N.Y. T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IMES")]), _vm._v(", Apr. 26, 1981.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_39",
      "id": "fn1-39"
    }
  }, [_vm._v("39.")]), _vm._v(" The original Spanish name of Los Angeles was "), _c('em', [_vm._v("El Pueblo de Nuestra Senora la Reyna de los Angeles de Porciuncula")]), _vm._v("—“The Town of Our Lady the Queen of the Angels of Porciuncula.” 2 N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EW")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ENTURY")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("YCLOPEDIA")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OF")]), _vm._v(" N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AMES")]), _vm._v(" 2513 (1954). Porciuncula apparently is derived from Portiuncula, the first monastery founded by St. Francis of Assisi. J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OHN")]), _vm._v(" J. D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ELANEY")]), _vm._v(", D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ICTIONARY")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OF")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AINTS")]), _vm._v(" 234 (Doubleday 1980); "), _c('em', [_vm._v("see also")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RTURO")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UYÁS")]), _vm._v(", A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PPLETON")]), _vm._v("’"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("S")]), _vm._v(" N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EW")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UYÁS")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NGLISH")]), _vm._v("-S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PANISH")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PANISH")]), _vm._v("-E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NGLISH")]), _vm._v(" D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ICTIONARY")]), _vm._v(" 433 (1972) (defining “porciuncula” as a “franciscan jubilee”). The name of the city has since been shortened to "), _c('em', [_vm._v("El Pueblo de la Reyna de los Angeles")]), _vm._v("—“The Town of the Queen of the Angels.” 23 T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EW")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NCYCLOPEDIA")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RITANNICA")]), _vm._v(" 311 (1985). Either version names the city with an honorific title for Mary, a religious figure significant only to Christians. Mary’s role in Christianity is a major point of division between Protestants and Catholics, and only Catholics would refer to her with these honorific titles. [I have been asked if I am now somewhat embarrassed by footnotes 38 and 39 and the paragraph they accompany. I am not. I understood at the time that there would always be a de minimis exception, and I now have a greater appreciation of the need for such an exception. But in principle, which is all I ever claimed, I still believe in this passage.]")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_40",
      "id": "fn1-40"
    }
  }, [_vm._v("40.")]), _vm._v(" "), _c('em', [_vm._v("Cf.")]), _vm._v(" Korematsu v. United States, 323 U.S. 214, 246 (1944) (Jackson, J., dissenting) (it would have been better for the Court to deny review than to publish opinion that validated principle of racial discrimination in military emergencies).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_41",
      "id": "fn1-41"
    }
  }, [_vm._v("41.")]), _vm._v(" This proposition is far too obvious to have ever been the subject of litigation. "), _c('em', [_vm._v("Cf.")]), _vm._v(" Grand Rapids School Dist. v. Ball, 473 U.S. 373, 388 (1985) (Court concerned that public school teachers might encourage religion while on property of parochial schools). Whatever the defects in the Court’s reasoning, it is plainly correct to hold that an establishment on private property is still an establishment.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_42",
      "id": "fn1-42"
    }
  }, [_vm._v("42.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" Toms & Whitehead, "), _c('em', [_vm._v("supra")]), _vm._v(" note 12, at 15–19.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_43",
      "id": "fn1-43"
    }
  }, [_vm._v("43.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" sources cited "), _c('em', [_vm._v("supra")]), _vm._v(" note 12.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_44",
      "id": "fn1-44"
    }
  }, [_vm._v("44.")]), _vm._v(" 454 U.S. 263, 265–66 (1981).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_45",
      "id": "fn1-45"
    }
  }, [_vm._v("45.")]), _vm._v(" Chess v. Widmar, 480 F. Supp. 907 (W.D. Mo. 1979), "), _c('em', [_vm._v("rev’d")]), _vm._v(", 635 F.2d 1310 (8th Cir. 1980), "), _c('em', [_vm._v("aff’d sub nom.")]), _vm._v(" Widmar v. Vincent, 454 U.S. 263 (1981).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_46",
      "id": "fn1-46"
    }
  }, [_vm._v("46.")]), _vm._v(" "), _c('em', [_vm._v("Chess")]), _vm._v(", 635 F.2d at 1310.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_47",
      "id": "fn1-47"
    }
  }, [_vm._v("47.")]), _vm._v(" "), _c('em', [_vm._v("Widmar")]), _vm._v(", 454 U.S. at 274.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_48",
      "id": "fn1-48"
    }
  }, [_vm._v("48.")]), _vm._v(" "), _c('em', [_vm._v("Id.")]), _vm._v(" at 281 (Stevens, J., concurring).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_49",
      "id": "fn1-49"
    }
  }, [_vm._v("49.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at 278–79 (Stevens, J., concurring).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_50",
      "id": "fn1-50"
    }
  }, [_vm._v("50.")]), _vm._v(" Carey v. Brown, 447 U.S. 455 (1980); Healy v. James, 408 U.S. 169 (1972); Police Dep’t v. Mosley, 408 U.S. 92 (1972). "), _c('em', [_vm._v("See generally")]), _vm._v(" Kenneth L. Karst, "), _c('em', [_vm._v("Equality as a Central Principle in the First Amendment")]), _vm._v(", 43 U. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HI")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 20, 20–43 (1975); Geoffrey R. Stone, "), _c('em', [_vm._v("Content Regulation and the First Amendment")]), _vm._v(", 25 W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("M")]), _vm._v(". & M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARY")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 189, 189–94, 233–52 (1983).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_51",
      "id": "fn1-51"
    }
  }, [_vm._v("51.")]), _vm._v(" Madison Joint Sch. Dist. v. Wis. Employment Relations Comm’n, 429 U.S. 167 (1976); Southeastern Promotions, Ltd. v. Conrad, 420 U.S. 546 (1975). "), _c('em', [_vm._v("See generally")]), _vm._v(" Harry Kalven, Jr., "), _c('em', [_vm._v("The Concept of the Public Forum: Cox v. Louisiana")]), _vm._v(", 1965 Sup. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("T")]), _vm._v(". R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1; Geoffrey R. Stone, "), _c('em', [_vm._v("Fora Americana: Speech in Public Places")]), _vm._v(", 1974 S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UP")]), _vm._v(". C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("T")]), _vm._v(". R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 233.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-Body"
  }, [_vm._v("More recent scholarship argues that the public forum classification is often conclusory. These scholars suggest a more focused balancing of specific competing interests, with considerable weight given to the interests in speech and content neutrality. "), _c('em', [_vm._v("See")]), _vm._v(" Ronald A. Cass, "), _c('em', [_vm._v("First Amendment Access to Government Facilities")]), _vm._v(", 65 V"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1287 (1979); Daniel A. Farber & John E. Nowak, "), _c('em', [_vm._v("The Misleading Nature of Public Forum Analysis: Content and Context in First Amendment Adjudication")]), _vm._v(", 70 V"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1219 (1984); Barbara S. Gaal, Note, "), _c('em', [_vm._v("A Unitary Approach to Claims of First Amendment Access to Publicly Owned Property")]), _vm._v(", 35 S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TAN")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 121 (1982). Structuring the argument in this way does not change the result in "), _c('em', [_vm._v("Widmar")]), _vm._v(", because the ban on religious speech does not help implement the Establishment Clause, the only conceivably relevant governmental goal. "), _c('em', [_vm._v("See")]), _vm._v(" Farber & Nowak, "), _c('em', [_vm._v("supra")]), _vm._v(", at 1248–49; "), _c('em', [_vm._v("infra")]), _vm._v(" notes 70–165 and accompanying text.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_52",
      "id": "fn1-52"
    }
  }, [_vm._v("52.")]), _vm._v(" "), _c('em', [_vm._v("See supra")]), _vm._v(" note 5.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_53",
      "id": "fn1-53"
    }
  }, [_vm._v("53.")]), _vm._v(" Daniel A. Farber, "), _c('em', [_vm._v("Content Regulation and the First Amendment: A Revisionist View")]), _vm._v(", 68 G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EO")]), _vm._v(". L.J. 727 (1980); Paul B. Stephan III, "), _c('em', [_vm._v("The First Amendment and Content Discrimination")]), _vm._v(", 68 V"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 203 (1982).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_54",
      "id": "fn1-54"
    }
  }, [_vm._v("54.")]), _vm._v(" "), _c('em', [_vm._v("Widmar")]), _vm._v(", 454 U.S. at 284–85 (White, J., dissenting).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_55",
      "id": "fn1-55"
    }
  }, [_vm._v("55.")]), _vm._v(" "), _c('em', [_vm._v("Id.")]), _vm._v(" at 285.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_56",
      "id": "fn1-56"
    }
  }, [_vm._v("56.")]), _vm._v(" "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", Marsh v. Alabama, 326 U.S. 501 (1946); West Va. State Board of Educ. v. Barnette, 319 U.S. 624 (1943); Murdock v. Pennsylvania, 319 U.S. 105 (1943); Largent v. Texas, 318 U.S. 418 (1943); Jamison v. Texas, 318 U.S. 413 (1943); Cantwell v. Connecticut, 310 U.S. 296 (1940); Lovell v. City of Griffin, 303 U.S. 444 (1938). "), _c('em', [_vm._v("Largent")]), _vm._v(" held that religious speech is protected by both the Free Speech and Free Exercise Clauses. 318 U.S. at 422. That is clearly correct, but the standards are the same under both clauses. Some commentators prefer to protect religious speech under the Free Exercise Clause. "), _c('em', [_vm._v("See, e.g")]), _vm._v("., Drakeman & Seawright, "), _c('em', [_vm._v("supra")]), _vm._v(" note 12, at 273–78. Teitel argues that the Free Exercise Clause is not violated unless the government “effectively foreclose[s] the practice of one’s religion.” Ruti Teitel, "), _c('em', [_vm._v("The Unconstitutionality of Equal Access Policies and Legislation Allowing Organized Student-Initiated Religious Activities in the Public High Schools: A Proposal for a Unitary First Amendment Forum Analysis")]), _vm._v(", 12 H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ASTINGS")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONST")]), _vm._v(". L.Q. 529, 592 (1985). But Teitel’s standard would allow rampant government hostility to religion, so long as it fell short of a ban on religious practice. Discrimination against religion is the essence of both free speech and free exercise violations in equal access cases. "), _c('em', [_vm._v("See generally")]), _vm._v(" William P. Marshall, "), _c('em', [_vm._v("Solving the Free Exercise Dilemma: Free Exercise as Expression")]), _vm._v(", 67 M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("INN")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 545 (1983).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_57",
      "id": "fn1-57"
    }
  }, [_vm._v("57.")]), _vm._v(" Poulos v. New Hampshire, 345 U.S. 395 (1953); Fowler v. Rhode Island, 345 U.S. 67 (1953); Niemotko v. Maryland, 340 U.S. 268 (1951); "), _c('em', [_vm._v("see")]), _vm._v(" Kunz v. New York, 340 U.S. 290 (1951); Saia v. New York, 334 U.S. 558 (1948).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_58",
      "id": "fn1-58"
    }
  }, [_vm._v("58.")]), _vm._v(" Niemotko v. Maryland, 340 U.S. 268 (1951).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_59",
      "id": "fn1-59"
    }
  }, [_vm._v("59.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" Joint Brief for Appellants at 18–24, "), _c('em', [_vm._v("Niemotko")]), _vm._v("; Joint Brief for Appellees at 17–20. Because the authorities had allowed other religious groups to hold services in the parks, the Court refused to let the state defend the exclusion of Jehovah’s Witnesses on Establishment Clause grounds. "), _c('em', [_vm._v("Niemotko")]), _vm._v(", 340 U.S. at 272–73. The Establishment Clause argument was also raised in Kunz v. New York, 340 U.S. 290, 311 n.10 (1951) (Jackson, J., dissenting).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_60",
      "id": "fn1-60"
    }
  }, [_vm._v("60.")]), _vm._v(" O’Hair v. Andrus, 613 F.2d 931 (D.C. Cir. 1979); "), _c('em', [_vm._v("see also")]), _vm._v(" Gilfillan v. City of Philadelphia, 637 F.2d 924 (3d Cir. 1980). "), _c('em', [_vm._v("Gilfillan")]), _vm._v(" held that the city could not pay the cost of building a platform for a papal mass or provide other kinds of assistance that the city had not offered to other groups holding large meetings in the parks. "), _c('em', [_vm._v("Gilfillan")]), _vm._v(", 637 F.2d at 928–33. The plaintiffs conceded that the mass could be held and that the city could spend substantial sums on traffic and crowd control. "), _c('em', [_vm._v("Id")]), _vm._v(". at 928. Similar cases include Jews for Jesus, Inc. v. Board of Airport Comm’rs, 785 F.2d 791 (9th Cir.), "), _c('em', [_vm._v("cert. granted")]), _vm._v(", 479 U.S. 812 (1986) (religious solicitation in airport; establishment issue not raised) [The Court unanimously protected Jews for Jesus’s right to distribute literature, in an opinion written on overbreadth grounds. 482 U.S. 569 (1987).]; Christian Science Reading Room Jointly Maintained v. City of San Francisco, 784 F.2d 1010 (9th Cir. 1986) (church reading room in airport); McCreary v. Stone, 739 F.2d 716 (2d Cir. 1984) (private crèche in public park), "), _c('em', [_vm._v("aff’d by an equally divided Court sub nom")]), _vm._v(". Board of Trustees v. McCreary, 471 U.S. 83 (1985); Jaffe v. Alexis, 659 F.2d 1018 (9th Cir. 1981) (religious solicitation on grounds of Department of Motor Vehicles); Brashich v. Port Auth., 791 F.2d 224 (2d Cir. 1980) (chapels in airport).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_61",
      "id": "fn1-61"
    }
  }, [_vm._v("61.")]), _vm._v(" "), _c('em', [_vm._v("Widmar")]), _vm._v(", 454 U.S. at 287 (White, J., dissenting). White dissented because he thought religious worship was unlike other religious speech. "), _c('em', [_vm._v("See infra")]), _vm._v(" notes 261–62 and accompanying text.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_62",
      "id": "fn1-62"
    }
  }, [_vm._v("62.")]), _vm._v(" 452 U.S. 640 (1981).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_63",
      "id": "fn1-63"
    }
  }, [_vm._v("63.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at 643–45.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_64",
      "id": "fn1-64"
    }
  }, [_vm._v("64.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at 652–53.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_65",
      "id": "fn1-65"
    }
  }, [_vm._v("65.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at 652.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_66",
      "id": "fn1-66"
    }
  }, [_vm._v("66.")]), _vm._v(" Geoffrey R. Stone, "), _c('em', [_vm._v("The Equal Access Controversy: The Religion Clauses and the Meaning of “Neutrality,”")]), _vm._v(" 81 Nw. U.L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 168 (1986). For a similar argument, see Teitel, "), _c('em', [_vm._v("supra")]), _vm._v(" note 56, at 586.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_67",
      "id": "fn1-67"
    }
  }, [_vm._v("67.")]), _vm._v(" "), _c('em', [_vm._v("See generally")]), _vm._v(" Martin H. Redish, "), _c('em', [_vm._v("The Content Distinction in First Amendment Analysis")]), _vm._v(", 34 S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TAN")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 113 (1981).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_68",
      "id": "fn1-68"
    }
  }, [_vm._v("68.")]), _vm._v(" "), _c('em', [_vm._v("See generally")]), _vm._v(" Stone, "), _c('em', [_vm._v("supra")]), _vm._v(" note 50, at 239–42; Geoffrey R. Stone, "), _c('em', [_vm._v("Restriction of Speech Because of Its Content: The Peculiar Case of Subject-Matter Restrictions")]), _vm._v(", 46 U. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HI")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 81 (1978).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_69",
      "id": "fn1-69"
    }
  }, [_vm._v("69.")]), _vm._v(" "), _c('em', [_vm._v("But see")]), _vm._v(" Lehman v. City of Shaker Heights, 418 U.S. 298 (1974) (city bus system can sell commercial advertising space and refuse to sell political advertising space).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_70",
      "id": "fn1-70"
    }
  }, [_vm._v("70.")]), _vm._v(" Bender v. Williamsport Area Sch. Dist., 741 F.2d 538 (3d Cir. 1984), "), _c('em', [_vm._v("vacated on other grounds")]), _vm._v(", 475 U.S. 534 (1986); Brandon v. Board of Educ., 635 F.2d 971 (2d Cir. 1980); Chess v. Widmar, 480 F. Supp. 907 (W.D. Mo. 1979), "), _c('em', [_vm._v("rev’d")]), _vm._v(", 635 F.2d 1310 (8th Cir. 1980), "), _c('em', [_vm._v("aff’d sub nom")]), _vm._v(". Widmar v. Vincent, 454 U.S. 263 (1981); Nadine Strossen, "), _c('em', [_vm._v("A Framework for Evaluating Equal Access Claims by Student Religious Groups: Is There a Window for Free Speech in the Wall Separating Church and State?")]), _vm._v(", 71 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORNELL")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 143, 158 (1985); Teitel, "), _c('em', [_vm._v("supra")]), _vm._v(" note 56, at 566–74. In some cases, courts reasonably found actual endorsement in the implementation of facially neutral equal access policies. "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", Bell v. Little Axe Indep. Sch. Dist. No. 70, 766 F.2d 1391 (10th Cir. 1985); Lubbock Civil Liberties Union v. Lubbock Indep. Sch. Dist., 669 F.2d 1038 (5th Cir. 1982).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_71",
      "id": "fn1-71"
    }
  }, [_vm._v("71.")]), _vm._v(" Beyer, "), _c('em', [_vm._v("“Phooey on Falwell” Rally Attracts “The Masses,”")]), _vm._v(" D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AILY")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EXAN")]), _vm._v(", Sept. 30, 1981; Elliot, "), _c('em', [_vm._v("West Mall Religious Rally Ruled Illegal")]), _vm._v(", D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AILY")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EXAN")]), _vm._v(", Sept. 17, 1981.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_72",
      "id": "fn1-72"
    }
  }, [_vm._v("72.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" Cornelius v. NAACP Legal Defense & Educ. Fund, 473 U.S. 788, 802–03 (1985). The Court also has held that the streets of company towns are a public forum. Marsh v. Alabama, 326 U.S. 501 (1946). Some states have imposed public forum obligations on the owners of shopping malls, "), _c('em', [_vm._v("see")]), _vm._v(" Robins v. PruneYard Shopping Center, 592 P.2d 341 (Cal. 1979), "), _c('em', [_vm._v("aff’d on other grounds")]), _vm._v(", 447 U.S. 74 (1980), and private universities, "), _c('em', [_vm._v("see")]), _vm._v(" State v. Schmid, 423 A.2d 615 (N.J. 1980), "), _c('em', [_vm._v("appeal dismissed sub nom")]), _vm._v(". Princeton Univ. v. Schmid, 455 U.S. 100 (1982).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_73",
      "id": "fn1-73"
    }
  }, [_vm._v("73.")]), _vm._v(" 741 F.2d 538, 552 (3d Cir. 1984), "), _c('em', [_vm._v("vacated on other grounds")]), _vm._v(", 475 U.S. 534 (1986); "), _c('em', [_vm._v("see also")]), _vm._v(" Bell v. Little Axe Indep. Sch. Dist. No. 70, 766 F.2d 1391 (10th Cir. 1985); Lubbock Civil Liberties Union v. Lubbock Indep. Sch. Dist., 669 F.2d 1038 (5th Cir. 1982); Brandon v. Board of Educ., 635 F.2d 971 (2d Cir. 1980); Teitel, "), _c('em', [_vm._v("supra")]), _vm._v(" note 56, at 566–74.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_74",
      "id": "fn1-74"
    }
  }, [_vm._v("74.")]), _vm._v(" "), _c('em', [_vm._v("Bender")]), _vm._v(", 741 F.2d at 554.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_75",
      "id": "fn1-75"
    }
  }, [_vm._v("75.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" Bethel Sch. Dist. No. 403 v. Fraser, 478 U.S. 675, 683–84 (1986).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_76",
      "id": "fn1-76"
    }
  }, [_vm._v("76.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" Cary v. Board of Educ., 427 F. Supp. 945, 953 (D. Colo. 1977), "), _c('em', [_vm._v("aff’d on other grounds")]), _vm._v(", 598 F.2d 535 (10th Cir. 1979); Albaum v. Carey, 283 F. Supp. 3, 10–11 (E.D.N.Y. 1968); Strossen, "), _c('em', [_vm._v("supra")]), _vm._v(" note 70, at 160–61.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_77",
      "id": "fn1-77"
    }
  }, [_vm._v("77.")]), _vm._v(" A student note collects psychological studies suggesting that adolescents resist authority and are capable of independent critical thought. Note, "), _c('em', [_vm._v("Student-Initiated Religious Activity, supra")]), _vm._v(" note 12, at 507–09; "), _c('em', [_vm._v("see also")]), _vm._v(" Strossen, "), _c('em', [_vm._v("supra")]), _vm._v(" note 70, at 162.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_78",
      "id": "fn1-78"
    }
  }, [_vm._v("78.")]), _vm._v(" "), _c('em', [_vm._v("Cf")]), _vm._v(". Bigelow v. Virginia, 421 U.S. 809, 827–28 (1975) (state’s interest in “shielding its citizens from information” is entitled to little weight, even in context of commercial advertising).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_79",
      "id": "fn1-79"
    }
  }, [_vm._v("79.")]), _vm._v(" 393 U.S. 503 (1969).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_80",
      "id": "fn1-80"
    }
  }, [_vm._v("80.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at 504.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_81",
      "id": "fn1-81"
    }
  }, [_vm._v("81.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at 518 (Black, J., dissenting).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_82",
      "id": "fn1-82"
    }
  }, [_vm._v("82.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at 517–18 (Black, J., dissenting).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_83",
      "id": "fn1-83"
    }
  }, [_vm._v("83.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at 506.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_84",
      "id": "fn1-84"
    }
  }, [_vm._v("84.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at 512 (quoting Keyishian v. Board of Regents, 385 U.S. 589, 603 (1967)).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_85",
      "id": "fn1-85"
    }
  }, [_vm._v("85.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at 513 (quoting Burnside v. Byars, 363 F.2d 744, 749 (5th Cir. 1966) (internal quotation altered by Court)).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_86",
      "id": "fn1-86"
    }
  }, [_vm._v("86.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at 509.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_87",
      "id": "fn1-87"
    }
  }, [_vm._v("87.")]), _vm._v(" "), _c('em', [_vm._v("Id.")]), _vm._v(" at 512–13.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_88",
      "id": "fn1-88"
    }
  }, [_vm._v("88.")]), _vm._v(" 319 U.S. 624 (1943).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_89",
      "id": "fn1-89"
    }
  }, [_vm._v("89.")]), _vm._v(" "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", San Diego Comm. Against Registration & the Draft v. Governing Board, 790 F.2d 1471 (9th Cir. 1986) (antidraft advertisements); Gambino v. Fairfax City Sch. Board, 564 F.2d 157 (4th Cir. 1977) (birth control information); Jacobs v. Board of School Comm’rs, 490 F.2d 601 (7th Cir. 1973), "), _c('em', [_vm._v("dismissed as moot,")]), _vm._v(" 420 U.S. 128 (1975) (underground newspaper; profanity); Shanely v. Northeast Indep. Sch. Dist., 462 F.2d 960 (5th Cir. 1972) (challenge to marijuana laws; birth control information); Wilson v. Chancellor, 418 F. Supp. 1358 (D. Or. 1976) (Communist speaker); Bayer v. Kinzler, 383 F. Supp. 1164 (E.D.N.Y. 1974) (birth control and abortion information), "), _c('em', [_vm._v("aff’d")]), _vm._v(", 515 F.2d 504 (2d Cir. 1975). "), _c('em', [_vm._v("See generally")]), _vm._v(" Michael P. Aaron, Note, "), _c('em', [_vm._v("The Equal Access Act: A Haven for High School “Hate Groups”?")]), _vm._v(" 13 H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OFSTRA")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 589, 608–11 (1985); Note, "), _c('em', [_vm._v("Administrative Regulation of the High School Press")]), _vm._v(", 83 M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ICH")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 625 (1984) [hereinafter Note, "), _c('em', [_vm._v("Administrative Regulation")]), _vm._v("].")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_90",
      "id": "fn1-90"
    }
  }, [_vm._v("90.")]), _vm._v(" Bethel Sch. Dist. No. 403 v. Fraser, 478 U.S. 675 (1986).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_91",
      "id": "fn1-91"
    }
  }, [_vm._v("91.")]), _vm._v(" "), _c('em', [_vm._v("Id.")]), _vm._v(" at 681 (dictum).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_92",
      "id": "fn1-92"
    }
  }, [_vm._v("92.")]), _vm._v(" The ACLU has denounced the Equal Access Act as a flagrant violation of the Establishment Clause. "), _c('em', [_vm._v("ACLU Debates “Rights in Conflict,”")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IV")]), _vm._v(". L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IBERTIES")]), _vm._v(", Summer 1985, at 1.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_93",
      "id": "fn1-93"
    }
  }, [_vm._v("93.")]), _vm._v(" Whitney v. California, 274 U.S. 357, 377 (1927) (Brandeis, J., concurring).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_94",
      "id": "fn1-94"
    }
  }, [_vm._v("94.")]), _vm._v(" Teitel, "), _c('em', [_vm._v("supra")]), _vm._v(" note 56, at 588.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_95",
      "id": "fn1-95"
    }
  }, [_vm._v("95.")]), _vm._v(" "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", Democratic Party v. Wisconsin "), _c('em', [_vm._v("ex rel")]), _vm._v(". La Follette, 450 U.S. 107, 121–22 (1981); Buckley v. Valeo, 424 U.S. 1, 15 (1976); NAACP v. Button, 371 U.S. 415, 430–31 (1963); NAACP v. Alabama, 357 U.S. 449, 460 (1958).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_96",
      "id": "fn1-96"
    }
  }, [_vm._v("96.")]), _vm._v(" "), _c('em', [_vm._v("See infra")]), _vm._v(" notes 126–39 and accompanying text.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_97",
      "id": "fn1-97"
    }
  }, [_vm._v("97.")]), _vm._v(" Others have noted that refusing equal access is or may appear to be hostile to religion. "), _c('em', [_vm._v("E.g")]), _vm._v("., Lubbock Civil Liberties Union v. Lubbock Indep. Sch. Dist., 680 F.2d 424, 426 (5th Cir. 1982) (Reavley, J., dissenting from denial of rehearing en banc); Drakeman & Seawright, "), _c('em', [_vm._v("supra")]), _vm._v(" note 12, at 276; Strossen, "), _c('em', [_vm._v("supra")]), _vm._v(" note 70, at 163 n.100; Toms & Whitehead, "), _c('em', [_vm._v("supra")]), _vm._v(" note 12, at 9–10; Thomas E. Grossmann, Note, "), _c('em', [_vm._v("The Constitutionality of Student-Initiated Religious Meetings on Public School Grounds")]), _vm._v(", 50 U. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IN")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 740, 785 (1981). Contrary to Professor Lupu’s suggestion, the hostility is not mitigated by blaming it on the Constitution instead of the school. "), _c('em', [_vm._v("See")]), _vm._v(" Lupu, "), _c('em', [_vm._v("supra")]), _vm._v(" note 12, at 758.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_98",
      "id": "fn1-98"
    }
  }, [_vm._v("98.")]), _vm._v(" "), _c('em', [_vm._v("E.g.")]), _vm._v(", W. H. M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OBERLY")]), _vm._v(", T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RISIS")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IN")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE")]), _vm._v(" U"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NIVERSITY")]), _vm._v(" 55–56 (SCM Press 1949); James Hitchcock, "), _c('em', [_vm._v("Church, State and Moral Values: The Limits of American Pluralism")]), _vm._v(", 44 L. & C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONTEMP")]), _vm._v(". P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ROBS")]), _vm._v(". 3 (Spring 1981); Hull, "), _c('em', [_vm._v("supra")]), _vm._v(" note 28, at 431–33; "), _c('em', [_vm._v("cf")]), _vm._v(". David G. Leitch, Note, "), _c('em', [_vm._v("The Myth of Religious Neutrality by Separation in Education")]), _vm._v(", 71 V"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 127 (1985) (true neutrality requires schools to teach values from pluralistic perspectives, including secular philosophy and traditional religions).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_99",
      "id": "fn1-99"
    }
  }, [_vm._v("99.")]), _vm._v(" Ruti Teitel, "), _c('em', [_vm._v("When Separate Is Equal—Why Organized Religious Exercises Unlike Chess, Do Not Belong in the Public Schools")]), _vm._v(", 81 Nw. U.L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 174 (1986).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_100",
      "id": "fn1-100"
    }
  }, [_vm._v("100.")]), _vm._v(" “First, the statute must have a secular legislative purpose; second, its principal or primary effect must be one that neither advances nor inhibits religion; finally, the statute must not foster ‘an excessive government entanglement with religion.’” Lemon v. Kurtzman, 403 U.S. 602, 612–13 (1971) (quoting Walz v. Tax Comm’n, 397 U.S. 664, 674 (1970)).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_101",
      "id": "fn1-101"
    }
  }, [_vm._v("101.")]), _vm._v(" Douglas Laycock, "), _c('em', [_vm._v("A Survey of Religious Liberty in the United States")]), _vm._v(", 47 O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HIO")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("T")]), _vm._v(". L.J. 409, 449–50 (1986) [in volume 1 at 323–24]. For other criticisms of the test, "), _c('em', [_vm._v("see, e.g")]), _vm._v("., Phillip E. Johnson, "), _c('em', [_vm._v("Concepts and Compromise in First Amendment Religious Doctrine")]), _vm._v(", 72 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AL")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 817, 825–31 (1984); Philip B. Kurland, "), _c('em', [_vm._v("The Irrelevance of the Constitution: The Religion Clauses of the First Amendment and the Supreme Court")]), _vm._v(", 24 V"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ILL")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 3, 17–20 (1978). For an academic who likes the test, see Norman Redlich, "), _c('em', [_vm._v("Separation of Church and State: The Burger Court’s Tortuous Journey")]), _vm._v(", 60 N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OTRE")]), _vm._v(" D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AME")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1094, 1104 (1985).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_102",
      "id": "fn1-102"
    }
  }, [_vm._v("102.")]), _vm._v(" "), _c('em', [_vm._v("Lemon")]), _vm._v(", 403 U.S. at 612.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_103",
      "id": "fn1-103"
    }
  }, [_vm._v("103.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" Wallace v. Jaffree, 472 U.S. 38 (1985); Stone v. Graham, 449 U.S. 39 (1980); Epperson v. Arkansas, 393 U.S. 97 (1968).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_104",
      "id": "fn1-104"
    }
  }, [_vm._v("104.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" Michael W. McConnell, "), _c('em', [_vm._v("Accommodation of Religion")]), _vm._v(", 1985 Sup. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("T")]), _vm._v(". R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1, 34–37, 44; Redlich, "), _c('em', [_vm._v("supra")]), _vm._v(" note 101, at 1115; "), _c('em', [_vm._v("Wallace")]), _vm._v(", 472 U.S. at 83–84 (O’Connor, J., concurring) (lifting government-imposed burden is accommodation; other government aid to religion is establishment). Although he recognizes the need for accommodation in some contexts, and presumably supports neutrality toward religion, Dean Redlich appears to oppose equal access. "), _c('em', [_vm._v("See")]), _vm._v(" Redlich, "), _c('em', [_vm._v("supra")]), _vm._v(" note 101, at 1116.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_105",
      "id": "fn1-105"
    }
  }, [_vm._v("105.")]), _vm._v(" "), _c('em', [_vm._v("E.g.")]), _vm._v(", Title VII of the Civil Rights Act of 1964, 42 U.S.C. § 2000e-2 (1982); "), _c('em', [_vm._v("see also")]), _vm._v(" McConnell, "), _c('em', [_vm._v("supra")]), _vm._v(" note 104, at 32–33.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_106",
      "id": "fn1-106"
    }
  }, [_vm._v("106.")]), _vm._v(" Teitel, "), _c('em', [_vm._v("supra")]), _vm._v(" note 56, at 556–59. Strossen apparently takes a similar view. "), _c('em', [_vm._v("See")]), _vm._v(" Strossen, "), _c('em', [_vm._v("supra")]), _vm._v(" note 70, at 170–71, 181. For a contrary view, see Lupu, "), _c('em', [_vm._v("supra")]), _vm._v(" note 12, at 759.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_107",
      "id": "fn1-107"
    }
  }, [_vm._v("107.")]), _vm._v(" A divided court struck down New Jersey’s moment-of-silence statute on similar reasoning. "), _c('em', [_vm._v("See")]), _vm._v(" May v. Cooperman, 780 F.2d 240, 252–53 (3d Cir. 1985), "), _c('em', [_vm._v("juris. postponed sub nom")]), _vm._v(". Karcher v. May, 479 U.S. 1062 (1987) ["), _c('em', [_vm._v("appeal dis’d")]), _vm._v(", 484 U.S. 872 (1987)]. "), _c('em', [_vm._v("May")]), _vm._v(" cited Estate of Thornton v. Caldor, Inc., 472 U.S. 703, 708 (1985), as striking down a statute that accommodated religion. But the statute in "), _c('em', [_vm._v("Thornton")]), _vm._v(" was struck down because of its religious effect, not for lack of a secular purpose. "), _c('em', [_vm._v("Id.")]), _vm._v(" at 709–10. The statute in "), _c('em', [_vm._v("Thornton")]), _vm._v(" required the plaintiff’s employer or fellow workers to bear substantial costs resulting from his religious observance. "), _c('em', [_vm._v("Thornton")]), _vm._v(" is correctly decided, but irrelevant.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_108",
      "id": "fn1-108"
    }
  }, [_vm._v("108.")]), _vm._v(" Palmer v. Thompson, 403 U.S. 217 (1971); United States v. O’Brien, 391 U.S. 367 (1968); United States v. Darby, 312 U.S. 100 (1941); McConnell, "), _c('em', [_vm._v("supra")]), _vm._v(" note 104, at 47–48.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_109",
      "id": "fn1-109"
    }
  }, [_vm._v("109.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" Personnel Adm’r v. Feeney, 442 U.S. 256 (1979) (statute distinguishing military veterans from nonveterans had discriminatory effect on women); Village of Arlington Heights v. Metropolitan Hous. Dev. Corp., 429 U.S. 252 (1977) (zoning ordinance distinguishing single-family housing from multifamily housing had discriminatory effect on blacks); Washington v. Davis, 426 U.S. 229 (1976) (statute distinguishing test-passers from test-failers had discriminatory effect on blacks); "), _c('em', [_vm._v("cf.")]), _vm._v(" Mt. Healthy City Sch. Dist. Board of Educ. v. Doyle, 429 U.S. 274 (1977) (teacher discharged on stated ground of unprofessionalism alleged that real ground was retaliation for protected speech). Similar inquiries are appropriate in religious discrimination cases when a plaintiff is treated worse than his peers and the issue is whether the bad treatment was because of his religion or because of some permissible reason. But some person or group must be treated worse than another to trigger such an inquiry. The motives for an all-inclusive neutrality are irrelevant.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_110",
      "id": "fn1-110"
    }
  }, [_vm._v("110.")]), _vm._v(" The problems of proving legislative purpose are illustrated in May v. Cooperman, 780 F.2d 240, 252 n.9 (3d Cir. 1985), "), _c('em', [_vm._v("juris postponed sub nom")]), _vm._v(". Karcher v. May, 479 U.S. 1062 (1987) ["), _c('em', [_vm._v("appeal dis’d")]), _vm._v(", 484 U.S. 872 (1987)]; "), _c('em', [_vm._v("May")]), _vm._v(", 780 F.2d at 262–65 (Becker, J., dissenting).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_111",
      "id": "fn1-111"
    }
  }, [_vm._v("111.")]), _vm._v(" Teitel, "), _c('em', [_vm._v("supra")]), _vm._v(" note 56, at 557 n.130.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_112",
      "id": "fn1-112"
    }
  }, [_vm._v("112.")]), _vm._v(" Teitel says that advocates for evangelicals “claim to be” counsel in every equal access case, but that some conceal their identity from the Court by giving a post office box address. "), _c('em', [_vm._v("Id")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_113",
      "id": "fn1-113"
    }
  }, [_vm._v("113.")]), _vm._v(" Harris v. McRae, 448 U.S. 297, 319 (1980); McGowan v. Maryland, 366 U.S. 420, 442 (1961).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_114",
      "id": "fn1-114"
    }
  }, [_vm._v("114.")]), _vm._v(" The Court relied on religious purpose when it struck down a statute forbidding the teaching of evolution in the public schools. Epperson v. Arkansas, 393 U.S. 97 (1968). The Constitution prevents the state from teaching religious theories of human origins, so the statute imposed a form of neutrality through silence. But the Court also viewed the statute as nonneutral in its effects, because the statute forbade only the teaching of evolution. "), _c('em', [_vm._v("Id")]), _vm._v(". at 109.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_115",
      "id": "fn1-115"
    }
  }, [_vm._v("115.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" Wallace v. Jaffree, 472 U.S. 38 (1985); Stone v. Graham, 449 U.S. 39 (1980).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_116",
      "id": "fn1-116"
    }
  }, [_vm._v("116.")]), _vm._v(" Lemon v. Kurtzman, 403 U.S. 602, 612 (1971).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_117",
      "id": "fn1-117"
    }
  }, [_vm._v("117.")]), _vm._v(" 374 U.S. 203, 222 (1963). The phrase is repeated in Board of Educ. v. Allen, 392 U.S. 236, 243 (1968), with a citation to "), _c('em', [_vm._v("Schempp")]), _vm._v(". It is incorporated into the three-part test in "), _c('em', [_vm._v("Lemon")]), _vm._v(", 403 U.S. at 612, with a citation to "), _c('em', [_vm._v("Allen")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_118",
      "id": "fn1-118"
    }
  }, [_vm._v("118.")]), _vm._v(" "), _c('em', [_vm._v("Schempp")]), _vm._v(", 374 U.S. at 222.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_119",
      "id": "fn1-119"
    }
  }, [_vm._v("119.")]), _vm._v(" This is an excellent example of how the substitution of judicial formulas for constitutional text can change the meaning of constitutional rights. "), _c('em', [_vm._v("See generally")]), _vm._v(" Robert F. Nagel, "), _c('em', [_vm._v("The Formulaic Constitution")]), _vm._v(", 84 M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ICH")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 165 (1985).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_120",
      "id": "fn1-120"
    }
  }, [_vm._v("120.")]), _vm._v(" Comm. for Pub. Educ. & Religious Liberty v. Nyquist, 413 U.S. 756, 783–84 n.39 (1973).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_121",
      "id": "fn1-121"
    }
  }, [_vm._v("121.")]), _vm._v(" "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", Witters v. Wash. Dep’t of Servs. for the Blind, 474 U.S. 481, 485 (1986); Grand Rapids Sch. Dist. v. Ball, 473 U.S. 373, 382–83 (1985); Wallace v. Jaffree, 472 U.S. 38, 55 (1985); Lynch v. Donnelly, 465 U.S. 668, 679 (1984).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_122",
      "id": "fn1-122"
    }
  }, [_vm._v("122.")]), _vm._v(" Johnson v. Huntington Beach Union High Sch. Dist., 137 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AL")]), _vm._v(". Rptr. 43, 49 (Ct. App.) (1977); Teitel, "), _c('em', [_vm._v("supra")]), _vm._v(" note 56, at 562–65.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_123",
      "id": "fn1-123"
    }
  }, [_vm._v("123.")]), _vm._v(" Teitel, "), _c('em', [_vm._v("supra")]), _vm._v(" note 56, at 582.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_124",
      "id": "fn1-124"
    }
  }, [_vm._v("124.")]), _vm._v(" "), _c('em', [_vm._v("See supra")]), _vm._v(" note 60.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_125",
      "id": "fn1-125"
    }
  }, [_vm._v("125.")]), _vm._v(" Incidental expenses of equal access are analyzed at greater length in Grossmann, "), _c('em', [_vm._v("supra")]), _vm._v(" note 97, at 761–67.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_126",
      "id": "fn1-126"
    }
  }, [_vm._v("126.")]), _vm._v(" "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", Lemon v. Kurtzman, 403 U.S. 602, 613, 619–24 (1971).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_127",
      "id": "fn1-127"
    }
  }, [_vm._v("127.")]), _vm._v(" Larkin v. Grendel’s Den, Inc., 459 U.S. 116, 122 (1982); Comm. for Pub. Educ. & Religious Liberty v. Nyquist, 413 U.S. 756, 761 (1973); Everson v. Board of Educ., 330 U.S. 1, 16 (1947); Reynolds v. United States, 98 U.S. 145, 164 (1878).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_128",
      "id": "fn1-128"
    }
  }, [_vm._v("128.")]), _vm._v(" 741 F.2d 538 (3d Cir. 1984), "), _c('em', [_vm._v("vacated on other grounds")]), _vm._v(", 475 U.S. 534 (1986); "), _c('em', [_vm._v("see also supra")]), _vm._v(" notes 14–18 and accompanying text.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_129",
      "id": "fn1-129"
    }
  }, [_vm._v("129.")]), _vm._v(" "), _c('em', [_vm._v("Bender")]), _vm._v(", 741 F.2d at 556–57.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_130",
      "id": "fn1-130"
    }
  }, [_vm._v("130.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at 556. The superficially similar reasoning in Nartowicz v. Clayton County Sch. Dist., 736 F.2d 646, 649 (11th Cir. 1984), did not relate to announcements of student organizations. The school district in "), _c('em', [_vm._v("Nartowicz")]), _vm._v(" announced off-campus “secular” activities of churches.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_131",
      "id": "fn1-131"
    }
  }, [_vm._v("131.")]), _vm._v(" Healy v. James, 408 U.S. 169, 181–83 (1972); "), _c('em', [_vm._v("cf")]), _vm._v(". Perry Educ. Ass’n v. Perry Local Educators’ Ass’n, 460 U.S. 37, 45–46 (1983). "), _c('em', [_vm._v("Perry")]), _vm._v(" held that teacher mailboxes were not a public forum. But unlike the bulletin boards and intercoms in "), _c('em', [_vm._v("Healy")]), _vm._v(" and "), _c('em', [_vm._v("Bender")]), _vm._v(", the mailboxes in "), _c('em', [_vm._v("Perry")]), _vm._v(" had not been made generally available to a wide range of organizations.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_132",
      "id": "fn1-132"
    }
  }, [_vm._v("132.")]), _vm._v(" Douglas Laycock, "), _c('em', [_vm._v("Towards a General Theory of the Religion Clauses: The Case of Church Labor Relations and the Right to Church Autonomy")]), _vm._v(", 81 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OLUM")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1373, 1378–83, 1392–94 (1981) [in volume 2 at 241–47, 258–60]; "), _c('em', [_vm._v("accord")]), _vm._v(" Arlin M. Adams & William R. Hanlon, "), _c('em', [_vm._v("Jones v. Wolf: Church Autonomy and the Religion Clauses of the First Amendment")]), _vm._v(", 128 U. P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1291, 1336–37 (1980).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_133",
      "id": "fn1-133"
    }
  }, [_vm._v("133.")]), _vm._v(" "), _c('em', [_vm._v("See supra")]), _vm._v(" notes 102–15 and accompanying text.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_134",
      "id": "fn1-134"
    }
  }, [_vm._v("134.")]), _vm._v(" McDaniel v. Paty, 435 U.S. 618 (1978).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_135",
      "id": "fn1-135"
    }
  }, [_vm._v("135.")]), _vm._v(" The most sophisticated version of this argument appears in Laurence H. Tribe, "), _c('em', [_vm._v("The Supreme Court, 1972 Term—Foreword: Toward a Model of Roles in the Due Process of Life and Law")]), _vm._v(", 87 H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARV")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1, 21–25 (1973). Professor Tribe later recanted. See T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RIBE")]), _vm._v(", "), _c('em', [_vm._v("supra")]), _vm._v(" note 28, § 15–10, at 928.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_136",
      "id": "fn1-136"
    }
  }, [_vm._v("136.")]), _vm._v(" Harris v. McRae, 448 U.S. 297, 319 (1980).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_137",
      "id": "fn1-137"
    }
  }, [_vm._v("137.")]), _vm._v(" Bender v. Williamsport Area Sch. Dist., 741 F.2d 538, 543 (3d Cir. 1984), "), _c('em', [_vm._v("vacated on other grounds")]), _vm._v(", 475 U.S. 534 (1986); "), _c('em', [_vm._v("see also")]), _vm._v(" Brandon v. Board of Educ., 635 F.2d 971, 979 (2d Cir. 1980).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_138",
      "id": "fn1-138"
    }
  }, [_vm._v("138.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" Laycock, "), _c('em', [_vm._v("supra")]), _vm._v(" note 132, at 1383 [in volume 2 at 246–47].")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_139",
      "id": "fn1-139"
    }
  }, [_vm._v("139.")]), _vm._v(" "), _c('em', [_vm._v("See id")]), _vm._v(". at 1392–94 [in volume 2 at 258–60].")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_140",
      "id": "fn1-140"
    }
  }, [_vm._v("140.")]), _vm._v(" "), _c('em', [_vm._v("See Bender")]), _vm._v(", 741 F.2d at 554–55.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_141",
      "id": "fn1-141"
    }
  }, [_vm._v("141.")]), _vm._v(" 20 U.S.C. § 4071(a) (Supp. 1985).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_142",
      "id": "fn1-142"
    }
  }, [_vm._v("142.")]), _vm._v(" Monitors apparently are not required by state law in many states. Strossen, "), _c('em', [_vm._v("supra")]), _vm._v(" note 70, at 175–76 n.138; Grossmann, "), _c('em', [_vm._v("supra")]), _vm._v(" note 97, at 783–84 (collecting cases).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_143",
      "id": "fn1-143"
    }
  }, [_vm._v("143.")]), _vm._v(" "), _c('em', [_vm._v("Bender")]), _vm._v(", 741 F.2d at 552, "), _c('em', [_vm._v("quoted with approval in")]), _vm._v(" Teitel, "), _c('em', [_vm._v("supra")]), _vm._v(" note 56, at 569. Similar concerns were expressed in Brandon v. Board of Educ., 635 F.2d 971, 979 (2d Cir. 1980).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_144",
      "id": "fn1-144"
    }
  }, [_vm._v("144.")]), _vm._v(" The affidavits stated that the monitor graded papers and took no part in the meetings. "), _c('em', [_vm._v("Bender")]), _vm._v(", 741 F.2d at 544.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_145",
      "id": "fn1-145"
    }
  }, [_vm._v("145.")]), _vm._v(" The trial court granted summary judgment for Petros. The court of appeals agreed that the case was appropriate for summary judgment, "), _c('em', [_vm._v("id")]), _vm._v(". at 542, but reversed, "), _c('em', [_vm._v("id.")]), _vm._v(" at 561. The effect of this reversal was to order summary judgment for the school.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_146",
      "id": "fn1-146"
    }
  }, [_vm._v("146.")]), _vm._v(" Unpublished comment on an early draft of this Article.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_147",
      "id": "fn1-147"
    }
  }, [_vm._v("147.")]), _vm._v(" Teitel, "), _c('em', [_vm._v("supra")]), _vm._v(" note 56, at 571 n.221; "), _c('em', [_vm._v("see, e.g")]), _vm._v("., Tinker v. Des Moines Indep. Community Sch. Dist., 393 U.S. 503, 506 (1969); Pickering v. Board of Educ., 391 U.S. 563 (1968); Shelton v. Tucker, 364 U.S. 479, 487 (1960).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_148",
      "id": "fn1-148"
    }
  }, [_vm._v("148.")]), _vm._v(" Teitel, "), _c('em', [_vm._v("supra")]), _vm._v(" note 56, at 571 n.221.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_149",
      "id": "fn1-149"
    }
  }, [_vm._v("149.")]), _vm._v(" "), _c('em', [_vm._v("But see")]), _vm._v(" May v. Evansville-Vanderburgh Sch. Corp., 787 F.2d 1105 (7th Cir. 1986). "), _c('em', [_vm._v("May")]), _vm._v(" held that the school, which allowed no group meetings of teachers, did not have to allow a teacher prayer group to meet. But the teachers were entitled to be in the building and not yet required to be at work. "), _c('em', [_vm._v("Id")]), _vm._v(". at 1107–08. Under those circumstances, a rule forbidding them to meet is facially unconstitutional. "), _c('em', [_vm._v("See infra")]), _vm._v(" notes 227–28 and accompanying text. The court agreed that the teachers’ speech was protected under the circumstances, but it unpersuasively argued that meetings for the purpose of speech were not protected. "), _c('em', [_vm._v("May")]), _vm._v(", 787 F.2d at 1110–12. The court’s arguments all assumed that the teachers were claiming a preferential right to use the school buildings for meetings. "), _c('em', [_vm._v("See id.")]), _vm._v(" In fact, the school was claiming a right to censor private speech in a place that the teachers had a right to be.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_150",
      "id": "fn1-150"
    }
  }, [_vm._v("150.")]), _vm._v(" "), _c('em', [_vm._v("But cf.")]), _vm._v(" James v. Board of Educ., 461 F.2d 566, 574 (2d Cir. 1972) (teacher wore black armband in class; court assumed that students understood it as expression of teacher’s personal views).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_151",
      "id": "fn1-151"
    }
  }, [_vm._v("151.")]), _vm._v(" Bender v. Williamsport Area Sch. Dist., 741 F.2d 538, 552 (3d Cir. 1984), "), _c('em', [_vm._v("vacated on other grounds")]), _vm._v(", 475 U.S. 534 (1986).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_152",
      "id": "fn1-152"
    }
  }, [_vm._v("152.")]), _vm._v(" "), _c('em', [_vm._v("Bender")]), _vm._v(", 741 F.2d at 552.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_153",
      "id": "fn1-153"
    }
  }, [_vm._v("153.")]), _vm._v(" "), _c('em', [_vm._v("Id.")])]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_154",
      "id": "fn1-154"
    }
  }, [_vm._v("154.")]), _vm._v(" "), _c('em', [_vm._v("See id.")]), _vm._v(" at 561; Brandon v. Board of Educ., 635 F.2d 971, 978 (2d Cir. 1980).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_155",
      "id": "fn1-155"
    }
  }, [_vm._v("155.")]), _vm._v(" "), _c('em', [_vm._v("See Brandon")]), _vm._v(", 635 F.2d at 978.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_156",
      "id": "fn1-156"
    }
  }, [_vm._v("156.")]), _vm._v(" Zorach v. Clauson, 343 U.S. 306, 324 (1952) (Jackson, J., dissenting).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_157",
      "id": "fn1-157"
    }
  }, [_vm._v("157.")]), _vm._v(" 333 U.S. 203 (1948).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_158",
      "id": "fn1-158"
    }
  }, [_vm._v("158.")]), _vm._v(" 343 U.S. 306 (1952).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_159",
      "id": "fn1-159"
    }
  }, [_vm._v("159.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" Lanner v. Wimmer, 662 F.2d 1349, 1354 (10th Cir. 1981) (upholding released time in church building adjacent to school building and wired to hear school’s intercom and bell system).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_160",
      "id": "fn1-160"
    }
  }, [_vm._v("160.")]), _vm._v(" "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", Kurland, "), _c('em', [_vm._v("supra")]), _vm._v(" note 10, at 77.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_161",
      "id": "fn1-161"
    }
  }, [_vm._v("161.")]), _vm._v(" "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", Engel v. Vitale, 370 U.S. 421, 430–31 (1962).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_162",
      "id": "fn1-162"
    }
  }, [_vm._v("162.")]), _vm._v(" Bender v. Williamsport Area Sch. Dist., 741 F.2d 538, 553 (3d Cir. 1984), "), _c('em', [_vm._v("vacated on other grounds")]), _vm._v(", 475 U.S. 534 (1986).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_163",
      "id": "fn1-163"
    }
  }, [_vm._v("163.")]), _vm._v(" By contrast, there was coercion in Bell v. Little Axe Indep. Sch. Dist. No. 70, 766 F.2d 1391 (10th Cir. 1985). The school district had a stated policy of equal access, but only the religious group met between the arrival of school buses and the beginning of class. "), _c('em', [_vm._v("Id.")]), _vm._v(" at 1405. Nonparticipants were required to wait outside, or in the gymnasium during bad weather. "), _c('em', [_vm._v("Id")]), _vm._v(". at 1397 n.4. The court could have invalidated that scheme as coercive.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-Body"
  }, [_vm._v("The contrast between "), _c('em', [_vm._v("Bender")]), _vm._v(" and "), _c('em', [_vm._v("Bell")]), _vm._v(" illustrates the irrelevance of one distinction offered by some opponents of the Equal Access Act. They argue that the Act applies only to schools where student groups meet before the first class in the morning or after the last class in the afternoon, but not to schools where student groups meet during an activity period between classes. John D. Thompson, Note, "), _c('em', [_vm._v("Student Religious Groups and the Right of Access to Public School Activity Periods")]), _vm._v(", 74 G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EO")]), _vm._v(". L.J. 205, 208 n.19, 217–18 (1985). But Williamsport had a noncoercive open forum during the school day, and Little Axe coerced students to participate before the first class. The statutory language does not compel this distinction, because a student activity period is “noninstructional time,” 20 U.S.C. § 4071(b) (Supp. 1985), “set aside by the school” before the next period when “actual classroom instruction begins” and after the previous period when “actual classroom instruction ends,” "), _c('em', [_vm._v("id.")]), _vm._v(" § 4072(4). Roughly equal numbers of statements on the floor of Congress go each way on the issue of activity periods during the day. Note, "), _c('em', [_vm._v("supra")]), _vm._v(", at 217 n.83. Teitel concedes that the issue is “unclear.” Teitel, "), _c('em', [_vm._v("supra")]), _vm._v(" note 56, at 563–64 n.175.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_164",
      "id": "fn1-164"
    }
  }, [_vm._v("164.")]), _vm._v(" Teitel, "), _c('em', [_vm._v("supra")]), _vm._v(" note 56, at 562–63, 568. For a more modest conclusion drawn from the same premise, see Strossen, "), _c('em', [_vm._v("supra")]), _vm._v(" note 70, at 175.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_165",
      "id": "fn1-165"
    }
  }, [_vm._v("165.")]), _vm._v(" Teitel, "), _c('em', [_vm._v("supra")]), _vm._v(" note 56, at 568. She supports this characterization with a reference to Abington School Dist. v. Schempp, 374 U.S. 203, 223 (1963). But there really were captive audiences in "), _c('em', [_vm._v("Schempp")]), _vm._v(" and its companion case. In "), _c('em', [_vm._v("Schempp")]), _vm._v(", Bible verses and the Lord’s Prayer were read over the school’s public address system. Students were asked to stand and repeat the prayer in unison. "), _c('em', [_vm._v("Id")]), _vm._v(". at 207. In "), _c('em', [_vm._v("Schempp")]), _vm._v("’s companion case, the state required schools to open each day with a Bible reading, the Lord’s Prayer, or both. Students could be excused only with a written excuse from a parent. "), _c('em', [_vm._v("Id")]), _vm._v(". at 211–12. For an equally preposterous analogy to "), _c('em', [_vm._v("Schempp")]), _vm._v(", see Teitel, "), _c('em', [_vm._v("supra")]), _vm._v(" note 56, at 570.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_166",
      "id": "fn1-166"
    }
  }, [_vm._v("166.")]), _vm._v(" 20 U.S.C. § 4071(a) (Supp. 1985).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_167",
      "id": "fn1-167"
    }
  }, [_vm._v("167.")]), _vm._v(" Cornelius v. NAACP Legal Defense & Educ. Fund, 473 U.S. 788, 800–06 (1985); Perry Educ. Ass’n v. Perry Local Educators’ Ass’n, 460 U.S. 37, 45–49 (1983); Southeastern Promotions, Ltd. v. Conrad, 420 U.S. 546, 552 (1975).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_168",
      "id": "fn1-168"
    }
  }, [_vm._v("168.")]), _vm._v(" 130 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONG")]), _vm._v(". R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EC")]), _vm._v(". S8341 (daily ed. June 27, 1984) (statement of Sen. Leahy).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_169",
      "id": "fn1-169"
    }
  }, [_vm._v("169.")]), _vm._v(" Lucy B. Mullins, Note, "), _c('em', [_vm._v("Education for Economic Security Acts: The Secular Humanism Ban and Equal Access Act")]), _vm._v(", 43 W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ASH")]), _vm._v(". & L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EE")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 265, 291–93 (1986). Professor Lupu is more optimistic, but his review of the Act is superficial. "), _c('em', [_vm._v("See")]), _vm._v(" Lupu, "), _c('em', [_vm._v("supra")]), _vm._v(" note 12, at 758–61.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_170",
      "id": "fn1-170"
    }
  }, [_vm._v("170.")]), _vm._v(" 20 U.S.C. § 4071(a).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_171",
      "id": "fn1-171"
    }
  }, [_vm._v("171.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". § 4071(3).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_172",
      "id": "fn1-172"
    }
  }, [_vm._v("172.")]), _vm._v(" Y"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UDOF")]), _vm._v(", "), _c('em', [_vm._v("supra")]), _vm._v(" note 11, at 225–26.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_173",
      "id": "fn1-173"
    }
  }, [_vm._v("173.")]), _vm._v(" 130 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONG")]), _vm._v(". R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EC")]), _vm._v(". S8342 (daily ed. June 27, 1984) (statement of Sen. Hatfield).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_174",
      "id": "fn1-174"
    }
  }, [_vm._v("174.")]), _vm._v(" Mergens v. Board of Educ., 5 Religious Freedom Rep. (Christian Legal Soc’y) 86, 87 (D. Neb. 1985) ["), _c('em', [_vm._v("rev’d")]), _vm._v(", 867 F.2d 1076 (8th Cir. 1989), "), _c('em', [_vm._v("aff’d")]), _vm._v(", 496 U.S. 226 (1990)]. Williamsport made a similar claim in "), _c('em', [_vm._v("Bender")]), _vm._v(", and a student commentator has endorsed it. "), _c('em', [_vm._v("See")]), _vm._v(" Thompson, "), _c('em', [_vm._v("supra")]), _vm._v(" note 163, at 208 n.19, 215–17.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_175",
      "id": "fn1-175"
    }
  }, [_vm._v("175.")]), _vm._v(" "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", 130 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONG")]), _vm._v(". R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EC")]), _vm._v(". S8345 (daily ed. June 27, 1984) (statement of Sen. Hatfield).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_176",
      "id": "fn1-176"
    }
  }, [_vm._v("176.")]), _vm._v(" "), _c('em', [_vm._v("See id.")]), _vm._v(" at S8344.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_177",
      "id": "fn1-177"
    }
  }, [_vm._v("177.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at S8345 (statement of Sen. Gorton).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_178",
      "id": "fn1-178"
    }
  }, [_vm._v("178.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at H7723 (daily ed. July 25, 1984) (motion of Rep. Perkins); "), _c('em', [_vm._v("id")]), _vm._v(". at H7733 (statement of Rep. Oakar); "), _c('em', [_vm._v("id")]), _vm._v(". at H7736 (statement of Rep. Fish).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_179",
      "id": "fn1-179"
    }
  }, [_vm._v("179.")]), _vm._v(" "), _c('em', [_vm._v("See id.")]), _vm._v(" at S8342 (daily ed. June 27, 1984).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_180",
      "id": "fn1-180"
    }
  }, [_vm._v("180.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_181",
      "id": "fn1-181"
    }
  }, [_vm._v("181.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_182",
      "id": "fn1-182"
    }
  }, [_vm._v("182.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_183",
      "id": "fn1-183"
    }
  }, [_vm._v("183.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_184",
      "id": "fn1-184"
    }
  }, [_vm._v("184.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_185",
      "id": "fn1-185"
    }
  }, [_vm._v("185.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_186",
      "id": "fn1-186"
    }
  }, [_vm._v("186.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_187",
      "id": "fn1-187"
    }
  }, [_vm._v("187.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_188",
      "id": "fn1-188"
    }
  }, [_vm._v("188.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_189",
      "id": "fn1-189"
    }
  }, [_vm._v("189.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at S8341 (statement of Sen. Leahy).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_190",
      "id": "fn1-190"
    }
  }, [_vm._v("190.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at H7736 (daily ed. July 25, 1984) (statement of Rep. Fish).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_191",
      "id": "fn1-191"
    }
  }, [_vm._v("191.")]), _vm._v(" S. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EP")]), _vm._v(". No. 98–357 at 10, 11 (1984).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_192",
      "id": "fn1-192"
    }
  }, [_vm._v("192.")]), _vm._v(" The vote in the House was 337–77. 130 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONG")]), _vm._v(". R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EC")]), _vm._v(". H7740–41 (daily ed. July 25, 1984) (Roll Call No. 313). The vote in the Senate was 88–11. "), _c('em', [_vm._v("Id.")]), _vm._v(" at S8370 (daily ed. June 27, 1984) (vote on Amendment No. 315).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_193",
      "id": "fn1-193"
    }
  }, [_vm._v("193.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at S8342–43 (daily ed. June 27, 1984) (statement of Sen. Hatfield); "), _c('em', [_vm._v("id")]), _vm._v(". (statement of Sen. Gorton); "), _c('em', [_vm._v("id")]), _vm._v(". at S8355 (statement of Sen. Levin); "), _c('em', [_vm._v("id")]), _vm._v(". at S8356 (statement of Sen. Denton); "), _c('em', [_vm._v("id")]), _vm._v(". at S8357 (statement of Sen. Durenberger); "), _c('em', [_vm._v("id")]), _vm._v(". at S8362 (statement of Sen. Mitchell); "), _c('em', [_vm._v("id")]), _vm._v(". at H7735 (daily ed. July 25, 1984) (statement of Rep. Rogers).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_194",
      "id": "fn1-194"
    }
  }, [_vm._v("194.")]), _vm._v(" "), _c('em', [_vm._v("Cf")]), _vm._v(". Susan Garrison, Comment, "), _c('em', [_vm._v("The Public School as Public Forum")]), _vm._v(", 54 T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EX")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 90, 116 (1975) (courts should hold that school-sponsored, after-school speakers create open public fora, lest school control supply of outside speakers).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_195",
      "id": "fn1-195"
    }
  }, [_vm._v("195.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" 130 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONG")]), _vm._v(". R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EC")]), _vm._v(". S8366 (daily ed. June 27, 1984) (statement of Sen. Grassley); "), _c('em', [_vm._v("id")]), _vm._v(". at S8365 (statement of Sen. Baucus); "), _c('em', [_vm._v("id")]), _vm._v(". at H7730 (daily ed. July 25, 1984) (statement of Rep. Clinger).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_196",
      "id": "fn1-196"
    }
  }, [_vm._v("196.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at S8367 (daily ed. June 27, 1984) (statement of Sen. Gorton).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_197",
      "id": "fn1-197"
    }
  }, [_vm._v("197.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at S8362 (statement of Sen. Dole).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_198",
      "id": "fn1-198"
    }
  }, [_vm._v("198.")]), _vm._v(" "), _c('em', [_vm._v("See id.")]), _vm._v(" at H7739 (daily ed. July 25, 1984) (statement of Rep. Synar); "), _c('em', [_vm._v("id.")]), _vm._v(" at H7736 (statement of Rep. Bonker). Other statements emphasized that schools could choose whether to have an open forum, but did not explicitly state that schools could close existing open fora. "), _c('em', [_vm._v("See id.")]), _vm._v(" at H7740 (statement of Rep. Frenzel); "), _c('em', [_vm._v("id.")]), _vm._v(" at H7732 (statement of Rep. Goodling); "), _c('em', [_vm._v("id")]), _vm._v(". at S8364 (daily ed. June 27, 1984) (statement of Sen. Thurmond); "), _c('em', [_vm._v("id")]), _vm._v(". at S8357 (statement of Sen. Durenberger). The Third Circuit has held that a plaintiff must show that a limited open forum existed after the effective date of the Act. Student Coalition for Peace v. Lower Merion Sch. Dist. Board of Sch. Directors, 776 F.2d 431, 443 (3d Cir. 1985).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_199",
      "id": "fn1-199"
    }
  }, [_vm._v("199.")]), _vm._v(" 130 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONG")]), _vm._v(". R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EC")]), _vm._v(". H7736 (daily ed. July 25, 1984) (statement of Rep. Pepper).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_200",
      "id": "fn1-200"
    }
  }, [_vm._v("200.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" Seyfried v. Walton, 668 F.2d 214 (3d Cir. 1981). "), _c('em', [_vm._v("But see")]), _vm._v(" Bowman v. Bethel-Tate Board of Educ., 610 F. Supp. 517 (S.D. Ohio 1985) (school play is extracurricular and not censorable if participation is voluntary).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_201",
      "id": "fn1-201"
    }
  }, [_vm._v("201.")]), _vm._v(" Note, "), _c('em', [_vm._v("Administrative Regulation, supra")]), _vm._v(" note 89, at 632–33. For other distinctions in the student newspaper cases, and incisive criticism of their First Amendment analysis, see Cass, "), _c('em', [_vm._v("supra")]), _vm._v(" note 51, at 1306–07, 1350–51. For recent cases see Kuhlmeier v. Hazelwood School Dist., 795 F.2d 1368 (8th Cir. 1986) (holding that school officials were not justified in censoring articles written for in-class student newspaper), "), _c('em', [_vm._v("cert. granted")]), _vm._v(", 479 U.S. 1053 (1987) ["), _c('em', [_vm._v("rev’d")]), _vm._v(", 484 U.S. 260 (1988)]; San Diego Comm. Against Registration & the Draft v. Governing Board, 790 F.2d 1471 (9th Cir. 1986) (invalidating censorship of student newspaper without regard to in-class/out-of-class distinction).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_202",
      "id": "fn1-202"
    }
  }, [_vm._v("202.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" Fraser v. Bethel Sch. Dist. No. 403, 755 F.2d 1356, 1364 (9th Cir. 1985) (student government is not part of curriculum), "), _c('em', [_vm._v("rev’d on other grounds")]), _vm._v(", 478 U.S. 675 (1986).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_203",
      "id": "fn1-203"
    }
  }, [_vm._v("203.")]), _vm._v(" Section 4071(c) provides:")]), _vm._v(" "), _c('p', {
    staticClass: "foot-left"
  }, [_vm._v("(c)"), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Schools shall be deemed to offer a fair opportunity to students who wish to conduct a meeting within its [sic] limited open forum if such school uniformly provides that")])]), _vm._v(" "), _c('p', {
    staticClass: "List36"
  }, [_vm._v("1."), _c('span', {
    staticClass: "pad"
  }, [_vm._v("The meeting is voluntary and student-initiated;")])]), _vm._v(" "), _c('p', {
    staticClass: "List36"
  }, [_vm._v("2."), _c('span', {
    staticClass: "pad"
  }, [_vm._v("there is no sponsorship of the meeting by the school, the government, or its agents or employees;")])]), _vm._v(" "), _c('p', {
    staticClass: "List36"
  }, [_vm._v("3."), _c('span', {
    staticClass: "pad"
  }, [_vm._v("employees or agents of the school or government are present at religious meetings only in a nonparticipatory capacity;")])]), _vm._v(" "), _c('p', {
    staticClass: "List36"
  }, [_vm._v("4."), _c('span', {
    staticClass: "pad"
  }, [_vm._v("the meeting does not materially and substantially interfere with the orderly conduct of educational activities within the school; and")])]), _vm._v(" "), _c('p', {
    staticClass: "List36"
  }, [_vm._v("5."), _c('span', {
    staticClass: "pad"
  }, [_vm._v("nonschool persons may not direct, conduct, control, or regularly attend activities of student groups.")])]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_204",
      "id": "fn1-204"
    }
  }, [_vm._v("204.")]), _vm._v(" "), _c('em', [_vm._v("Cf")]), _vm._v(". Jay Lawrence Westbrook, "), _c('em', [_vm._v("Glitch: Section 9–402(7) and the U.C.C. Revision Process")]), _vm._v(", 52 G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EO")]), _vm._v(". W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ASH")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 408, 408 n.1 (1984) (quoting etymology of “glitch” and applying concept to process of statutory drafting).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_205",
      "id": "fn1-205"
    }
  }, [_vm._v("205.")]), _vm._v(" There may be a state interest: the school might want to refrain from sponsoring controversial political groups. And there may be some First Amendment right to evenhandedness in sponsorship: a public school should not be allowed to sponsor the Young Republicans and refuse to sponsor the Young Democrats. Neither of these interests supports a federal ban on sponsoring any non-curriculum-related group.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_206",
      "id": "fn1-206"
    }
  }, [_vm._v("206.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" United States v. Finn, 502 F.2d 938, 941–43 (7th Cir. 1974) (construing 47 U.S.C. § 605 (now 47 U.S.C. § 605(a) (1982))). On its face, the Act forbids communications carriers to disclose messages in every circumstance in which Congress meant to authorize disclosure.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_207",
      "id": "fn1-207"
    }
  }, [_vm._v("207.")]), _vm._v(" The Act bars discrimination against “otherwise qualified handicapped individuals.” 29 U.S.C. § 794 (1982). Realizing that a blind bus driver could be otherwise qualified, the implementing agency excised “otherwise” and protected only “qualified handicapped individuals.” 45 C.F.R. § 84.3(k) (1984); "), _c('em', [_vm._v("id")]), _vm._v(". at pt. 84, app. A, § 5.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_208",
      "id": "fn1-208"
    }
  }, [_vm._v("208.")]), _vm._v(" For my strong commitment to operative legal texts, see Douglas Laycock, "), _c('em', [_vm._v("Taking Constitutions Seriously: A Theory of Judicial Review")]), _vm._v(", 59 T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EX")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 343 (1981).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_209",
      "id": "fn1-209"
    }
  }, [_vm._v("209.")]), _vm._v(" Here are excerpts from the relevant colloquy:")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('strong', [_vm._v("Mr. GORTON")]), _vm._v(".… But those strictures will apply to all noncurriculum-related student activities which may use the open forum?")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('strong', [_vm._v("Mr. HATFIELD.")]), _vm._v(" That is correct.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('strong', [_vm._v("Mr. GORTON")]), _vm._v(". This also means that there can be no sponsorship or teacher leadership or significant participation in the operation of the student Young Republican Club or Young Democratic Club, or Young Americans for Freedom, does it not?")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('strong', [_vm._v("Mr. HATFIELD")]), _vm._v(". This tightens up the whole area of activity in anything involving student-initiated noncurriculum-related activities, whether they be religious or otherwise. It could be political. All these things can have someone in a custodial role.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_vm._v("…")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('strong', [_vm._v("Mr. GORTON.")]), _vm._v(" The teacher or administration employee participation in the political club can be no greater than its very limited participation in the religious club, can it?")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('strong', [_vm._v("Mr. HATFIELD.")]), _vm._v(" That is correct.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('strong', [_vm._v("Mr. GORTON")]), _vm._v(". And going back to my earlier example of the chess club, it can be no greater than its participation in the chess club.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('strong', [_vm._v("Mr. HATFIELD")]), _vm._v(". I believe that is right.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('strong', [_vm._v("Mr. GORTON")]), _vm._v(". So the question is whether it is curriculum related. If it is not curriculum related, the Senator’s amendment is providing controls over the faculty and administration personnel considerably greater than are many school districts in the United States today, is it not?")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('strong', [_vm._v("Mr. HATFIELD")]), _vm._v(". That is true. What we are trying to get at here, I say to the Senator from Washington, is the question of separation of church and state. It is not involved in a chess club, not involved in a political club, but it is involved in the basic framework of our Constitution. I suppose it is like a net: When you throw the net out, you are going to garner in a few other things, but I do not think to the detriment or [sic] the efficiency of what you are seeking. It will not create a difficult problem.")]), _vm._v(" "), _c('p', {
    staticClass: "f-HPara"
  }, [_vm._v("130 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONG")]), _vm._v(". R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EC")]), _vm._v(". S8342–43 (daily ed. June 27, 1984).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_210",
      "id": "fn1-210"
    }
  }, [_vm._v("210.")]), _vm._v(" At least some members of Congress assumed that schools with open fora could abolish them, even if their motive in doing so was to avoid equal access. "), _c('em', [_vm._v("See supra")]), _vm._v(" note 198.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_211",
      "id": "fn1-211"
    }
  }, [_vm._v("211.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" Teitel, "), _c('em', [_vm._v("supra")]), _vm._v(" note 56, at 565. Later, she concedes that the ban on faculty sponsors for nonreligious groups was “apparently unintended.” "), _c('em', [_vm._v("Id.")]), _vm._v(" at 576.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_212",
      "id": "fn1-212"
    }
  }, [_vm._v("212.")]), _vm._v(" This agreement appears in a set of “Equal Access Guidelines” negotiated after passage. Two of the House sponsors inserted these guidelines into the "), _c('em', [_vm._v("Congressional Record")]), _vm._v(", 130 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONG")]), _vm._v(". R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EC")]), _vm._v(". H12, 272 (daily ed. Oct. 11, 1984), but no congressmen participated in their drafting, "), _c('em', [_vm._v("id")]), _vm._v(". at H12, 272–73. They are in no sense legislative history.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_213",
      "id": "fn1-213"
    }
  }, [_vm._v("213.")]), _vm._v(" "), _c('em', [_vm._v("See infra")]), _vm._v(" notes 243–46 and accompanying text.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_214",
      "id": "fn1-214"
    }
  }, [_vm._v("214.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" Y"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UDOF")]), _vm._v(", "), _c('em', [_vm._v("supra")]), _vm._v(" note 11, at 225–27.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_215",
      "id": "fn1-215"
    }
  }, [_vm._v("215.")]), _vm._v(" 473 U.S. 788 (1985).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_216",
      "id": "fn1-216"
    }
  }, [_vm._v("216.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at 802 (quoting Perry Educ. Ass’n v. Perry Local Educators’ Ass’n, 460 U.S. 37, 45 (1983)).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_217",
      "id": "fn1-217"
    }
  }, [_vm._v("217.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at 800.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_218",
      "id": "fn1-218"
    }
  }, [_vm._v("218.")]), _vm._v(" "), _c('em', [_vm._v("Id.")]), _vm._v(" at 802.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_219",
      "id": "fn1-219"
    }
  }, [_vm._v("219.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at 800.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_220",
      "id": "fn1-220"
    }
  }, [_vm._v("220.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". (quoting "), _c('em', [_vm._v("Perry")]), _vm._v(", 460 U.S. at 45).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_221",
      "id": "fn1-221"
    }
  }, [_vm._v("221.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at 805–06.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_222",
      "id": "fn1-222"
    }
  }, [_vm._v("222.")]), _vm._v(" "), _c('em', [_vm._v("But cf")]), _vm._v(". Larson v. Valente, 456 U.S. 228, 245–46 (1982) (requiring states to treat least favored groups equally with most favored groups provides powerful protection to unfavored groups) (quoting Railway Express Agency v. New York, 336 U.S. 106, 112 (1949) (Jackson, J., concurring)); J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OHN")]), _vm._v(" H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ART")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LY")]), _vm._v(", D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EMOCRACY")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND")]), _vm._v(" D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISTRUST")]), _vm._v(" 81–87 (Harvard 1980) (same).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_223",
      "id": "fn1-223"
    }
  }, [_vm._v("223.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" Perry Educ. Ass’n v. Perry Local Educators’ Ass’n, 460 U.S. 37, 46–49 (1983). The defendant granted one teachers’ union access to the campus mail system and denied access to all others. The Court found no hostility to the views of the competing unions; instead, it found that the restriction served the legitimate goal of “insuring labor peace.” "), _c('em', [_vm._v("Id.")]), _vm._v(" at 52. “Insuring labor peace” seems to be a euphemism for suppressing all competition to the exclusive bargaining representative. For further analysis, see Farber & Nowak, "), _c('em', [_vm._v("supra")]), _vm._v(" note 51, at 1253–57.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-Body"
  }, [_vm._v("Fortunately, cases restricting labor speech do not seem to be used as precedent for other kinds of speakers. "), _c('em', [_vm._v("Compare")]), _vm._v(" NAACP v. Claiborne Hardware Co., 458 U.S. 886, 912–15 (1982) (political boycott by black consumers is protected speech) "), _c('em', [_vm._v("with")]), _vm._v(" International Longshoremen’s Ass’n v. Allied Int’l, Inc., 456 U.S. 212, 226 (1982) (political boycott by labor union is not protected speech). For an attempt to reconcile the two cases on the basis of the boycotters’ relative economic power, see Michael C. Harper, "), _c('em', [_vm._v("The Consumer’s Emerging Right to Boycott")]), _vm._v(": "), _c('em', [_vm._v("NAACP v. Claiborne Hardware and Its Implications for American Labor Law")]), _vm._v(", 93 Y"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALE")]), _vm._v(" L.J. 409, 426–29 (1984).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_224",
      "id": "fn1-224"
    }
  }, [_vm._v("224.")]), _vm._v(" Southeastern Promotions, Ltd. v. Conrad, 420 U.S. 546, 555–56 (1975); Grayned v. City of Rockford, 408 U.S. 104, 116–17 (1972) (“The crucial question is whether the manner of expression is basically incompatible with the normal activity of a particular place at a particular time.”); "), _c('em', [_vm._v("see")]), _vm._v(" Keith Werhan, "), _c('em', [_vm._v("The Supreme Court’s Public Forum Doctrine and the Return of Formalism")]), _vm._v(", 7 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARDOZO")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 335, 423–26 (1986). Compare Adderly v. Florida, 385 U.S. 39 (1966) (protest on jail grounds not protected) with Brown v. Louisiana, 383 U.S. 131 (1966) (silent protest in public library protected). Language in "), _c('em', [_vm._v("Cornelius")]), _vm._v(" suggests that it is still important to decide whether speech is compatible with the locale: “We will not find that a public forum has been created in the face of clear evidence of a contrary intent, … nor will we infer that the Government intended to create a public forum when the nature of the property is inconsistent with expressive activity.” Cornelius v. NAACP Legal Defense & Educ. Fund, 473 U.S. 788, 803 (1985). Perhaps intention can be objectified into a largely fictional “reasonable intent,” in which the government is presumed to intend to permit speech except when it has strong reasons not to. "), _c('em', [_vm._v("See")]), _vm._v(" Cass, "), _c('em', [_vm._v("supra")]), _vm._v(" note 51, at 1305–06 (suggesting that courts have merged the two tests in this way in student newspaper cases).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_225",
      "id": "fn1-225"
    }
  }, [_vm._v("225.")]), _vm._v(" 393 U.S. 503 (1969).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_226",
      "id": "fn1-226"
    }
  }, [_vm._v("226.")]), _vm._v(" "), _c('em', [_vm._v("Cornelius")]), _vm._v(", 473 U.S. at 823 n.3 (Blackmun, J., dissenting).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_227",
      "id": "fn1-227"
    }
  }, [_vm._v("227.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" Jamison v. Texas, 318 U.S. 413, 416 (1943); Texas State Teachers Ass’n v. Garland Indep. Sch. Dist., 777 F.2d 1046, 1053–55 (5th Cir. 1985), "), _c('em', [_vm._v("aff’d mem")]), _vm._v("., 479 U.S. 801 (1986); Garrison, "), _c('em', [_vm._v("supra")]), _vm._v(" note 194, at 105–07, 111; "), _c('em', [_vm._v("see also")]), _vm._v(" Cass, "), _c('em', [_vm._v("supra")]), _vm._v(" note 51, at 1343–44.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_228",
      "id": "fn1-228"
    }
  }, [_vm._v("228.")]), _vm._v(" The Court did note that the school’s toleration of other political symbols aggravated the constitutional violation. "), _c('em', [_vm._v("Tinker")]), _vm._v(", 393 U.S. at 510–11. But there was no holding that the school had created a limited public forum.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_229",
      "id": "fn1-229"
    }
  }, [_vm._v("229.")]), _vm._v(" A student commentator’s characterization of "), _c('em', [_vm._v("Tinker")]), _vm._v(" as a public forum case overlooks both the students’ right to be where they were and the noncontingent nature of their rights. "), _c('em', [_vm._v("See")]), _vm._v(" James C. Dever III, Note, "), _c('em', [_vm._v("Tinker Revisited: Fraser v. Bethel School District and Regulation of Speech in the Public Schools")]), _vm._v(", 1985 D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UKE")]), _vm._v(" L.J. 1164, 1174–77. The student’s characterization of "), _c('em', [_vm._v("Tinker")]), _vm._v(" is irrelevant to his thesis that student speech is subject to reasonable time, place, and manner restrictions.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_230",
      "id": "fn1-230"
    }
  }, [_vm._v("230.")]), _vm._v(" "), _c('em', [_vm._v("Cf.")]), _vm._v(" Y"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UDOF")]), _vm._v(", "), _c('em', [_vm._v("supra")]), _vm._v(" note 11, at 225–27. Yudof argues that so long as normal educational functions are not disrupted, schools should be public fora even for persons other than students and faculty. I do not disagree, but I do not have to defend that proposal to defend the position taken in this Article.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_231",
      "id": "fn1-231"
    }
  }, [_vm._v("231.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" Werhan, "), _c('em', [_vm._v("supra")]), _vm._v(" note 224, at 406.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_232",
      "id": "fn1-232"
    }
  }, [_vm._v("232.")]), _vm._v(" Farber and Nowak note that in "), _c('em', [_vm._v("Widmar")]), _vm._v(", the Court finessed this problem of the relationship between the speakers entitled to access to the forum and the state’s right to close the forum. Farber & Nowak, "), _c('em', [_vm._v("supra")]), _vm._v(" note 51, at 1249. They seem to treat the problem as inherent in public forum doctrine, rather than as a glitch in the Court’s formulation of public forum doctrine. One court of appeals sensibly has found that student newspapers are a limited public forum for students; the court did not recognize the difficulties caused by the Supreme Court’s formulation. "), _c('em', [_vm._v("See")]), _vm._v(" San Diego Comm. Against Registration & the Draft v. Governing Board, 790 F.2d 1471, 1476 (9th Cir. 1986).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_233",
      "id": "fn1-233"
    }
  }, [_vm._v("233.")]), _vm._v(" Board of Educ. v. Pico, 457 U.S. 853, 864–71 (1982) (plurality opinion); "), _c('em', [_vm._v("id")]), _vm._v(". at 876–77 (Blackmun, J., concurring); Healy v. James, 408 U.S. 169, 180–81 (1972); Tinker v. Des Moines Indep. Community Sch. Dist., 393 U.S. 503, 511–13 (1969); Epperson v. Arkansas, 393 U.S. 97, 104–05 (1968); Keyishian v. Board of Regents, 385 U.S. 589, 603 (1967); Shelton v. Tucker, 364 U.S. 479, 487 (1960).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_234",
      "id": "fn1-234"
    }
  }, [_vm._v("234.")]), _vm._v(" The Court said that the university officials in "), _c('em', [_vm._v("Widmar")]), _vm._v(" intended to create a public forum but mistakenly concluded that the Establishment Clause prevented them from allowing religious groups to participate. That is not entirely accurate, because the defendants also argued that the Missouri constitution barred the university from allowing religious groups to participate. The Court did not characterize the defendants’ view of the state constitution as mistaken; nor did it attribute to the defendants an intention to create a forum in defiance of the state constitution. "), _c('em', [_vm._v("Widmar")]), _vm._v(" found a federal right of access to a university open forum that overrode contrary state law.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_235",
      "id": "fn1-235"
    }
  }, [_vm._v("235.")]), _vm._v(" "), _c('em', [_vm._v("Cornelius")]), _vm._v(", 473 U.S. at 803 (citing "), _c('em', [_vm._v("Widmar")]), _vm._v(", 454 U.S. at 267 n.5).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_236",
      "id": "fn1-236"
    }
  }, [_vm._v("236.")]), _vm._v(" Board of Airport Comm’rs v. Jews for Jesus, Inc., 479 U.S. 812 (1986), "), _c('em', [_vm._v("granting cert. to")]), _vm._v(" 785 F.2d 791 (9th Cir. 1986). [The Court protected Jews for Jesus under overbreadth doctrine, without regard to whether the airport was a public forum. 482 U.S. 569 (1987).]")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_237",
      "id": "fn1-237"
    }
  }, [_vm._v("237.")]), _vm._v(" Teitel, "), _c('em', [_vm._v("supra")]), _vm._v(" note 56, at 579–90. She proposes a “unitary forum analysis,” in which increasing government control of a site simultaneously erodes its status as a forum and escalates the state’s Establishment Clause responsibility for any religious speech that occurs there. The Establishment Clause half of this analysis merely repeats her earlier arguments about school “involvement” in private religious speech on campus. "), _c('em', [_vm._v("Id")]), _vm._v(". at 586.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_238",
      "id": "fn1-238"
    }
  }, [_vm._v("238.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" cases cited "), _c('em', [_vm._v("supra")]), _vm._v(" note 233.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_239",
      "id": "fn1-239"
    }
  }, [_vm._v("239.")]), _vm._v(" The distinction between meetings and other speech was crucial to May v. Evansville-Vanderburgh School Corp., 787 F.2d 1105 (7th Cir. 1986). But "), _c('em', [_vm._v("May")]), _vm._v(" dealt with meetings of teachers, which required no monitor. For criticism of the case, see "), _c('em', [_vm._v("supra")]), _vm._v(" note 149.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_240",
      "id": "fn1-240"
    }
  }, [_vm._v("240.")]), _vm._v(" Schneider v. New Jersey, 308 U.S. 147, 162–63 (1939).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_241",
      "id": "fn1-241"
    }
  }, [_vm._v("241.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" Vince Blasi, "), _c('em', [_vm._v("Prior Restraints on Demonstrations")]), _vm._v(", 68 M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ICH")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1481, 1527–32 (1970); David Goldberger, "), _c('em', [_vm._v("A Reconsideration of Cox v. New Hampshire: Can All Demonstrators Be Required to Pay the Cost of Using America’s Public Forums?")]), _vm._v(", 62 T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EX")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 403 (1983); Eric Neisser, "), _c('em', [_vm._v("Charging for Free Speech: User Fees and Insurance in the Marketplace of Ideas")]), _vm._v(", 74 G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EO")]), _vm._v(". L.J. 257 (1985).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_242",
      "id": "fn1-242"
    }
  }, [_vm._v("242.")]), _vm._v(" Cox v. New Hampshire, 312 U.S. 569, 576–77 (1941). For thorough analyses, see Goldberger, "), _c('em', [_vm._v("supra")]), _vm._v(" note 241; Neisser, "), _c('em', [_vm._v("supra")]), _vm._v(" note 241.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_243",
      "id": "fn1-243"
    }
  }, [_vm._v("243.")]), _vm._v(" 20 U.S.C. § 4071(a) (Supp. 1985). The statutory language is “any public secondary schools.” Teitel reports that some state laws use this term to include junior high school. Teitel, "), _c('em', [_vm._v("supra")]), _vm._v(" note 56, at 573–74.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_244",
      "id": "fn1-244"
    }
  }, [_vm._v("244.")]), _vm._v(" "), _c('em', [_vm._v("But see")]), _vm._v(" Bell v. Little Axe Indep. Sch. Dist. No. 70, 766 F.2d 1391, 1402, 1413 (10th Cir. 1985) (holding that elementary school had created limited forum, but Establishment Clause barred “concerted” religious speech from forum); Mich. State Board of Educ. v. Tri-County Area Sch. Dist., 5 Religious Freedom Rep. (Christian Legal Soc’y) 47 (W.D. Mich. 1984) (substantially the same, at preliminary injunction stage).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_245",
      "id": "fn1-245"
    }
  }, [_vm._v("245.")]), _vm._v(" 393 U.S. at 504, 514.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_246",
      "id": "fn1-246"
    }
  }, [_vm._v("246.")]), _vm._v(" "), _c('em', [_vm._v("But cf.")]), _vm._v(" Bowman v. Bethel-Tate Board of Educ., 610 F. Supp. 577 (S.D. Ohio 1985) (enjoining censorship of third-grade play).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_247",
      "id": "fn1-247"
    }
  }, [_vm._v("247.")]), _vm._v(" "), _c('em', [_vm._v("Annual Report, 1983–84: Years of Struggle, Years of Triumph")]), _vm._v(", C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IV")]), _vm._v(". L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IBERTIES")]), _vm._v(", Spring 1985, at 6.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_248",
      "id": "fn1-248"
    }
  }, [_vm._v("248.")]), _vm._v(" Barry Lynn, "), _c('em', [_vm._v("Religious Speech in Secondary Schools: What Is Equal Access?,")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IV")]), _vm._v(". L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IBERTIES")]), _vm._v(", Fall 1984, at 5.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_249",
      "id": "fn1-249"
    }
  }, [_vm._v("249.")]), _vm._v(" "), _c('em', [_vm._v("ACLU Debates “Rights in Conflict,”")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IV")]), _vm._v(". L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IBERTIES")]), _vm._v(", Summer 1985, at 1, 3.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_250",
      "id": "fn1-250"
    }
  }, [_vm._v("250.")]), _vm._v(" 669 F.2d 1038 (5th Cir. 1982); "), _c('em', [_vm._v("see also")]), _vm._v(" Nartowicz v. Clayton County Sch. Dist., 736 F.2d 646 (11th Cir. 1984) (court relied on evidence that school sponsored religious activities to support preliminary injunction against on-campus meetings of Youth for Christ Club).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_251",
      "id": "fn1-251"
    }
  }, [_vm._v("251.")]), _vm._v(" Teitel, "), _c('em', [_vm._v("supra")]), _vm._v(" note 56, at 549–51.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_252",
      "id": "fn1-252"
    }
  }, [_vm._v("252.")]), _vm._v(" NLRB v. Wemyss, 212 F.2d 465 (9th Cir. 1954); "), _c('em', [_vm._v("In re")]), _vm._v(" Carpenter Steel Co., 76 N.L.R.B. 670 (1948); R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OBERT")]), _vm._v(" A. G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORMAN")]), _vm._v(", B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ASIC")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EXT")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ON")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ABOR")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AW")]), _vm._v(", U"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NIONIZATION")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OLLECTIVE")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARGAINING")]), _vm._v(" 197 (West 1976).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_253",
      "id": "fn1-253"
    }
  }, [_vm._v("253.")]), _vm._v(" Studies indicating substantial but imperfect compliance with the school prayer decisions are collected in Jesse H. Choper, "), _c('em', [_vm._v("Consequences of Supreme Court Decisions Upholding Individual Constitutional Rights")]), _vm._v(", 83 M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ICH")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1, 79 nn.525–27 (1984).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_254",
      "id": "fn1-254"
    }
  }, [_vm._v("254.")]), _vm._v(" 130 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONG")]), _vm._v(". R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EC")]), _vm._v(". S8343–44 (daily ed. June 27, 1984) (colloquy between Sen. Gorton and Sen. Hatfield); "), _c('em', [_vm._v("see")]), _vm._v(" Aaron, "), _c('em', [_vm._v("supra")]), _vm._v(" note 89, at 593–96.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_255",
      "id": "fn1-255"
    }
  }, [_vm._v("255.")]), _vm._v(" 130 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONG")]), _vm._v(". R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EC")]), _vm._v(". S8343–44 (daily ed. June 27, 1984) (statement of Sen. Hatfield).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_256",
      "id": "fn1-256"
    }
  }, [_vm._v("256.")]), _vm._v(" "), _c('em', [_vm._v("Cf")]), _vm._v(". Knights of the Ku Klux Klan v. East Baton Rouge Parish Sch. Board, 578 F.2d 1122 (5th Cir. 1978) (Ku Klux Klan had constitutional right of equal access to school gymnasium in evenings; case governed by First Amendment standards for adults).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_257",
      "id": "fn1-257"
    }
  }, [_vm._v("257.")]), _vm._v(" 395 U.S. 444, 448–49 (1969) (advocacy of violence is protected speech unless it amounts to “incitement to imminent lawless action”).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_258",
      "id": "fn1-258"
    }
  }, [_vm._v("258.")]), _vm._v(" Aaron, "), _c('em', [_vm._v("supra")]), _vm._v(" note 89, at 597–603, 608–11; Note, "), _c('em', [_vm._v("Administrative Regulation, supra")]), _vm._v(" note 89, at 636–49; Annotation, "), _c('em', [_vm._v("What Oral Statement of Student Is Sufficiently Disruptive So as to Fall Beyond Protection of First Amendment")]), _vm._v(", 76 A.L.R. F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ED")]), _vm._v(". 599 (1986); "), _c('em', [_vm._v("see, e.g.")]), _vm._v(", Bethel School Dist. No. 403 v. Fraser, 478 U.S. 675 (1986).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_259",
      "id": "fn1-259"
    }
  }, [_vm._v("259.")]), _vm._v(" The opposite view is asserted in Strossen, "), _c('em', [_vm._v("supra")]), _vm._v(" note 70, at 171.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_260",
      "id": "fn1-260"
    }
  }, [_vm._v("260.")]), _vm._v(" 130 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONG")]), _vm._v(". R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EC")]), _vm._v(". S8352, 8360 (daily ed. June 27, 1984) (statement of Sen. Hatfield).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_261",
      "id": "fn1-261"
    }
  }, [_vm._v("261.")]), _vm._v(" Widmar v. Vincent, 454 U.S. 263, 284–85 (1981) (White, J., dissenting). White thought that if all religious speech were protected by the Free Speech Clause, the Free Exercise Clause would “be emptied of any independent meaning in circumstances in which religious practice took the form of speech.” "), _c('em', [_vm._v("Id")]), _vm._v(". at 284. Losing counsel also thought this was a central defect in the Court’s opinion. Ted D. Ayres, "), _c('em', [_vm._v("Widmar v. Vincent: The Beginning of the End for the Establishment Clause")]), _vm._v(", 8 J.C. & U.L. 511, 514 (1982). The resulting overlap between free speech and free exercise is not troubling, because only the Free Exercise Clause protects the many other forms of religious exercise.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_262",
      "id": "fn1-262"
    }
  }, [_vm._v("262.")]), _vm._v(" "), _c('em', [_vm._v("Widmar")]), _vm._v(", 454 U.S. at 282, 286–89 (White, J., dissenting).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_263",
      "id": "fn1-263"
    }
  }, [_vm._v("263.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at 269–70 n.6.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_264",
      "id": "fn1-264"
    }
  }, [_vm._v("264.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_265",
      "id": "fn1-265"
    }
  }, [_vm._v("265.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_266",
      "id": "fn1-266"
    }
  }, [_vm._v("266.")]), _vm._v(" "), _c('em', [_vm._v("See generally")]), _vm._v(" Serbian E. Orthodox Diocese v. Milivojevich, 426 U.S. 696 (1976).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_267",
      "id": "fn1-267"
    }
  }, [_vm._v("267.")]), _vm._v(" See Laycock, "), _c('em', [_vm._v("supra")]), _vm._v(" note 132, at 1411–12 n.286 [in volume 2 at 281]; Douglas Laycock, "), _c('em', [_vm._v("Civil Rights and Civil Liberties")]), _vm._v(", 54 Chi.-Kent. L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 390, 430–32 (1977) [in volume 2 at 357–60].")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_268",
      "id": "fn1-268"
    }
  }, [_vm._v("268.")]), _vm._v(" "), _c('em', [_vm._v("Widmar")]), _vm._v(", 454 U.S. at 270 n.6; "), _c('em', [_vm._v("see")]), _vm._v(" Heffron v. Int’l Soc’y for Krishna Consciousness, Inc., 452 U.S. 640 (1981).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_269",
      "id": "fn1-269"
    }
  }, [_vm._v("269.")]), _vm._v(" Religious intensity as a basis for valuing Religion Clause interests is examined in Laycock, "), _c('em', [_vm._v("supra")]), _vm._v(" note 132, at 1409–11 [in volume 2 at 278–81].")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_270",
      "id": "fn1-270"
    }
  }, [_vm._v("270.")]), _vm._v(" Consider the extraordinary line-drawing difficulties caused by attempts to exclude obscene speech from First Amendment protection.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_271",
      "id": "fn1-271"
    }
  }, [_vm._v("271.")]), _vm._v(" Elliott, "), _c('em', [_vm._v("supra")]), _vm._v(" note 71, at 1, col. 1.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_272",
      "id": "fn1-272"
    }
  }, [_vm._v("272.")]), _vm._v(" 472 U.S. 38 (1985).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_273",
      "id": "fn1-273"
    }
  }, [_vm._v("273.")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LA")]), _vm._v(". C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ODE")]), _vm._v(" § 16–1–20 (Supp. 1986), "), _c('em', [_vm._v("quoted in Wallace")]), _vm._v(", 472 U.S. at 40 n.1.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_274",
      "id": "fn1-274"
    }
  }, [_vm._v("274.")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LA")]), _vm._v(". C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ODE")]), _vm._v(" § 16–1–20.1 (Supp. 1986), "), _c('em', [_vm._v("quoted in Wallace")]), _vm._v(", 472 U.S. at 40 n.2.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_275",
      "id": "fn1-275"
    }
  }, [_vm._v("275.")]), _vm._v(" "), _c('em', [_vm._v("Wallace")]), _vm._v(", 472 U.S. at 40 n.1.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_276",
      "id": "fn1-276"
    }
  }, [_vm._v("276.")]), _vm._v(" For the original formulation of this three-part test, see Lemon v. Kurtzman, 403 U.S. 602, 612–13 (1971), quoted "), _c('em', [_vm._v("supra")]), _vm._v(" note 100.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_277",
      "id": "fn1-277"
    }
  }, [_vm._v("277.")]), _vm._v(" "), _c('em', [_vm._v("Wallace")]), _vm._v(", 472 U.S. at 59.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_278",
      "id": "fn1-278"
    }
  }, [_vm._v("278.")]), _vm._v(" For an example of a neutral provision that mentions “prayer,” see "), _c('em', [_vm._v("infra")]), _vm._v(" note 292 and accompanying text (West Virginia’s constitutional amendment).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_279",
      "id": "fn1-279"
    }
  }, [_vm._v("279.")]), _vm._v(" The second definition of “meditation” listed in the O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("XFORD")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NGLISH")]), _vm._v(" D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ICTIONARY")]), _vm._v(" 298 (1970) is as follows: “spec. [specifically] in religious use: That kind of private devotional exercise which consists in the continuous application of the mind to the contemplation of some religious truth, mystery, or object of reverence, in order that the soul may increase in love of God and holiness of life.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_280",
      "id": "fn1-280"
    }
  }, [_vm._v("280.")]), _vm._v(" "), _c('em', [_vm._v("See Annual Report, supra")]), _vm._v(" note 247, at 6 (ACLU describes New Jersey law as “legislators trying to hide government-sponsored prayer behind thinly veiled words like ‘contemplation’ and ‘introspection’”).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_281",
      "id": "fn1-281"
    }
  }, [_vm._v("281.")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LA")]), _vm._v(". C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ODE")]), _vm._v(" § 16–1–20.1 (Supp. 1986).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_282",
      "id": "fn1-282"
    }
  }, [_vm._v("282.")]), _vm._v(" Nor is it clear that inserting “voluntary” overcomes the thrust of the statute with respect to prayer. I do not know what it means to direct that students “shall observe” a moment of “voluntary” prayer.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_283",
      "id": "fn1-283"
    }
  }, [_vm._v("283.")]), _vm._v(" Gaines v. Anderson, 421 F. Supp. 337 (D. Mass. 1976).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_284",
      "id": "fn1-284"
    }
  }, [_vm._v("284.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at 339, 342. Professor McConnell also finds the statutory text neutral. McConnell, "), _c('em', [_vm._v("supra")]), _vm._v(" note 104, at 46–47.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_285",
      "id": "fn1-285"
    }
  }, [_vm._v("285.")]), _vm._v(" "), _c('em', [_vm._v("Gaines")]), _vm._v(", 421 F. Supp. at 342.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_286",
      "id": "fn1-286"
    }
  }, [_vm._v("286.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" Lynch v. Donnelly, 465 U.S. 668, 690 (1984) (O’Connor, J., concurring).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_287",
      "id": "fn1-287"
    }
  }, [_vm._v("287.")]), _vm._v(" "), _c('em', [_vm._v("Cf")]), _vm._v(". Seide, "), _c('em', [_vm._v("supra")]), _vm._v(" note 9 (arguing that Establishment Clause forbids any government act perceived as support of religion, apparently without regard to whether perception is accurate, informed, or even reasonable).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_288",
      "id": "fn1-288"
    }
  }, [_vm._v("288.")]), _vm._v(" Teachers were instructed to repeat the words of the legislature, to say that they were doing this to comply with the law, and to refuse to answer questions. "), _c('em', [_vm._v("Gaines")]), _vm._v(", 421 F. Supp. at 340 n.4.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_289",
      "id": "fn1-289"
    }
  }, [_vm._v("289.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at 344 n.9.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_290",
      "id": "fn1-290"
    }
  }, [_vm._v("290.")]), _vm._v(" N.M. S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TAT")]), _vm._v(". A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NN")]), _vm._v(". § 22–5–4.1 (1978), "), _c('em', [_vm._v("quoted in")]), _vm._v(" Duffy v. Las Cruces Pub. Schs., 557 F. Supp. 1013, 1015 (D.N.M. 1983).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_291",
      "id": "fn1-291"
    }
  }, [_vm._v("291.")]), _vm._v(" N.J. S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TAT")]), _vm._v(". A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NN")]), _vm._v(". § 18A-26–4 (West 1986), "), _c('em', [_vm._v("quoted in")]), _vm._v(" May v. Cooperman, 572 F. Supp. 1561, 1562 (D.N.J. 1983), "), _c('em', [_vm._v("aff’d")]), _vm._v(", 780 F.2d 240 (3d Cir. 1985), "), _c('em', [_vm._v("juris. postponed sub nom")]), _vm._v(". Karcher v. May, 479 U.S. 1062 ["), _c('em', [_vm._v("appeal dis’d")]), _vm._v(", 484 U.S. 72 (1987)].")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_292",
      "id": "fn1-292"
    }
  }, [_vm._v("292.")]), _vm._v(" W. V"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A")]), _vm._v(". C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONST")]), _vm._v(". art. III, § 15-a, "), _c('em', [_vm._v("quoted in")]), _vm._v(" Walter v. West Va. Board of Educ., 610 F. Supp. 1169, 1170 n.1 (S.D.W. Va. 1985); "), _c('em', [_vm._v("cf")]), _vm._v(". N.C. L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AWS OF")]), _vm._v(" 1985, ch. 637 (to be codified as N.C. G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EN")]), _vm._v(". S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TAT")]), _vm._v(". 115C-4728), "), _c('em', [_vm._v("quoted in")]), _vm._v(" Valerie B. Spalding, Note, "), _c('em', [_vm._v("Constitutional Law—Moment of Silence Statute May Threaten the Wall of Separation Between Church and State—Wallace v. Jaffree")]), _vm._v(", 8 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AMPBELL")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 125, 141 (1985) (“Such period of silence shall be totally unstructured and free of guidance or influence of any kind from any sources.”).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_293",
      "id": "fn1-293"
    }
  }, [_vm._v("293.")]), _vm._v(" "), _c('em', [_vm._v("May")]), _vm._v(", 780 F.2d at 241; "), _c('em', [_vm._v("Walter")]), _vm._v(", 610 F. Supp. at 1170 n.1; Duffy v. Las Cruces Pub. Schools, 557 F. Supp. 1013, 1015 (D.N.M. 1983).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_294",
      "id": "fn1-294"
    }
  }, [_vm._v("294.")]), _vm._v(" "), _c('em', [_vm._v("Walter")]), _vm._v(", 610 F. Supp. at 1172–73. The district court in the New Jersey case also found improper implementation in some districts. "), _c('em', [_vm._v("May")]), _vm._v(", 572 F. Supp. at 1567–68. But the court of appeals did not rely on these findings, 780 F.2d at 251 & n.8, perhaps because it decided the case on grounds applicable to all districts.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_295",
      "id": "fn1-295"
    }
  }, [_vm._v("295.")]), _vm._v(" "), _c('em', [_vm._v("See supra")]), _vm._v(" notes 102–15 and accompanying text.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_296",
      "id": "fn1-296"
    }
  }, [_vm._v("296.")]), _vm._v(" "), _c('em', [_vm._v("May")]), _vm._v(", 572 F. Supp. at 1569–73; "), _c('em', [_vm._v("Duffy")]), _vm._v(", 557 F. Supp. at 1015–17. "), _c('em', [_vm._v("But see May")]), _vm._v(", 780 F.2d at 264–65 (Becker, J., dissenting) (arguing that court should accept testimony that moment of silence is a secular teaching device). Martin Nussbaum, an open defender of government support for majoritarian religion, agrees that such rationalizations are “ridiculous.” L. Martin Nussbaum, "), _c('em', [_vm._v("A Garment for the Naked Public Square: Nurturing American Public Theology")]), _vm._v(", 16 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UMB")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 53, 61–62 (1985).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_297",
      "id": "fn1-297"
    }
  }, [_vm._v("297.")]), _vm._v(" "), _c('em', [_vm._v("May")]), _vm._v(", 780 F.2d at 243–46, 251.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_298",
      "id": "fn1-298"
    }
  }, [_vm._v("298.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at 247–50.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_299",
      "id": "fn1-299"
    }
  }, [_vm._v("299.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at 251.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_300",
      "id": "fn1-300"
    }
  }, [_vm._v("300.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at 247.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_301",
      "id": "fn1-301"
    }
  }, [_vm._v("301.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at 252; "), _c('em', [_vm._v("see id")]), _vm._v(". at 261 (Becker, J., dissenting) (identifying number of legislators). Similar reasoning appears in Note, "), _c('em', [_vm._v("State Statutes, supra")]), _vm._v(" note 28, at 1879–86.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_302",
      "id": "fn1-302"
    }
  }, [_vm._v("302.")]), _vm._v(" "), _c('em', [_vm._v("See supra")]), _vm._v(" notes 108–13 and accompanying text.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_303",
      "id": "fn1-303"
    }
  }, [_vm._v("303.")]), _vm._v(" "), _c('em', [_vm._v("See supra")]), _vm._v(" notes 102–07 and accompanying text.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_304",
      "id": "fn1-304"
    }
  }, [_vm._v("304.")]), _vm._v(" "), _c('em', [_vm._v("Cf")]), _vm._v(". Wallace v. Jaffree, 472 U.S. 38, 57 n.45 (1985) (no “governmental practice” prevented individual students from praying silently); "), _c('em', [_vm._v("id")]), _vm._v(". at 83 (O’Connor, J., concurring) (no “law” prevented individual students from praying silently).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_305",
      "id": "fn1-305"
    }
  }, [_vm._v("305.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" McConnell, "), _c('em', [_vm._v("supra")]), _vm._v(" note 104, at 46.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_306",
      "id": "fn1-306"
    }
  }, [_vm._v("306.")]), _vm._v(" The Court incorrectly relied on such statements as evidence of impermissible intent in "), _c('em', [_vm._v("Wallace")]), _vm._v(", 472 U.S. at 56–57.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_307",
      "id": "fn1-307"
    }
  }, [_vm._v("307.")]), _vm._v(" For a plea for accommodation that uses the word carefully and tries to develop manageable standards, see McConnell, "), _c('em', [_vm._v("supra")]), _vm._v(" note 104. McConnell and I agree substantially but not totally on the meaning of “accommodation.” In general, I insist on more vigilance against incidental encouragement in the course of accommodation. "), _c('em', [_vm._v("See also")]), _vm._v(" Norman Dorsen & Charles Sims, "), _c('em', [_vm._v("The Nativity Scene Case: An Error of Judgment")]), _vm._v(", 1985 U. I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LL")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 837, 862–63.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_308",
      "id": "fn1-308"
    }
  }, [_vm._v("308.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" May v. Cooperman, 572 F. Supp. 1561, 1566 (D.N.J. 1983), "), _c('em', [_vm._v("aff’d on other grounds")]), _vm._v(", 780 F.2d 240 (3d Cir. 1985), "), _c('em', [_vm._v("juris. postponed sub nom")]), _vm._v(". Karcher v. May, 479 U.S. 1062 ["), _c('em', [_vm._v("appeal dis’d")]), _vm._v(", 484 U.S. 72 (1987)]; Spalding, "), _c('em', [_vm._v("supra")]), _vm._v(" note 292, at 142 n.141.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_309",
      "id": "fn1-309"
    }
  }, [_vm._v("309.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" Walter v. West Va. Board of Educ., 610 F. Supp. 1169, 1173 (S.D.W. Va. 1985); "), _c('em', [_vm._v("May")]), _vm._v(", 572 F. Supp. at 1567; Gaines v. Anderson, 421 F. Supp. 337, 340 n.4 (D. Mass. 1976). "), _c('em', [_vm._v("May")]), _vm._v(" reports implementation practices in several schools.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_310",
      "id": "fn1-310"
    }
  }, [_vm._v("310.")]), _vm._v(" "), _c('em', [_vm._v("May")]), _vm._v(", 572 F. Supp. at 1567–68.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_311",
      "id": "fn1-311"
    }
  }, [_vm._v("311.")]), _vm._v(" "), _c('em', [_vm._v("Walter")]), _vm._v(", 610 F. Supp. at 1172–73.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_312",
      "id": "fn1-312"
    }
  }, [_vm._v("312.")]), _vm._v(" "), _c('em', [_vm._v("May")]), _vm._v(", 572 F. Supp. at 1568.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_313",
      "id": "fn1-313"
    }
  }, [_vm._v("313.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at 1567.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_314",
      "id": "fn1-314"
    }
  }, [_vm._v("314.")]), _vm._v(" "), _c('em', [_vm._v("Walter")]), _vm._v(", 610 F. Supp. at 1173; "), _c('em', [_vm._v("May")]), _vm._v(", 572 F. Supp. at 1569, 1574–75; "), _c('em', [_vm._v("Gaines")]), _vm._v(", 421 F. Supp. at 345.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cdba590","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/010_Chapter01a.vue
// module id = 84
// module chunks = 0